/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Currency: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export enum Action {
  ConfirmSelection = "ConfirmSelection",
  ConfirmViaPartialConfirm = "ConfirmViaPartialConfirm",
  DeclineOptInViaCatalog = "DeclineOptInViaCatalog",
  DeclineOptInViaConfirmDecline = "DeclineOptInViaConfirmDecline",
  DeclineOptInViaSigningService = "DeclineOptInViaSigningService",
  DeclineOptInViaSurvey = "DeclineOptInViaSurvey",
  EditSelectionsViaPartialConfirm = "EditSelectionsViaPartialConfirm",
  GetStarted = "GetStarted",
  GoBackViaCardOneLearnMore = "GoBackViaCardOneLearnMore",
  GoBackViaCardTwoLearnMore = "GoBackViaCardTwoLearnMore",
  GoBackViaConfirmDecline = "GoBackViaConfirmDecline",
  GoBackViaDeclineResponse = "GoBackViaDeclineResponse",
  GoBackViaFaq = "GoBackViaFaq",
  GoBackViaPartialConfirm = "GoBackViaPartialConfirm",
  GoBackViaSurveyDecline = "GoBackViaSurveyDecline",
  GoToCatalogViaFaq = "GoToCatalogViaFaq",
  GoToFaqViaCardOneLearnMore = "GoToFaqViaCardOneLearnMore",
  GoToFaqViaCardTwoLearnMore = "GoToFaqViaCardTwoLearnMore",
  GoToFaqViaConfirmDecline = "GoToFaqViaConfirmDecline",
  GoToFaqViaNavBar = "GoToFaqViaNavBar",
  GoToSongtradrViaDeclineResponse = "GoToSongtradrViaDeclineResponse",
  GoToSongtradrViaSigned = "GoToSongtradrViaSigned",
  OpenLearnMoreViaCardOne = "OpenLearnMoreViaCardOne",
  OpenLearnMoreViaCardTwo = "OpenLearnMoreViaCardTwo",
  SelectCardTwo = "SelectCardTwo",
  SelectClaimOnMonetizationSelect = "SelectClaimOnMonetizationSelect",
  SelectDoNotClaimOnMonetizationSelect = "SelectDoNotClaimOnMonetizationSelect",
  SendSignedMsaProfileToMusicBus = "SendSignedMsaProfileToMusicBus",
  SendSignedMsaProfileToMusicBusFailure = "SendSignedMsaProfileToMusicBusFailure",
  SendSongs = "SendSongs",
  SendSongsFailure = "SendSongsFailure",
  SignForm = "SignForm",
  UnselectCardTwo = "UnselectCardTwo",
  UpdatedPersonalData = "UpdatedPersonalData",
  ViewSignedDocumentViaSigned = "ViewSignedDocumentViaSigned",
}

export type AddClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export type Artist = {
  __typename?: "Artist";
  artworkGuid?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  stats?: Maybe<ArtistStats>;
  trackIds?: Maybe<Array<Scalars["String"]["output"]>>;
  tracks?: Maybe<Array<Track>>;
};

export type ArtistImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type ArtistTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtistQueries = {
  __typename?: "ArtistQueries";
  /** Get an artist by id */
  byId?: Maybe<Artist>;
  /** Shared artist queries */
  shared?: Maybe<SharedArtistQueries>;
};

export type ArtistQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type ArtistStats = {
  __typename?: "ArtistStats";
  albumsCount: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  mostCommonGenre?: Maybe<Scalars["String"]["output"]>;
  segmentTracksCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type ArtistsQueries = {
  __typename?: "ArtistsQueries";
  /** Get recently played artists derived from recently played tracks */
  recent?: Maybe<Array<Artist>>;
};

export type ArtistsQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AudioUrls = {
  __typename?: "AudioUrls";
  high: Scalars["String"]["output"];
  low: Scalars["String"]["output"];
  normal: Scalars["String"]["output"];
  veryHigh: Scalars["String"]["output"];
};

export type BriefAnalysis = {
  __typename?: "BriefAnalysis";
  /** Brief analysis */
  description: Scalars["String"]["output"];
  /** Filter */
  filter?: Maybe<Array<SearchFilterOutput>>;
};

export type BulkDownload = {
  __typename?: "BulkDownload";
  /** Download link for the archive, present once the job is completed */
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  /** Bulk-download job ID */
  id: Scalars["ID"]["output"];
  /** Current processing status */
  status: BulkDownloadStatus;
};

export enum BulkDownloadReferenceFormat {
  Mp3 = "mp3",
  Wav = "wav",
}

export enum BulkDownloadReferenceType {
  Playlist = "playlist",
  Track = "track",
}

export enum BulkDownloadStatus {
  Completed = "completed",
  Error = "error",
  Processing = "processing",
}

export type Channel = {
  __typename?: "Channel";
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  channelTitle?: Maybe<Scalars["String"]["output"]>;
  /** Collections this channel belongs to */
  collections?: Maybe<Array<Collection>>;
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who connected the channel */
  createUser?: Maybe<SsoUser>;
  handle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  /** Whether the channel was imported from old Studio, so has no createUser */
  imported?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  platform: ChannelPlatform;
  url?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelLookupError = {
  __typename?: "ChannelLookupError";
  url: Scalars["String"]["output"];
};

export type ChannelLookupInput = {
  name: Scalars["String"]["input"];
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

export enum ChannelPlatform {
  Facebook = "facebook",
  Instagram = "instagram",
  Other = "other",
  Tiktok = "tiktok",
  X = "x",
  Youtube = "youtube",
}

export enum ChannelSortKey {
  Handle = "handle",
  Name = "name",
  Platform = "platform",
  RecentlyAdded = "recentlyAdded",
}

export type ChannelsPage = {
  __typename?: "ChannelsPage";
  items: Array<Channel>;
  total: Scalars["Int"]["output"];
};

export type ChannelsQueries = {
  __typename?: "ChannelsQueries";
  /** Get single channel by id */
  byId?: Maybe<Channel>;
  /** Get the org's connected channels by id, in the order the ids were given */
  byIds?: Maybe<Array<Channel>>;
  /** Get the org's connected channels */
  connected?: Maybe<ChannelsPage>;
  /** Get the org's deactivated channels */
  deactivated?: Maybe<ChannelsPage>;
  /** Get user-entered channels prepared for connection (resolve metadata and flag duplicates) */
  prepared?: Maybe<Array<PreparedChannelResult>>;
};

export type ChannelsQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type ChannelsQueriesByIdsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type ChannelsQueriesConnectedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type ChannelsQueriesDeactivatedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type ChannelsQueriesPreparedArgs = {
  input: Array<ChannelLookupInput>;
};

export type ChannelsSort = {
  direction: SortDirection;
  key?: InputMaybe<ChannelSortKey>;
};

export type Clearance = {
  __typename?: "Clearance";
  /** Client ID */
  clientId: Scalars["ID"]["output"];
  /** Client name */
  clientName?: Maybe<Scalars["String"]["output"]>;
  /** Clearance end date */
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Clearance ID */
  id: Scalars["ID"]["output"];
  /** Clearance media (channel/video) */
  media: ClearanceMedia;
  /** Clearance Notes */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Clearance start date */
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Clearance status */
  status: ClearanceStatus;
};

export type ClearanceCreateInput = {
  /** Client ID */
  clientId: Scalars["ID"]["input"];
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance media (channel/video) */
  media: ClearanceMediaCreateInput;
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance status */
  status: ClearanceStatus;
};

export type ClearanceMedia = {
  __typename?: "ClearanceMedia";
  /** Media ID (channel/video id) */
  id: Scalars["String"]["output"];
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type: ClearanceMediaType;
  /** Media url */
  url: Scalars["String"]["output"];
};

export type ClearanceMediaCreateInput = {
  /** Media ID (channel/video id) */
  id: Scalars["String"]["input"];
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type: ClearanceMediaType;
  /** Media url */
  url: Scalars["String"]["input"];
};

export enum ClearanceMediaPlatform {
  /** `Meta` */
  Meta = "Meta",
  /** `TikTok` */
  TikTok = "TikTok",
  /** `YouTube` */
  YouTube = "YouTube",
}

export enum ClearanceMediaType {
  Channel = "Channel",
  Video = "Video",
}

export type ClearanceMediaUpdateInput = {
  /** Media ID (channel/video id) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type?: InputMaybe<ClearanceMediaType>;
  /** Media url */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClearancePage = {
  __typename?: "ClearancePage";
  /** List of clearances */
  items: Array<Clearance>;
  /** Total number of clearances */
  total: Scalars["Int"]["output"];
};

export type ClearanceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort Key */
  key?: InputMaybe<ClearanceSortKey>;
};

export enum ClearanceSortKey {
  EndDate = "endDate",
  StartDate = "startDate",
  Status = "status",
}

export type ClearanceSource = {
  __typename?: "ClearanceSource";
  /** Clearance source ID */
  id: Scalars["String"]["output"];
  /** Clearance source type ex. Fawkes */
  type: Scalars["String"]["output"];
};

export enum ClearanceStatus {
  Active = "Active",
  Expired = "Expired",
  Expiring = "Expiring",
  Pending = "Pending",
}

export type ClearanceUpdateInput = {
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance ID */
  id: Scalars["ID"]["input"];
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Client = {
  __typename?: "Client";
  /** Client clearances */
  clearances?: Maybe<Array<Maybe<Clearance>>>;
  /** Client contact */
  contact: Scalars["String"]["output"];
  /** Client email */
  email: Scalars["String"]["output"];
  /** Client ID */
  id: Scalars["ID"]["output"];
  /** Client name */
  name: Scalars["String"]["output"];
};

export type ClientPage = {
  __typename?: "ClientPage";
  /** List of clients */
  items: Array<Client>;
  /** Total number of clients */
  total: Scalars["Int"]["output"];
};

export type ClientSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ClientSortKey>;
};

export enum ClientSortKey {
  Contact = "contact",
  Email = "email",
  Name = "name",
}

export type ClientSource = {
  __typename?: "ClientSource";
  /** Client source ID */
  id: Scalars["String"]["output"];
  /** Client source type ex. Fawkes */
  type: Scalars["String"]["output"];
};

export type Collection = {
  __typename?: "Collection";
  channelIds: Array<Scalars["String"]["output"]>;
  /** Channels belonging to this collection */
  channels: ChannelsPage;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  numberOfChannels: Scalars["Int"]["output"];
};

export type CollectionChannelsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type CollectionsPage = {
  __typename?: "CollectionsPage";
  items: Array<Collection>;
  total: Scalars["Int"]["output"];
};

export type CollectionsQueries = {
  __typename?: "CollectionsQueries";
  /** Get the org's collections */
  all?: Maybe<CollectionsPage>;
  /** Get a single collection by id */
  byId?: Maybe<Collection>;
  /** Get one or more collections by id, e.g. to export their channels */
  byIds?: Maybe<Array<Collection>>;
};

export type CollectionsQueriesAllArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollectionsQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type CollectionsQueriesByIdsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type CommercialLicense = {
  __typename?: "CommercialLicense";
  /** Brand - brand */
  brand: Scalars["String"]["output"];
  /** Campaign name - dealname */
  campaignName: Scalars["String"]["output"];
  /** Close date - closedate */
  closeDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Contacts - UNKNOWN */
  contacts?: Maybe<CommercialLicenseContacts>;
  /** Documents - p_documents_collection__deal_to_documents */
  documents?: Maybe<Array<CommercialLicenseDocument>>;
  /** Commercial license ID - hs_object_id */
  id: Scalars["ID"]["output"];
  /** Services - p_services_collection__deal_to_services */
  services?: Maybe<Array<CommercialLicenseService>>;
  /** Status - dealstage */
  status: CommercialLicenseStatus;
  /** Terms - p_license_terms_collection__deal_to_license_terms */
  terms?: Maybe<Array<CommercialLicenseTerm>>;
  /** Tracks - line_item_collection__primary */
  tracks?: Maybe<Array<CommercialLicenseTrack>>;
};

export type CommercialLicenseContact = {
  __typename?: "CommercialLicenseContact";
  /** Email - email */
  email: Scalars["String"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
};

export type CommercialLicenseContacts = {
  __typename?: "CommercialLicenseContacts";
  additionalContacts?: Maybe<Array<CommercialLicenseContact>>;
  projectLeads?: Maybe<Array<CommercialLicenseContact>>;
};

export type CommercialLicenseDocument = {
  __typename?: "CommercialLicenseDocument";
  /** ID - id */
  id: Scalars["ID"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
  /** Type - type */
  type: Scalars["String"]["output"];
  /** Upload date - upload_date */
  uploadDate: Scalars["DateTime"]["output"];
  /** URL - url */
  url: Scalars["String"]["output"];
};

export type CommercialLicensePage = {
  __typename?: "CommercialLicensePage";
  /** List of commercial licenses */
  items: Array<CommercialLicense>;
  /** Total number of commercial licenses */
  total: Scalars["Int"]["output"];
};

export type CommercialLicenseScript = {
  __typename?: "CommercialLicenseScript";
  /** Details - details */
  details: Scalars["Int"]["output"];
  /** Duration - duration */
  duration: Scalars["String"]["output"];
};

export type CommercialLicenseService = {
  __typename?: "CommercialLicenseService";
  /** Cost - cost */
  cost: Scalars["Float"]["output"];
  /** Currency code - currency_code */
  currencyCode: Scalars["String"]["output"];
  /** ID - id */
  id: Scalars["ID"]["output"];
  /** Music type - music_type */
  musicType: Scalars["String"]["output"];
  /** Service type - service_type */
  serviceType: Scalars["String"]["output"];
};

export type CommercialLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<CommercialLicenseSortKey>;
};

export enum CommercialLicenseSortKey {
  Brand = "brand",
}

export enum CommercialLicenseStatus {
  Active = "ACTIVE",
  Expired = "EXPIRED",
  InPerpetuity = "IN_PERPETUITY",
  SoonToExpire = "SOON_TO_EXPIRE",
  Undefined = "UNDEFINED",
}

export type CommercialLicenseTerm = {
  __typename?: "CommercialLicenseTerm";
  /** Duration - duration */
  duration: Scalars["String"]["output"];
  /** End date - end_date */
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Final tracks - final_tracks */
  finalTracks: Array<Scalars["String"]["output"]>;
  /** Media type - media_type */
  mediaType: Scalars["String"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
  /** Scripts - scripts */
  scripts: CommercialLicenseScript;
  /** Start date - start_date */
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  status: CommercialLicenseStatus;
  /** Territories - territories */
  territories: CommercialLicenseTerritories;
  /** Time remaining - start_date/end_date */
  timeRemaining: Scalars["String"]["output"];
  /** Time remaining percentage - start_date/end_date */
  timeRemainingPercentage: Scalars["Int"]["output"];
};

export type CommercialLicenseTerritories = {
  __typename?: "CommercialLicenseTerritories";
  excluded: Array<Scalars["String"]["output"]>;
  included: Array<Scalars["String"]["output"]>;
};

export type CommercialLicenseTrack = {
  __typename?: "CommercialLicenseTrack";
  /** Artist - artist */
  artist: Scalars["String"]["output"];
  /** Attachments - attachments */
  attachments?: Maybe<Array<CommercialLicenseTrackAttachment>>;
  /** Name - name */
  name: Scalars["String"]["output"];
};

export type CommercialLicenseTrackAttachment = {
  __typename?: "CommercialLicenseTrackAttachment";
  /** Name - name */
  name: Scalars["String"]["output"];
  /** URL - url */
  url: Scalars["String"]["output"];
};

export type ConnectChannelInput = {
  channelId: Scalars["String"]["input"];
  channelImage?: InputMaybe<Scalars["String"]["input"]>;
  channelName: Scalars["String"]["input"];
  channelTitle?: InputMaybe<Scalars["String"]["input"]>;
  handle?: InputMaybe<Scalars["String"]["input"]>;
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

/** Creates a draft document. All other fields are populated server-side with sensible defaults (empty content, effective today, no re-agreement, no scroll-to-accept) — the user fills them in on the edit screen. */
export type CreateLegalDocumentInput = {
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateOrgInput = {
  metadata: CreateOrgMetadataInput;
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrgMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
};

export type CreateShareTokenInput = {
  resourceId: Scalars["ID"]["input"];
  resourceType: ShareResourceType;
};

export type CuratedPlaylistCategory = {
  __typename?: "CuratedPlaylistCategory";
  playlistIds: Array<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type CuratedPlaylistQueries = {
  __typename?: "CuratedPlaylistQueries";
  /** List of current user's curated playlists */
  all: Array<Playlist>;
  /** Get a list of curated playlists by category */
  byCategorySlug?: Maybe<PlaylistList>;
  /** List of unique categories in the user's curated playlists */
  categories?: Maybe<Array<CuratedPlaylistCategory>>;
  /** Total count of curated playlists available to the user */
  total: Scalars["Int"]["output"];
};

export type CuratedPlaylistQueriesByCategorySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type Curator = {
  __typename?: "Curator";
  id: Scalars["ID"]["output"];
  imageUrl: Scalars["String"]["output"];
  initials: Scalars["String"]["output"];
  stats: Scalars["String"]["output"];
};

export type CurrentUser = {
  __typename?: "CurrentUser";
  /** User email */
  email: Scalars["String"]["output"];
  /** User first name */
  firstName: Scalars["String"]["output"];
  /** User ID */
  id: Scalars["ID"]["output"];
  /** User orgs */
  inOrgs: Array<UserOrg>;
  /** Impersonation Info */
  isImInfo?: Maybe<IsImInfo>;
  /** Lab App Access */
  labApps?: Maybe<Array<Scalars["String"]["output"]>>;
  /** User last name */
  lastName: Scalars["String"]["output"];
  /** User org ID */
  orgId: Scalars["ID"]["output"];
  /** User permissions (hashed) */
  permissions: Array<Scalars["String"]["output"]>;
  /** User picture */
  picture?: Maybe<Scalars["String"]["output"]>;
  /** The org's subscription, or the plans it can subscribe to, if any billing system reports either */
  subscription?: Maybe<UserSubscription>;
};

export type DeclareTrackChannelInput = {
  /** Channel-specific identifier (e.g. handle or page id) */
  id: Scalars["String"]["input"];
  /** Channel the track is used on */
  type: ChannelPlatform;
  /** Link to the published usage on the channel */
  usageLinks: Array<Scalars["String"]["input"]>;
};

export type DeclareTracksInput = {
  /** Brand or campaign name */
  businessBrand: Scalars["String"]["input"];
  /** Channels the track is used on */
  channels: Array<DeclareTrackChannelInput>;
  /** Date the usage goes live */
  goLiveDate: Scalars["DateTime"]["input"];
  /** Project description */
  projectDescription: Scalars["String"]["input"];
  /** Project or product name */
  projectName: Scalars["String"]["input"];
  /** Regions the track is used in */
  regions: Array<Scalars["String"]["input"]>;
  /** Ids of the tracks being declared */
  trackIds: Array<Scalars["ID"]["input"]>;
};

export enum DefaultViewInDraftMode {
  Development = "DEVELOPMENT",
  Published = "PUBLISHED",
}

export type DistributionQueries = {
  __typename?: "DistributionQueries";
  /** Get The Source portal sign-in URL for the current user */
  signinLink?: Maybe<DistributionSigninLinkResult>;
};

export type DistributionSigninLinkResult = {
  __typename?: "DistributionSigninLinkResult";
  url: Scalars["String"]["output"];
};

export enum DownloadType {
  DownloadMp3 = "download_mp3",
  DownloadWav = "download_wav",
}

export enum DownloadsScope {
  Team = "team",
  User = "user",
}

export type FileValidationResult = {
  __typename?: "FileValidationResult";
  error?: Maybe<Scalars["String"]["output"]>;
  exists: Scalars["Boolean"]["output"];
  filename: Scalars["String"]["output"];
};

export type GeminiModel = {
  __typename?: "GeminiModel";
  /** Human-friendly model name */
  displayName?: Maybe<Scalars["String"]["output"]>;
  /** Model identifier passed to the Gemini API (e.g. gemini-2.0-flash) */
  name: Scalars["String"]["output"];
};

/**
 * Batch lifecycle. Pending is the single working state — what can be done
 * next (generate, pay) is derived from the rows' statuses, not the batch.
 */
export enum ImportBatchStatus {
  Cancelled = "Cancelled",
  Failed = "Failed",
  Generating = "Generating",
  Parsing = "Parsing",
  Pending = "Pending",
}

export enum ImportDataStatus {
  /** Credited to the org's balance, not yet in a payout batch */
  InBalance = "InBalance",
  Matched = "Matched",
  Paid = "Paid",
  PaymentFailed = "PaymentFailed",
  /** In a payout batch Trolley hasn't paid yet */
  PaymentPending = "PaymentPending",
  /** Paid, then returned by Trolley; the amount is back in the balance */
  Returned = "Returned",
  StatementCreated = "StatementCreated",
  Unmatched = "Unmatched",
}

export enum ImportFormat {
  Distribution = "Distribution",
}

export type IngestionJob = {
  __typename?: "IngestionJob";
  catalogUploadId: Scalars["Int"]["output"];
  changeUser?: Maybe<SsoUser>;
  createUser?: Maybe<SsoUser>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  csvOriginalFilename?: Maybe<Scalars["String"]["output"]>;
  dromoImportId?: Maybe<Scalars["String"]["output"]>;
  dromoImportIdentifier: Scalars["String"]["output"];
  dromoSessionId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  jobName: Scalars["String"]["output"];
  licensorDpid: Scalars["String"]["output"];
  mappingSnapshot?: Maybe<Scalars["JSON"]["output"]>;
  mediaFiles: Array<SavedMediaFile>;
  metadataRowCount?: Maybe<Scalars["Int"]["output"]>;
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  status: IngestionJobStatus;
  updatedAt: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type IngestionJobResult = {
  __typename?: "IngestionJobResult";
  id: Scalars["Int"]["output"];
};

export enum IngestionJobStatus {
  AudioUpload = "audio_upload",
  Cancelled = "cancelled",
  CsvMapping = "csv_mapping",
  Done = "done",
  ReadyToIngest = "ready_to_ingest",
  Review = "review",
}

export type IngestionJobsResult = {
  __typename?: "IngestionJobsResult";
  items: Array<IngestionJob>;
  total: Scalars["Int"]["output"];
};

export type IngestionSettingsResult = {
  __typename?: "IngestionSettingsResult";
  dpid: Scalars["String"]["output"];
};

export type IsImInfo = {
  __typename?: "IsImInfo";
  body: Scalars["String"]["output"];
  confirmLabel: Scalars["String"]["output"];
  disclaimer: Scalars["String"]["output"];
  isIm: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type LabApp = {
  __typename?: "LabApp";
  /** App Access */
  access: Array<LabAppAccess>;
  /** Allow Fullscreen Mode in App UI */
  allowFullscreen: Scalars["Boolean"]["output"];
  /** Api Key */
  apiKey: Scalars["String"]["output"];
  /** Bridge Key */
  bridgeKey: Scalars["String"]["output"];
  /** Category ID */
  categoryId?: Maybe<Scalars["String"]["output"]>;
  /** Datastore Tables */
  datastoreTables: Array<LabDatastoreTable>;
  /** Default View in Draft Mode */
  defaultViewInDraftMode?: Maybe<DefaultViewInDraftMode>;
  /** App description */
  description: Scalars["String"]["output"];
  /** Display Order in Apps Overview */
  displayOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Environment this app was loaded in */
  env: LabAppEnvironment;
  /** Hide Bottom Bar in App UI */
  hideBottomBar: Scalars["Boolean"]["output"];
  /** App Hosting URL */
  hostingUrl: Scalars["String"]["output"];
  /** App Icon */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** App ID */
  id: Scalars["String"]["output"];
  /** Is Favorited by Current User */
  isFavorited: Scalars["Boolean"]["output"];
  /** App label/name */
  label: Scalars["String"]["output"];
  /** Lab Version */
  labsVersion: LabsVersion;
  /** Last Updated On */
  lastUpdatedOn: Scalars["DateTime"]["output"];
  /** Latest published version of the @songtradr/massivemusic-labs package */
  latestLabsPackageVersion?: Maybe<Scalars["String"]["output"]>;
  /** Legal documents the user must agree to before using the app */
  legalDocuments: Array<LabAppLegalDocument>;
  /** Linked App ID (points to dev app from prod, or prod app from dev) */
  linkedAppId?: Maybe<Scalars["String"]["output"]>;
  /** App Local Development URL */
  localDevelopmentUrl?: Maybe<Scalars["String"]["output"]>;
  /** Modules */
  modules: LabAppModules;
  /** App Parameters */
  parameters: Array<LabAppParameter>;
  /** App Parameters Encoded */
  parametersEncoded?: Maybe<Array<LabAppParameter>>;
  /** Rate Limits */
  rateLimits?: Maybe<RateLimits>;
  /** App Repository Link */
  repositoryLink?: Maybe<Scalars["String"]["output"]>;
  /** Roles assigned to users / orgs for this app */
  roles: Array<LabAppRole>;
  /** App Secrets */
  secrets: Array<LabAppParameter>;
  /** Status */
  status: LabAppStatus;
};

export type LabAppAccess = {
  __typename?: "LabAppAccess";
  /** Access Label */
  label: Scalars["String"]["output"];
  /** Access Value */
  value: Scalars["String"]["output"];
};

export type LabAppAccessInput = {
  /** Access Label */
  label: Scalars["String"]["input"];
  /** Access Value */
  value: Scalars["String"]["input"];
};

export type LabAppDeleteResponse = {
  __typename?: "LabAppDeleteResponse";
  /** Deleted App ID */
  id: Scalars["String"]["output"];
};

export type LabAppDevDifference = {
  __typename?: "LabAppDevDifference";
  /** Development value */
  devValue?: Maybe<Scalars["String"]["output"]>;
  /** Field name */
  field: Scalars["String"]["output"];
  /** Production value */
  prodValue?: Maybe<Scalars["String"]["output"]>;
  /** Detailed record-level changes for datastore tables */
  records?: Maybe<Array<LabAppDevDifferenceRecord>>;
};

export type LabAppDevDifferenceRecord = {
  __typename?: "LabAppDevDifferenceRecord";
  /** Change type: added, modified, deleted */
  changeType: Scalars["String"]["output"];
  /** Development data (JSON) */
  devData?: Maybe<Scalars["String"]["output"]>;
  /** Record ID */
  id: Scalars["String"]["output"];
  /** Production data (JSON) */
  prodData?: Maybe<Scalars["String"]["output"]>;
};

export enum LabAppEnvironment {
  Development = "DEVELOPMENT",
  Production = "PRODUCTION",
}

export type LabAppInput = {
  /** App Access */
  access: Array<LabAppAccessInput>;
  /** Allow Fullscreen Mode in App UI */
  allowFullscreen?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  /** Datastore Tables */
  datastoreTables?: InputMaybe<Array<LabDatastoreTableInput>>;
  /** Default View in Draft Mode */
  defaultViewInDraftMode?: InputMaybe<DefaultViewInDraftMode>;
  /** App description */
  description: Scalars["String"]["input"];
  /** Display Order in Apps Overview */
  displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
  /** Hide Bottom Bar in App UI */
  hideBottomBar?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** App Hosting URL */
  hostingUrl: Scalars["String"]["input"];
  /** App Icon */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  /** App ID */
  id: Scalars["String"]["input"];
  /** App label */
  label: Scalars["String"]["input"];
  /** Labs Version */
  labsVersion: LabsVersion;
  /** Legal documents the user must agree to */
  legalDocuments?: InputMaybe<Array<LabAppLegalDocumentInput>>;
  /** App Local Development URL */
  localDevelopmentUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Modules */
  modules: LabAppModulesInput;
  /** App Parameters */
  parameters: Array<LabAppParameterInput>;
  /** Rate Limits */
  rateLimits?: InputMaybe<RateLimitsInput>;
  /** App Repository Link */
  repositoryLink?: InputMaybe<Scalars["String"]["input"]>;
  /** Roles assigned to users / orgs (full replace when provided) */
  roles?: InputMaybe<Array<LabAppRoleInput>>;
  /** App Secrets */
  secrets: Array<LabAppParameterInput>;
  /** Status */
  status: LabAppStatus;
};

export type LabAppLegalDocument = {
  __typename?: "LabAppLegalDocument";
  /** Key of a legal document the user must agree to */
  key: Scalars["String"]["output"];
};

export type LabAppLegalDocumentInput = {
  /** Key of a legal document the user must agree to */
  key: Scalars["String"]["input"];
};

export type LabAppModules = {
  __typename?: "LabAppModules";
  /** Datastore Module Enabled */
  dataStore: Scalars["Boolean"]["output"];
  /** Gemini Module Enabled */
  gemini: Scalars["Boolean"]["output"];
  /** Gemini model the app should use (falls back to the service default when unset) */
  geminiModel?: Maybe<Scalars["String"]["output"]>;
  /** Heap analytics tracking module enabled for this Lab app (the host additionally gates the effective value by the org's analytics settings) */
  heapTracking?: Maybe<Scalars["Boolean"]["output"]>;
  /** Music Search Module Enabled */
  musicSearch: Scalars["Boolean"]["output"];
};

export type LabAppModulesInput = {
  /** Datastore Module Enabled */
  dataStore: Scalars["Boolean"]["input"];
  /** Gemini Module Enabled */
  gemini: Scalars["Boolean"]["input"];
  /** Gemini model the app should use (falls back to the service default when unset) */
  geminiModel?: InputMaybe<Scalars["String"]["input"]>;
  /** Heap analytics tracking module enabled for this Lab app (the host additionally gates the effective value by the org's analytics settings) */
  heapTracking?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Music Search Module Enabled */
  musicSearch: Scalars["Boolean"]["input"];
};

export type LabAppParameter = {
  __typename?: "LabAppParameter";
  /** Parameter Key */
  key: Scalars["String"]["output"];
  /** Parameter Value */
  value: Scalars["String"]["output"];
};

export type LabAppParameterInput = {
  /** Parameter Key */
  key: Scalars["String"]["input"];
  /** Parameter Value */
  value: Scalars["String"]["input"];
};

export type LabAppRole = {
  __typename?: "LabAppRole";
  /** Members assigned to this role */
  members: Array<LabAppRoleMember>;
  /** Role identifier (lowercase letters and hyphens only) */
  roleId: Scalars["String"]["output"];
};

export type LabAppRoleInput = {
  /** Members assigned to this role */
  members: Array<LabAppRoleMemberInput>;
  /** Role identifier (lowercase letters and hyphens only) */
  roleId: Scalars["String"]["input"];
};

export type LabAppRoleMember = {
  __typename?: "LabAppRoleMember";
  /** Display label resolved from member identifier */
  label: Scalars["String"]["output"];
  /** Member identifier prefixed with USER: or ORG: */
  value: Scalars["String"]["output"];
};

export type LabAppRoleMemberInput = {
  /** Display label resolved from member identifier */
  label: Scalars["String"]["input"];
  /** Member identifier prefixed with USER: or ORG: */
  value: Scalars["String"]["input"];
};

export enum LabAppStatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type LabCategory = {
  __typename?: "LabCategory";
  /** Category ID */
  id: Scalars["String"]["output"];
  /** Category Name */
  name: Scalars["String"]["output"];
  /** URL-safe slug derived from name */
  slug: Scalars["String"]["output"];
  /** Sort Order */
  sortOrder: Scalars["Int"]["output"];
};

export type LabCategoryInput = {
  /** Category ID (optional for new categories) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Category Name */
  name: Scalars["String"]["input"];
  /** Sort Order */
  sortOrder: Scalars["Int"]["input"];
};

export type LabDatastoreAdminCreateInput = {
  /** Data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Scope of the record */
  scope: LabDatastoreScope;
  /** Table name */
  tableName: Scalars["String"]["input"];
  /** User ID (required for user-scoped records) */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabDatastoreAdminDeleteInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record IDs */
  ids: Array<Scalars["String"]["input"]>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminQueryInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Maximum results */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminRecord = {
  __typename?: "LabDatastoreAdminRecord";
  /** The stored data as JSON */
  data: Scalars["JSON"]["output"];
  /** Record ID */
  id: Scalars["String"]["output"];
  /** Scope of the record */
  scope: LabDatastoreScope;
  /** User ID (for user-scoped records) */
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type LabDatastoreAdminResponse = {
  __typename?: "LabDatastoreAdminResponse";
  /** List of records */
  items: Array<LabDatastoreAdminRecord>;
  /** Total count of records */
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type LabDatastoreAdminUpdateInput = {
  /** Updated data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record ID */
  id: Scalars["String"]["input"];
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreFieldDefinition = {
  __typename?: "LabDatastoreFieldDefinition";
  /** Case Insensitive Search */
  caseInsensitive?: Maybe<Scalars["Boolean"]["output"]>;
  /** Field Name */
  name: Scalars["String"]["output"];
  /** Is Field Required */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is Field Searchable */
  searchable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Field Type */
  type: LabDatastoreFieldType;
};

export type LabDatastoreFieldDefinitionInput = {
  /** Case Insensitive Search */
  caseInsensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Name */
  name: Scalars["String"]["input"];
  /** Is Field Required */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Is Field Searchable */
  searchable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Type */
  type: LabDatastoreFieldType;
};

export enum LabDatastoreFieldType {
  Boolean = "BOOLEAN",
  Number = "NUMBER",
  String = "STRING",
}

export enum LabDatastoreScope {
  App = "APP",
  User = "USER",
}

export type LabDatastoreTable = {
  __typename?: "LabDatastoreTable";
  /** Table Field Definitions */
  fields: Array<LabDatastoreFieldDefinition>;
  /** Replace data on merge to production */
  replaceDataOnMerge?: Maybe<Scalars["Boolean"]["output"]>;
  /** Table Scope */
  scope: LabDatastoreScope;
  /** Table Name */
  tableName: Scalars["String"]["output"];
};

export type LabDatastoreTableInput = {
  /** Table Field Definitions */
  fields?: InputMaybe<Array<LabDatastoreFieldDefinitionInput>>;
  /** Replace data on merge to production */
  replaceDataOnMerge?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Table Scope */
  scope: LabDatastoreScope;
  /** Table Name */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandDatastoreFilterInput = {
  /** Field name to filter on */
  field: Scalars["String"]["input"];
  /** Value to match */
  value: Scalars["String"]["input"];
};

export type LabsCommandDatastoreInput = {
  /** Datastore sub-command (save, load, search, delete) */
  action: Scalars["String"]["input"];
  /** JSON data to store (for save action) */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Search filters (for search action) */
  filters?: InputMaybe<Array<LabsCommandDatastoreFilterInput>>;
  /** Record ID (required for load/delete, optional for save) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Maximum results (for search action) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset (for search action) */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandDatastoreItem = {
  __typename?: "LabsCommandDatastoreItem";
  /** The stored data as JSON */
  data: Scalars["JSON"]["output"];
  /** Record ID */
  id: Scalars["String"]["output"];
};

export type LabsCommandDatastoreResponse = {
  __typename?: "LabsCommandDatastoreResponse";
  /** The stored data as JSON */
  data?: Maybe<Scalars["JSON"]["output"]>;
  /** Record ID */
  id?: Maybe<Scalars["String"]["output"]>;
  /** List of search results */
  items?: Maybe<Array<LabsCommandDatastoreItem>>;
  /** Whether the operation succeeded */
  success?: Maybe<Scalars["Boolean"]["output"]>;
  /** Total count of matching records */
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type LabsCommandGeminiInput = {
  /** Maximum output tokens */
  maxOutputTokens?: InputMaybe<Scalars["Int"]["input"]>;
  /** Model to use */
  model?: InputMaybe<Scalars["String"]["input"]>;
  /** Prompt to send to Gemini */
  prompt: Scalars["String"]["input"];
  /** System instruction */
  systemInstruction?: InputMaybe<Scalars["String"]["input"]>;
  /** Temperature for response generation */
  temperature?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LabsCommandGeminiResponse = {
  __typename?: "LabsCommandGeminiResponse";
  /** Reason the model stopped generating */
  finishReason?: Maybe<Scalars["String"]["output"]>;
  /** Generated text response */
  text: Scalars["String"]["output"];
};

export type LabsCommandInitResponse = {
  __typename?: "LabsCommandInitResponse";
  /** Authentication token for lab app backend communication */
  authToken: Scalars["String"]["output"];
  /** Role IDs assigned to the current user for this Lab App */
  roles: Array<Scalars["String"]["output"]>;
};

export type LabsCommandInput = {
  /** App ID to execute command against */
  appId: Scalars["String"]["input"];
  /** Command to execute */
  command: Scalars["String"]["input"];
  /** Datastore-specific input */
  datastore?: InputMaybe<LabsCommandDatastoreInput>;
  /** Environment - routes datastore operations to the specified environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Gemini-specific input */
  gemini?: InputMaybe<LabsCommandGeminiInput>;
  /** Log Error-specific input */
  logError?: InputMaybe<LabsCommandLogErrorInput>;
  /** Music Search-specific input */
  musicSearch?: InputMaybe<LabsCommandMusicSearchInput>;
  /** User Action Log-specific input */
  userActionLog?: InputMaybe<LabsCommandUserActionLogInput>;
};

export type LabsCommandLogErrorInput = {
  /** Error message */
  message: Scalars["String"]["input"];
  /** Error stack trace */
  stack?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabsCommandLogErrorResponse = {
  __typename?: "LabsCommandLogErrorResponse";
  /** Whether the error was logged successfully */
  success: Scalars["Boolean"]["output"];
};

export type LabsCommandMusicSearchInput = {
  /** Number of results to return */
  limit: Scalars["Int"]["input"];
  /** Number of results to skip for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Search query */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Search type (e.g., SMART_SEARCH, EXACT_MATCH) */
  searchType?: InputMaybe<SearchType>;
};

export type LabsCommandMusicSearchResponse = {
  __typename?: "LabsCommandMusicSearchResponse";
  /** Total number of tracks matching the search criteria */
  total: Scalars["Int"]["output"];
  /** List of tracks matching the search criteria */
  tracks: Array<Track>;
};

export type LabsCommandResult =
  | LabsCommandDatastoreResponse
  | LabsCommandGeminiResponse
  | LabsCommandInitResponse
  | LabsCommandLogErrorResponse
  | LabsCommandMusicSearchResponse
  | LabsCommandUserActionLogResponse;

export type LabsCommandUserActionLogInput = {
  /** Action identifier (e.g. INIT, BUTTON_CLICK, etc.) */
  action: Scalars["String"]["input"];
  /** Optional arbitrary data */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Path / route within the lab app */
  path?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference identifier */
  reference: Scalars["String"]["input"];
  /** Reference key */
  referenceKey: Scalars["String"]["input"];
};

export type LabsCommandUserActionLogResponse = {
  __typename?: "LabsCommandUserActionLogResponse";
  /** Whether the action was logged successfully */
  success: Scalars["Boolean"]["output"];
};

export enum LabsVersion {
  V1 = "V1",
}

export type LegalAgreementRecord = {
  __typename?: "LegalAgreementRecord";
  agreedAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  version: Scalars["Int"]["output"];
};

export type LegalConfirmation = {
  __typename?: "LegalConfirmation";
  /** User-facing confirmation text the user must agree to */
  label: Scalars["String"]["output"];
};

export type LegalConfirmationInput = {
  label: Scalars["String"]["input"];
};

export type LegalDocument = {
  __typename?: "LegalDocument";
  /** Whether this version is the currently-active one for its key */
  active: Scalars["Boolean"]["output"];
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who last modified this version (falls back to createdByUser) */
  changedByUser?: Maybe<SsoUser>;
  /** Confirmation statements the user must agree to alongside the document */
  confirmations: Array<LegalConfirmation>;
  /** Document content as a JSON-serialized Tiptap document (stringified to avoid tripping WAF XSS rules on raw HTML) */
  content: Scalars["String"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who created this version */
  createdByUser?: Maybe<SsoUser>;
  /** Date the document takes effect */
  effectiveDate: Scalars["DateTime"]["output"];
  /** Legal document ID (unique per version) */
  id: Scalars["ID"]["output"];
  /** URL-safe key (lowercase a-z, 0-9, hyphen). Stable across versions. */
  key: Scalars["String"]["output"];
  /** Display name */
  name: Scalars["String"]["output"];
  /** ID of the version this one replaced (null on the first version) */
  previousVersionId?: Maybe<Scalars["ID"]["output"]>;
  /** Whether users must re-agree when the document changes */
  requiresReagreement: Scalars["Boolean"]["output"];
  /** Whether users must scroll to the end of the document before they can accept */
  requiresScrollToAccept: Scalars["Boolean"]["output"];
  /** Document version — incremented automatically on every save */
  version: Scalars["Int"]["output"];
};

/** An entry in the legal document change log, sourced from the user action log */
export type LegalDocumentChangeLogEntry = {
  __typename?: "LegalDocumentChangeLogEntry";
  /** When the change was made (ISO timestamp) */
  createdAt: Scalars["DateTime"]["output"];
  /** User action log entry ID */
  id: Scalars["ID"]["output"];
  /** Key of the legal document this entry belongs to */
  key: Scalars["String"]["output"];
  /** Human-readable list of changes made in this entry */
  summary: Array<Scalars["String"]["output"]>;
  /** The user who made the change */
  user?: Maybe<SsoUser>;
  /** Version of the legal document this entry produced (1 for the create) */
  version: Scalars["Int"]["output"];
};

export type LegalDocumentChangeLogPage = {
  __typename?: "LegalDocumentChangeLogPage";
  items: Array<LegalDocumentChangeLogEntry>;
  total: Scalars["Int"]["output"];
};

export type LegalDocumentPage = {
  __typename?: "LegalDocumentPage";
  /** List of legal documents */
  items: Array<LegalDocument>;
  /** Total number of legal documents */
  total: Scalars["Int"]["output"];
};

export type LibraryLicense = {
  __typename?: "LibraryLicense";
  businessBrand?: Maybe<Scalars["String"]["output"]>;
  channels: Array<LibraryLicenseDeclaredUsageChannel>;
  declaredByUser: LibraryLicenseUser;
  declaredDate: Scalars["DateTime"]["output"];
  downloadLink?: Maybe<Scalars["String"]["output"]>;
  downloadedByUser: LibraryLicenseUser;
  goLiveDate: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  projectDescription?: Maybe<Scalars["String"]["output"]>;
  projectName: Scalars["String"]["output"];
  regions: Array<Scalars["String"]["output"]>;
  trackArtist: Scalars["String"]["output"];
  trackId: Scalars["ID"]["output"];
  trackTitle: Scalars["String"]["output"];
};

export enum LibraryLicenseChannelType {
  CompanyWebsite = "CompanyWebsite",
  Facebook = "Facebook",
  Instagram = "Instagram",
  LinkedIn = "LinkedIn",
  Other = "Other",
  TikTok = "TikTok",
  Twitter = "Twitter",
  Youtube = "Youtube",
}

export type LibraryLicenseDeclaredUsageChannel = {
  __typename?: "LibraryLicenseDeclaredUsageChannel";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  type: LibraryLicenseChannelType;
  url?: Maybe<Scalars["String"]["output"]>;
  usageLinks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type LibraryLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<LibraryLicenseSortKey>;
};

export enum LibraryLicenseSortKey {
  DeclaredByUser = "declaredByUser",
  GoLiveDate = "goLiveDate",
  OrgName = "orgName",
  ProjectDescription = "projectDescription",
  ProjectName = "projectName",
  TrackArtist = "trackArtist",
  TrackTitle = "trackTitle",
}

export type LibraryLicenseUser = {
  __typename?: "LibraryLicenseUser";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type LibraryLicensesSummary = {
  __typename?: "LibraryLicensesSummary";
  /** Total number of library licenses based on filters */
  total: Scalars["Int"]["output"];
  /** Years for which queried library licenses are available */
  years: Array<Scalars["Int"]["output"]>;
};

export enum LikeItemsType {
  Playlist = "playlist",
  Stem = "stem",
  Track = "track",
}

export type MsaDocument = {
  __typename?: "MsaDocument";
  id: Scalars["String"]["output"];
  selection: MsaDocumentSelection;
  signatoryId: Scalars["String"]["output"];
};

export type MsaDocumentCreateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export type MsaDocumentCreateResponse = {
  __typename?: "MsaDocumentCreateResponse";
  url: Scalars["String"]["output"];
};

export type MsaDocumentGetResponse = {
  __typename?: "MsaDocumentGetResponse";
  url: Scalars["String"]["output"];
};

export enum MsaDocumentSelection {
  OneOff = "OneOff",
  OneOffWithStudioAndDrm = "OneOffWithStudioAndDrm",
}

export type MsaFieldChange = {
  __typename?: "MsaFieldChange";
  field: Scalars["String"]["output"];
  newValue: Scalars["String"]["output"];
  oldValue: Scalars["String"]["output"];
};

export type MsaLogEntry = {
  __typename?: "MsaLogEntry";
  action: Action;
  actionDescription: Scalars["String"]["output"];
  fieldChange?: Maybe<MsaFieldChange>;
  key: Scalars["String"]["output"];
  surveyResponse?: Maybe<MsaSurveyResponse>;
};

export type MsaLogEntryInput = {
  action: Action;
  key: Scalars["String"]["input"];
};

export enum MsaMonetizationPreference {
  Claim = "claim",
  Protect = "protect",
}

export type MsaProfile = {
  __typename?: "MsaProfile";
  companyName?: Maybe<Scalars["String"]["output"]>;
  documentSelection: MsaDocumentSelection;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  monetizationPreference: MsaMonetizationPreference;
  msaDocument?: Maybe<MsaDocument>;
  source: MsaProfileSource;
  status: MsaProfileStatus;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type MsaProfileCreateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  source: MsaProfileSourceInput;
};

export type MsaProfileDocumentSelectionUpdateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export type MsaProfileMonetizationPrefUpdateInput = {
  key: Scalars["String"]["input"];
  preference: MsaMonetizationPreference;
};

export type MsaProfileSource = {
  __typename?: "MsaProfileSource";
  /** Source ID - ex. A MarketplaceId used to transfer songs to Phoenix - Requiring all sources provide unique IDs for each Msa Profile to be created. */
  id: Scalars["Int"]["output"];
  /** Source Type - ex. Marketplace */
  type: MsaSourceType;
};

export type MsaProfileSourceInput = {
  id: Scalars["Int"]["input"];
  type: MsaSourceType;
};

export enum MsaProfileStatus {
  Created = "Created",
  Declined = "Declined",
  Signed = "Signed",
  Viewed = "Viewed",
}

export type MsaProfileStatusUpdateInput = {
  key: Scalars["String"]["input"];
  status: MsaProfileStatus;
};

export enum MsaSourceType {
  Marketplace = "Marketplace",
  Tests = "Tests",
}

export type MsaSurveyData = {
  __typename?: "MsaSurveyData";
  selectionBitMask: Scalars["Int"]["output"];
  textResponse?: Maybe<Scalars["String"]["output"]>;
};

export type MsaSurveyLogEntryInput = {
  key: Scalars["String"]["input"];
  selectionBitMask: Scalars["Int"]["input"];
  textResponse?: InputMaybe<Scalars["String"]["input"]>;
};

export type MsaSurveyResponse = {
  __typename?: "MsaSurveyResponse";
  selectionDescriptions?: Maybe<Array<Scalars["String"]["output"]>>;
  selectionKeys: Array<Scalars["String"]["output"]>;
  textResponse?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Accept user invite to org */
  acceptUserInviteToOrg: OrgUser;
  /** Add the channels to the given collections */
  addChannelsToCollections: Array<Collection>;
  /** This operation allows to create a new client. */
  addClient?: Maybe<Client>;
  /** Add a lab app to favorites */
  addLabAppFavorite: Scalars["Boolean"]["output"];
  addLikes: Scalars["Boolean"]["output"];
  addMsaLogEntry: MsaLogEntry;
  addMsaSurveyLogEntry: MsaLogEntry;
  /** Reply in an org's payout conversation */
  addPayoutComment: PayoutComment;
  addTracksToPlaylists: Scalars["Boolean"]["output"];
  /** Start a bulk-download job for the referenced resources and return the job */
  bulkDownload: BulkDownload;
  /** Cancel an ingestion job */
  cancelIngestionJob: IngestionJob;
  clearUnreadNotifications: Scalars["Boolean"]["output"];
  /** Connect one or more resolved social channels to the current user's account, and add them to the given collections */
  connectChannels: Array<Channel>;
  /** This operation allows to create a new app */
  createApp: LabApp;
  /** This operation allows to create a new clearance. It gets the input and communicates with Aegis to create a new clearance. */
  createClearance?: Maybe<Clearance>;
  /** Create a collection for the current org, holding the given channels */
  createCollection: Collection;
  /** Create a new datastore record as admin */
  createDatastoreAdminRecord: LabDatastoreAdminRecord;
  /** Create a new ingestion job */
  createIngestionJob: IngestionJob;
  /** Create a new legal document */
  createLegalDocument: LegalDocument;
  createMsaDocument: MsaDocumentCreateResponse;
  createMsaProfile: MsaProfile;
  /** Create organization */
  createOrg: Org;
  /** Get a signed S3 URL for org asset upload */
  createOrgAssetSignedUploadUrl: OrgAssetSignedUploadUrl;
  /** Start creating an open Trolley batch for the given orgs; it is prepared in the background and records its progress. Processing is started in Trolley */
  createPayoutBatch: PayoutBatch;
  /** Create a share token granting public read access to a resource */
  createShareToken: Scalars["String"]["output"];
  createSignatureDocument: SignatureDocumentCreateResponse;
  createSignatureDocumentTemplate: SignatureDocumentTemplate;
  /** This operation allows to create a new statement */
  createStatement?: Maybe<Statement>;
  /** Create stem separation task and return one Stem record per target */
  createStems: Stem;
  /** Deactivate one or more of the org's connected channels */
  deactivateChannels: Array<Channel>;
  /** Deactivate user in org */
  deactivateUserInOrg: OrgUser;
  /** Declare a licensed usage for a downloaded track */
  declareTracks: Scalars["Boolean"]["output"];
  declineSignatureDocument: SignatureDocument;
  /** Delete all recent searches for the user */
  deleteAllRecentSearches: Scalars["Boolean"]["output"];
  /** This operation allows to delete an existing app */
  deleteApp: LabAppDeleteResponse;
  /** Delete one or more of the org's collections. The channels inside are untouched. */
  deleteCollections: Array<Scalars["ID"]["output"]>;
  /** Delete a datastore record as admin */
  deleteDatastoreAdminRecords: LabsCommandDatastoreResponse;
  /** Delete (soft) an ingestion job */
  deleteIngestionJob: Scalars["Boolean"]["output"];
  /** Delete a media file from an ingestion job (removes from S3 and updates the job) */
  deleteIngestionJobMediaFile: IngestionJob;
  /** Remove a lab app from favorites */
  deleteLabAppFavorite: Scalars["Boolean"]["output"];
  /** Soft-delete a legal document by key (removes every version) */
  deleteLegalDocument: Scalars["Boolean"]["output"];
  deleteLikes: Scalars["Boolean"]["output"];
  /** Start deleting, in the background, a Creating, Open or NeedsReview batch Trolley can't pay: open in Trolley (deleted there too), gone from Trolley, processed with no unpaid payout Trolley may still pay, never sent, or unconfirmed and not found in Trolley. Its unpaid items, including those of failed payments, return to the balance */
  deletePayoutBatch: PayoutBatch;
  deletePlaylist: Scalars["Boolean"]["output"];
  /** Delete a specific recent search by its log entry ID */
  deleteRecentSearch: Scalars["Boolean"]["output"];
  /** Duplicate a collection, copying its name and channels */
  duplicateCollection: Collection;
  emitMsaProfileToMusicBus: MsaProfile;
  /** Execute a catalog upload */
  executeCatalogUpload: IngestionJobResult;
  /** This operation allows to expire a specific clearance by provided `clearanceId`. It gets the clearance and communicates with Aegis to update its status to `Expired`. */
  expireClearance?: Maybe<Clearance>;
  /** Queue invites for every address that can receive one; sending happens in the background */
  inviteUserToOrg: OrgUserInviteBatch;
  markNotificationAsRead: Scalars["Boolean"]["output"];
  /** Mark an unpaid payout Paid once Trolley shows it was paid outside this batch: a processed payment to the same recipient for the exact amount, made since the batch was created and not linked to another payout. Then updates the batch status, or refreshes it in the background while another task runs */
  markPayoutPaid: PayoutBatch;
  /** Merge dev app config into production */
  mergeDevToProduction: LabApp;
  /** Reactivate one or more of the org's deactivated channels */
  reactivateChannels: Array<Channel>;
  /** Reactivate user in org */
  reactivateUserInOrg: OrgUser;
  /** Record that the current user has accepted a specific version of a legal document. */
  recordLegalAgreement: LegalAgreementRecord;
  /** Release payouts Trolley won't pay in this batch, returning their items to the balance, after checking only them in Trolley: failed ones whose payment is still failed stop being held, and Open ones whose org has no payment in the processed Trolley batch (e.g. removed by Finance) nor one that may be it re-sent are cancelled. Then updates the batch status. While another task runs, or before a complete refresh, a background refresh carries out the request instead */
  releasePayouts: PayoutBatch;
  /** Remove the channels from the given collections */
  removeChannelsFromCollections: Array<Collection>;
  /** Remove org user invite */
  removeOrgUserInvite: Scalars["Boolean"]["output"];
  removeTracksFromPlaylists: Scalars["Boolean"]["output"];
  /** Remove user from org */
  removeUserFromOrg: OrgUser;
  /** Rename a collection */
  renameCollection: Collection;
  reorderPlaylistTracks: Playlist;
  /** Resend org user invite */
  resendOrgUserInvite: Scalars["Boolean"]["output"];
  /** Revert a single dev field to its production value */
  revertDevField: Scalars["Boolean"]["output"];
  /** Put an org on hold, so it is never batched, or release it; the comment says why */
  setPayoutHold: PayoutComment;
  signSignatureDocument: SignatureDocument;
  /** Start a new music ingestion job and get upload URL */
  startIngestionJob: IngestionJobResult;
  /** Cancel a batch that has not generated statements yet */
  statementImportCancelBatch: StatementImportBatch;
  /** Create a batch from an uploaded royalty file: parse, match and prepare for review */
  statementImportCreateBatch: StatementImportBatch;
  /** Delete a cancelled batch */
  statementImportDeleteBatch: Scalars["Boolean"]["output"];
  /** Generate unpaid statements for all included, matched rows */
  statementImportGenerateStatements: StatementImportBatch;
  /** Trigger payment for included rows with statements (all, or a subset by id) */
  statementImportPay: StatementImportBatch;
  /** Include or exclude all rows, optionally narrowed to one status */
  statementImportSetAllIncluded: Scalars["Int"]["output"];
  /** Include or exclude specific rows */
  statementImportSetIncluded: Scalars["Int"]["output"];
  /** Submit a customer support inquiry */
  submitInquiry: Scalars["Boolean"]["output"];
  /** Start updating a batch and its payouts from Trolley in the background; the batch shows the progress. Does nothing while a task runs */
  syncPayoutBatch: PayoutBatch;
  /** Start refreshing every Trolley recipient's status in the background; false when a refresh is already running */
  syncPayoutRecipients: Scalars["Boolean"]["output"];
  /** This operation allows to update an existing app */
  updateApp: LabApp;
  /** This operation allows to update a specific clearance by provided `clearanceId`. It gets the clearance and communicates with Aegis to update its `startDate`, `endDate` and `notes`. It returns the updated clearance with the new `startDate`, `endDate` and `notes`. At the moment of writing it is not possible to update other fields. */
  updateClearance?: Maybe<Clearance>;
  /** This operation allows to update a client. */
  updateClient?: Maybe<Client>;
  /** Update a datastore record as admin */
  updateDatastoreAdminRecord: LabDatastoreAdminRecord;
  /** Update an existing ingestion job */
  updateIngestionJob: IngestionJob;
  /** Update ingestion settings for the current org */
  updateIngestionSettings: IngestionSettingsResult;
  /** Update Lab Categories (full replace) */
  updateLabCategories: Array<LabCategory>;
  /** Update an existing legal document by key */
  updateLegalDocument: LegalDocument;
  updateMsaProfileDocumentSelection: MsaProfile;
  updateMsaProfileMonetizationPref: MsaProfile;
  updateMsaProfileStatus: MsaProfile;
  /** Update org branding assets */
  updateOrgAssets: Scalars["Boolean"]["output"];
  /** Update organization details */
  updateOrgDetails: Scalars["Boolean"]["output"];
  /** Update organization modules */
  updateOrgModules: Scalars["Boolean"]["output"];
  /** Update org user roles and permissions */
  updateOrgUserInvite: OrgUserInvite;
  /** Set the current org's payout minimum (USD cents, at least ) */
  updatePayoutMinimum: PayoutBalance;
  updateSignatory: SignatureDocumentSignatoryUpdateResponse;
  /** This operation allows to update an existing statement */
  updateStatement?: Maybe<Statement>;
  /** Update org user roles and permissions */
  updateUserPermissionsInOrg: OrgUser;
  upsertPlaylist: Playlist;
  /** Validate if files exist in S3 bucket */
  validateFilesInS3: Array<FileValidationResult>;
};

export type MutationAcceptUserInviteToOrgArgs = {
  inviteId: Scalars["ID"]["input"];
};

export type MutationAddChannelsToCollectionsArgs = {
  channelIds: Array<Scalars["ID"]["input"]>;
  collectionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationAddClientArgs = {
  input: AddClientInput;
};

export type MutationAddLabAppFavoriteArgs = {
  labAppId: Scalars["String"]["input"];
};

export type MutationAddLikesArgs = {
  itemIds: Array<Scalars["ID"]["input"]>;
  itemType: LikeItemsType;
};

export type MutationAddMsaLogEntryArgs = {
  input: MsaLogEntryInput;
};

export type MutationAddMsaSurveyLogEntryArgs = {
  input: MsaSurveyLogEntryInput;
};

export type MutationAddPayoutCommentArgs = {
  body: Scalars["String"]["input"];
  orgId: Scalars["String"]["input"];
};

export type MutationAddTracksToPlaylistsArgs = {
  playlistIds: Array<Scalars["ID"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationBulkDownloadArgs = {
  referenceFormat: BulkDownloadReferenceFormat;
  referenceIds: Array<Scalars["ID"]["input"]>;
  referenceType: BulkDownloadReferenceType;
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCancelIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type MutationConnectChannelsArgs = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  input: Array<ConnectChannelInput>;
};

export type MutationCreateAppArgs = {
  label: Scalars["String"]["input"];
};

export type MutationCreateClearanceArgs = {
  input: ClearanceCreateInput;
};

export type MutationCreateCollectionArgs = {
  channelIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name: Scalars["String"]["input"];
};

export type MutationCreateDatastoreAdminRecordArgs = {
  input: LabDatastoreAdminCreateInput;
};

export type MutationCreateIngestionJobArgs = {
  jobName: Scalars["String"]["input"];
  licensorDpid: Scalars["String"]["input"];
};

export type MutationCreateLegalDocumentArgs = {
  input: CreateLegalDocumentInput;
};

export type MutationCreateMsaDocumentArgs = {
  input: MsaDocumentCreateInput;
};

export type MutationCreateMsaProfileArgs = {
  input: MsaProfileCreateInput;
};

export type MutationCreateOrgArgs = {
  input: CreateOrgInput;
};

export type MutationCreateOrgAssetSignedUploadUrlArgs = {
  contentType: Scalars["String"]["input"];
  hash: Scalars["String"]["input"];
};

export type MutationCreatePayoutBatchArgs = {
  orgIds: Array<Scalars["String"]["input"]>;
};

export type MutationCreateShareTokenArgs = {
  input: CreateShareTokenInput;
};

export type MutationCreateSignatureDocumentArgs = {
  input: SignatureDocumentCreateInput;
};

export type MutationCreateSignatureDocumentTemplateArgs = {
  input: SignatureDocumentTemplateCreateInput;
};

export type MutationCreateStatementArgs = {
  input: StatementCreateInput;
};

export type MutationCreateStemsArgs = {
  modelId: Scalars["String"]["input"];
  trackId: Scalars["ID"]["input"];
};

export type MutationDeactivateChannelsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeactivateUserInOrgArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeclareTracksArgs = {
  input: DeclareTracksInput;
};

export type MutationDeclineSignatureDocumentArgs = {
  input: SignatureDocumentDeclineInput;
};

export type MutationDeleteAppArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteCollectionsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeleteDatastoreAdminRecordsArgs = {
  input: LabDatastoreAdminDeleteInput;
};

export type MutationDeleteIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type MutationDeleteIngestionJobMediaFileArgs = {
  jobId: Scalars["ID"]["input"];
  mediaFileId: Scalars["String"]["input"];
};

export type MutationDeleteLabAppFavoriteArgs = {
  labAppId: Scalars["String"]["input"];
};

export type MutationDeleteLegalDocumentArgs = {
  key: Scalars["String"]["input"];
};

export type MutationDeleteLikesArgs = {
  itemIds: Array<Scalars["ID"]["input"]>;
  itemType: LikeItemsType;
};

export type MutationDeletePayoutBatchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeletePlaylistArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteRecentSearchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDuplicateCollectionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationEmitMsaProfileToMusicBusArgs = {
  key: Scalars["String"]["input"];
};

export type MutationExecuteCatalogUploadArgs = {
  dromoUploadId: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
};

export type MutationExpireClearanceArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInviteUserToOrgArgs = {
  invites: Array<OrgUserInviteInput>;
};

export type MutationMarkNotificationAsReadArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkPayoutPaidArgs = {
  id: Scalars["String"]["input"];
  payoutId: Scalars["String"]["input"];
};

export type MutationMergeDevToProductionArgs = {
  id: Scalars["String"]["input"];
};

export type MutationReactivateChannelsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationReactivateUserInOrgArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRecordLegalAgreementArgs = {
  input: RecordLegalAgreementInput;
};

export type MutationReleasePayoutsArgs = {
  id: Scalars["String"]["input"];
  payoutIds: Array<Scalars["String"]["input"]>;
};

export type MutationRemoveChannelsFromCollectionsArgs = {
  channelIds: Array<Scalars["ID"]["input"]>;
  collectionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationRemoveOrgUserInviteArgs = {
  inviteId: Scalars["ID"]["input"];
};

export type MutationRemoveTracksFromPlaylistsArgs = {
  playlistIds: Array<Scalars["ID"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationRemoveUserFromOrgArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRenameCollectionArgs = {
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationReorderPlaylistTracksArgs = {
  id: Scalars["ID"]["input"];
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationResendOrgUserInviteArgs = {
  inviteId: Scalars["ID"]["input"];
};

export type MutationRevertDevFieldArgs = {
  field: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationSetPayoutHoldArgs = {
  comment: Scalars["String"]["input"];
  onHold: Scalars["Boolean"]["input"];
  orgId: Scalars["String"]["input"];
};

export type MutationSignSignatureDocumentArgs = {
  input: SignatureDocumentSignInput;
};

export type MutationStartIngestionJobArgs = {
  jobName: Scalars["String"]["input"];
  licensorDpid: Scalars["String"]["input"];
};

export type MutationStatementImportCancelBatchArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportCreateBatchArgs = {
  input: StatementImportCreateBatchInput;
};

export type MutationStatementImportDeleteBatchArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportGenerateStatementsArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportPayArgs = {
  batchId: Scalars["String"]["input"];
  dataIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationStatementImportSetAllIncludedArgs = {
  batchId: Scalars["String"]["input"];
  included: Scalars["Boolean"]["input"];
  status?: InputMaybe<ImportDataStatus>;
};

export type MutationStatementImportSetIncludedArgs = {
  batchId: Scalars["String"]["input"];
  dataIds: Array<Scalars["String"]["input"]>;
  included: Scalars["Boolean"]["input"];
};

export type MutationSubmitInquiryArgs = {
  category: Scalars["String"]["input"];
  inquiry: Scalars["String"]["input"];
};

export type MutationSyncPayoutBatchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationUpdateAppArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  input: LabAppInput;
};

export type MutationUpdateClearanceArgs = {
  input: ClearanceUpdateInput;
};

export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};

export type MutationUpdateDatastoreAdminRecordArgs = {
  input: LabDatastoreAdminUpdateInput;
};

export type MutationUpdateIngestionJobArgs = {
  input: UpdateIngestionJobInput;
};

export type MutationUpdateIngestionSettingsArgs = {
  dpid: Scalars["String"]["input"];
};

export type MutationUpdateLabCategoriesArgs = {
  input: Array<LabCategoryInput>;
};

export type MutationUpdateLegalDocumentArgs = {
  input: UpdateLegalDocumentInput;
  key: Scalars["String"]["input"];
};

export type MutationUpdateMsaProfileDocumentSelectionArgs = {
  input: MsaProfileDocumentSelectionUpdateInput;
};

export type MutationUpdateMsaProfileMonetizationPrefArgs = {
  input: MsaProfileMonetizationPrefUpdateInput;
};

export type MutationUpdateMsaProfileStatusArgs = {
  input: MsaProfileStatusUpdateInput;
};

export type MutationUpdateOrgAssetsArgs = {
  background?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateOrgDetailsArgs = {
  input: UpdateOrgDetailsInput;
};

export type MutationUpdateOrgModulesArgs = {
  input: UpdateOrgModulesInput;
};

export type MutationUpdateOrgUserInviteArgs = {
  inviteId: Scalars["ID"]["input"];
  permissions: Array<Scalars["String"]["input"]>;
  roles: Array<Scalars["String"]["input"]>;
};

export type MutationUpdatePayoutMinimumArgs = {
  minimumPayoutCents: Scalars["Int"]["input"];
};

export type MutationUpdateSignatoryArgs = {
  input: SignatureDocumentSignatoryUpdateInput;
};

export type MutationUpdateStatementArgs = {
  input: StatementUpdateInput;
};

export type MutationUpdateUserPermissionsInOrgArgs = {
  id: Scalars["ID"]["input"];
  permissions: Array<Scalars["String"]["input"]>;
  roles: Array<Scalars["String"]["input"]>;
};

export type MutationUpsertPlaylistArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  imageS3Key?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  shareable?: InputMaybe<Scalars["Boolean"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationValidateFilesInS3Args = {
  input: ValidateFilesInput;
};

export type Notification = {
  __typename?: "Notification";
  data?: Maybe<Array<NotificationData>>;
  date: Scalars["DateTime"]["output"];
  dest?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  orgId?: Maybe<Scalars["String"]["output"]>;
  status: NotificationStatus;
  subject?: Maybe<NotificationSubject>;
  type: NotificationType;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationData = {
  __typename?: "NotificationData";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum NotificationStatus {
  Read = "Read",
  Unread = "Unread",
}

export type NotificationSubject = {
  __typename?: "NotificationSubject";
  avatar?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export enum NotificationType {
  /** For everyone in an organisation (e.g. a new org playlist) */
  Org = "Org",
  /** For a user in the context of a specific organisation (e.g. their org role changed) */
  OrgUser = "OrgUser",
  /** For a user regardless of organisation (e.g. their stem export is ready) */
  User = "User",
}

export type NotificationsPage = {
  __typename?: "NotificationsPage";
  items: Array<Notification>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type NotificationsQueries = {
  __typename?: "NotificationsQueries";
  /** Get the unread count for the current user */
  unreadCount?: Maybe<Scalars["Int"]["output"]>;
  /** Get the current user's notifications */
  user?: Maybe<NotificationsPage>;
};

export type NotificationsQueriesUserArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type Org = {
  __typename?: "Org";
  /** Create date */
  createDate: Scalars["DateTime"]["output"];
  /** Org ID */
  id: Scalars["ID"]["output"];
  /** Login methods */
  loginMethods: Array<OrgLoginMethods>;
  /** Org metadata */
  metadata?: Maybe<OrgMetadata>;
  /** Org modules */
  modules: Array<Scalars["String"]["output"]>;
  /** Org name */
  name: Scalars["String"]["output"];
  /** Parent Org ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Org roles */
  roles: Array<OrgRoleX>;
  /** Workspace */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export type OrgAssetSignedUploadUrl = {
  __typename?: "OrgAssetSignedUploadUrl";
  fileName: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export enum OrgLoginMethods {
  EmailPassword = "EMAIL_PASSWORD",
  Google = "GOOGLE",
  Upstream = "UPSTREAM",
}

export type OrgMetadata = {
  __typename?: "OrgMetadata";
  /** Account manager */
  accountManager?: Maybe<OrgMetadataAccountManager>;
  /** Analytics settings */
  analytics?: Maybe<OrgMetadataAnalytics>;
  /** Assets */
  assets?: Maybe<OrgMetadataAssets>;
  /** Basic settings */
  basic?: Maybe<OrgMetadataBasic>;
  /** Modules settings */
  modules?: Maybe<OrgMetadataModules>;
  /** Other settings */
  other?: Maybe<OrgMetadataOther>;
  /** Payouts settings */
  payouts?: Maybe<OrgMetadataPayouts>;
  /** Price estimation settings */
  priceEstimation?: Maybe<OrgMetadataPriceEstimation>;
};

export type OrgMetadataAccountManager = {
  __typename?: "OrgMetadataAccountManager";
  /** Account manager email */
  email: Scalars["String"]["output"];
  /** Account manager first name */
  firstName: Scalars["String"]["output"];
  /** Account manager last name */
  lastName: Scalars["String"]["output"];
  /** Account manager phone */
  phone?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataAnalytics = {
  __typename?: "OrgMetadataAnalytics";
  heap?: Maybe<OrgMetadataAnalyticsHeap>;
};

export type OrgMetadataAnalyticsHeap = {
  __typename?: "OrgMetadataAnalyticsHeap";
  /** Heap enabled */
  enabled: Scalars["Boolean"]["output"];
};

export type OrgMetadataAssets = {
  __typename?: "OrgMetadataAssets";
  /** Org background file name */
  background?: Maybe<Scalars["String"]["output"]>;
  /** Org logo file name */
  logo?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataBasic = {
  __typename?: "OrgMetadataBasic";
  /** Deal ID */
  dealId: Scalars["ID"]["output"];
  /** Holding organization ID */
  holdingOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Parent organization ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Servicing organization email */
  servicingOrgEmail: Scalars["String"]["output"];
  /** Servicing organization ID */
  servicingOrgId: Scalars["ID"]["output"];
};

export type OrgMetadataModules = {
  __typename?: "OrgMetadataModules";
  /** Adaptive Music settings */
  adaptiveMusic?: Maybe<OrgMetadataModulesAdaptiveMusic>;
};

export type OrgMetadataModulesAdaptiveMusic = {
  __typename?: "OrgMetadataModulesAdaptiveMusic";
  /** Adaptive Music Url */
  url: Scalars["String"]["output"];
};

export type OrgMetadataOther = {
  __typename?: "OrgMetadataOther";
  /** Org HubSpot IDs. Used to link the org to it's counterpart in the HubSpot system. */
  hubSpotIds?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type OrgMetadataPayouts = {
  __typename?: "OrgMetadataPayouts";
  /** Org billing email address */
  billingEmail?: Maybe<Scalars["String"]["output"]>;
  /** Minimum payout in USD cents; null means the platform default applies */
  minimumPayoutCents?: Maybe<Scalars["Int"]["output"]>;
  /** Org Trolley reference ID. Custom identifier that can be assigned to an entity when creating it within Trolley's system. By default, it is the same as the organization ID. */
  trolleyRefId?: Maybe<Scalars["String"]["output"]>;
  /** Org Trolley widget url. Generated based on the valid Trolley reference ID and billing email address. */
  trolleyUrl?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataPriceEstimation = {
  __typename?: "OrgMetadataPriceEstimation";
  /** Currency */
  currency?: Maybe<Scalars["Currency"]["output"]>;
  /** Instagram followers */
  instagramFollowers?: Maybe<Scalars["BigInt"]["output"]>;
  /** Market cap */
  marketCap?: Maybe<Scalars["BigInt"]["output"]>;
  /** Market symbol */
  marketSymbol?: Maybe<Scalars["String"]["output"]>;
  /** Number of employees */
  numberOfEmployees?: Maybe<Scalars["BigInt"]["output"]>;
  /** Public company */
  publicCompany?: Maybe<Scalars["Boolean"]["output"]>;
  /** TikTok followers */
  tikTokFollowers?: Maybe<Scalars["BigInt"]["output"]>;
};

export type OrgPermissionX = {
  __typename?: "OrgPermissionX";
  /** Permission hidden */
  hidden?: Maybe<Scalars["Boolean"]["output"]>;
  /** Permission label */
  label: Scalars["String"]["output"];
  /** Permission ID */
  name: Scalars["ID"]["output"];
};

export type OrgRoleX = {
  __typename?: "OrgRoleX";
  /** Role label */
  label: Scalars["String"]["output"];
  /** Role ID */
  name: Scalars["ID"]["output"];
  /** Role permissions */
  permissions: Array<OrgPermissionX>;
};

export type OrgUser = {
  __typename?: "OrgUser";
  /** User active date */
  activeDate: Scalars["DateTime"]["output"];
  /** Current app ID */
  appId: Scalars["ID"]["output"];
  /** User deleted date */
  deletedDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User email */
  email: Scalars["String"]["output"];
  /** User first name */
  firstName: Scalars["String"]["output"];
  /** User has access to current app */
  hasAccessToApplication: Scalars["Boolean"]["output"];
  /** User ID */
  id: Scalars["ID"]["output"];
  /** User apps IDs */
  inAppIds: Array<Scalars["ID"]["output"]>;
  /** User orgs */
  inOrgs: Array<UserOrg>;
  /** User inactive date */
  inactiveDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User last name */
  lastName: Scalars["String"]["output"];
  /** User name */
  name: Scalars["String"]["output"];
  /** User org ID */
  orgId: Scalars["ID"]["output"];
  /** User permissions */
  permissions: Array<Scalars["String"]["output"]>;
  /** User picture */
  picture?: Maybe<Scalars["String"]["output"]>;
  /** User roles */
  roles: Array<Scalars["String"]["output"]>;
  /** User status */
  status: OrgUserStatus;
};

export type OrgUserInvite = {
  __typename?: "OrgUserInvite";
  /** Invite email */
  email: Scalars["String"]["output"];
  /** Invite ID */
  id: Scalars["ID"]["output"];
  /** Last send date */
  lastSendDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Invite permissions */
  permissions: Array<Scalars["String"]["output"]>;
  /** Invite roles */
  roles: Array<Scalars["String"]["output"]>;
  /** Invite status */
  status: OrgUserInviteStatus;
  /** Workspace the invite must be accepted under */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export type OrgUserInviteBatch = {
  __typename?: "OrgUserInviteBatch";
  /** Creation date */
  createdDate: Scalars["DateTime"]["output"];
  /** Invites that could not be sent */
  failed: Scalars["Int"]["output"];
  /** Batch ID */
  id: Scalars["ID"]["output"];
  /** Entered values skipped because they are not deliverable email addresses */
  invalid: Array<Scalars["String"]["output"]>;
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Invites created and queued for sending */
  requested: Scalars["Int"]["output"];
  /** Invites sent so far */
  sent: Scalars["Int"]["output"];
  /** Addresses skipped because they are members, inactive or already invited */
  skipped: Scalars["Int"]["output"];
  /** Batch status */
  status: OrgUserInviteBatchStatus;
};

export enum OrgUserInviteBatchStatus {
  /** Every invite was sent */
  Completed = "completed",
  /** At least one invite could not be sent */
  Error = "error",
  /** Processor is sending */
  Processing = "processing",
  /** Accepted and waiting for the processor */
  Queued = "queued",
}

export type OrgUserInviteInput = {
  /** Invite email */
  emails: Array<Scalars["String"]["input"]>;
  /** Invite permissions */
  permissions: Array<Scalars["String"]["input"]>;
  /** Invite roles */
  roles: Array<Scalars["String"]["input"]>;
};

export type OrgUserInviteLookupResult = {
  __typename?: "OrgUserInviteLookupResult";
  /** Normalised email address */
  email: Scalars["String"]["output"];
  /** What sending an invite to this address would do */
  status: OrgUserInviteLookupStatus;
};

export enum OrgUserInviteLookupStatus {
  /** Active user of the org */
  Active = "active",
  /** Deactivated member of the org, needs reactivating rather than inviting */
  Inactive = "inactive",
  /** Has a pending invite already */
  Pending = "pending",
  /** No org user and no pending invite, an invite can be sent */
  Unknown = "unknown",
}

export type OrgUserInviteSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgUserInviteSortKey>;
};

export enum OrgUserInviteSortKey {
  Email = "email",
  LastSendDate = "lastSendDate",
  Status = "status",
}

export enum OrgUserInviteStatus {
  Accepted = "accepted",
  Pending = "pending",
  Removed = "removed",
}

export type OrgUserInvitesPage = {
  __typename?: "OrgUserInvitesPage";
  /** Invites */
  invites: Array<OrgUserInvite>;
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Query */
  query?: Maybe<Scalars["String"]["output"]>;
  /** Total */
  total: Scalars["Int"]["output"];
};

export enum OrgUserStatus {
  Active = "active",
  Deleted = "deleted",
  Inactive = "inactive",
}

export type OrgUsersPage = {
  __typename?: "OrgUsersPage";
  /** App ID */
  appId: Scalars["ID"]["output"];
  /** Include permissions */
  includePermissions: Scalars["Boolean"]["output"];
  /** Last page */
  isLastPage: Scalars["Boolean"]["output"];
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Query */
  query: Scalars["String"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
  /** Users */
  users: Array<OrgUser>;
};

export type OrgsPage = {
  __typename?: "OrgsPage";
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Orgs */
  orgs: Array<Org>;
  /** Query */
  query?: Maybe<Scalars["String"]["output"]>;
  /** Total */
  total: Scalars["Int"]["output"];
};

export type OrgsSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgsSortKey>;
};

export enum OrgsSortKey {
  Name = "name",
}

export type Payout = {
  __typename?: "Payout";
  /** amountCents as a USD decimal, e.g. 120.50, for exports; always set */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountCents: Scalars["Int"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Also the Trolley payment's external id */
  id: Scalars["String"]["output"];
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  paidAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Trolley returned the payment, before or after paying it; its amount is back in the org's balance */
  returned?: Maybe<Scalars["Boolean"]["output"]>;
  /** When the return was seen in Trolley */
  returnedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: PayoutStatus;
  trolleyPaymentId?: Maybe<Scalars["String"]["output"]>;
  trolleyStatus?: Maybe<Scalars["String"]["output"]>;
};

/** The current org's payout balance; all amounts are USD cents */
export type PayoutBalance = {
  __typename?: "PayoutBalance";
  /** Unpaid and batched ledger items; can be negative */
  balanceCents: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  /** The org is paid once its balance reaches this amount */
  minimumPayoutCents: Scalars["Int"]["output"];
  /** Whether the org has an active Trolley recipient; null when Trolley can't be reached */
  payoutSetupComplete?: Maybe<Scalars["Boolean"]["output"]>;
  /** Part of the balance in a Trolley batch that hasn't been paid yet */
  pendingPayoutCents: Scalars["Int"]["output"];
};

export type PayoutBatch = {
  __typename?: "PayoutBatch";
  /** Last change; while Creating, every prepared org updates it */
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  createUser?: Maybe<SsoUser>;
  createdBy?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  /** Payouts the last complete refresh found a problem with */
  issues?: Maybe<Array<PayoutBatchIssue>>;
  /** Why the last background task stopped: a sentence, or a Payouts.* message key; null once one finished */
  lastSyncError?: Maybe<Scalars["String"]["output"]>;
  lastSyncedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Orgs selected for the batch; 0 on batches created before it was recorded */
  orgCount: Scalars["Int"]["output"];
  paymentCount: Scalars["Int"]["output"];
  payouts?: Maybe<Array<Payout>>;
  /** Selected orgs prepared so far, skipped or not; while Creating it shows the progress */
  preparedCount: Scalars["Int"]["output"];
  reviewReason?: Maybe<Scalars["String"]["output"]>;
  skipped: Array<PayoutSkippedOrg>;
  status: PayoutBatchStatus;
  /** How far the running or last refresh got */
  syncProgress?: Maybe<PayoutBatchSyncProgress>;
  /** What the running or last background task does */
  syncTask?: Maybe<PayoutBatchTask>;
  /** A refresh or delete is running in the background */
  syncing?: Maybe<Scalars["Boolean"]["output"]>;
  totalCents: Scalars["Int"]["output"];
  trolleyBatchId?: Maybe<Scalars["String"]["output"]>;
  /** Set once the batch was sent to Trolley */
  trolleyRequestedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PayoutBatchPayoutsArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PayoutBatchIssue = {
  __typename?: "PayoutBatchIssue";
  kind: PayoutIssueKind;
  message: Scalars["String"]["output"];
  payout: Payout;
  /** Whether releasePayouts can return its items to the balance */
  releasable: Scalars["Boolean"]["output"];
  /** The payment's status in Trolley when the problem was found; null when Trolley has no payment */
  trolleyStatus?: Maybe<Scalars["String"]["output"]>;
};

export type PayoutBatchPage = {
  __typename?: "PayoutBatchPage";
  items: Array<PayoutBatch>;
  total: Scalars["Int"]["output"];
};

/**
 * Batches are created open in Trolley; Finance starts processing them in the
 * Trolley dashboard. NeedsReview means Trolley didn't match our records or its
 * outcome is unknown, so an admin must check it.
 */
export enum PayoutBatchStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Creating = "Creating",
  NeedsReview = "NeedsReview",
  Open = "Open",
  Processing = "Processing",
}

/** Payments a refresh listed from Trolley and applied */
export type PayoutBatchSyncProgress = {
  __typename?: "PayoutBatchSyncProgress";
  applied: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

/** What a batch's background task does */
export enum PayoutBatchTask {
  Delete = "Delete",
  Refresh = "Refresh",
}

/** A message in an org's payout conversation */
export type PayoutComment = {
  __typename?: "PayoutComment";
  /** Set when the comment put the org on hold or released it */
  action?: Maybe<PayoutCommentAction>;
  /** Plain text; URLs are shown as links */
  body: Scalars["String"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  createUser?: Maybe<SsoUser>;
  createdBy?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  orgId: Scalars["String"]["output"];
};

export enum PayoutCommentAction {
  /** The comment put the org on hold */
  Hold = "Hold",
  /** The comment released the org */
  Release = "Release",
}

/** An org's payout balance details */
export type PayoutEligibleOrg = {
  __typename?: "PayoutEligibleOrg";
  adjustmentCents: Scalars["Int"]["output"];
  adjustments?: Maybe<Scalars["String"]["output"]>;
  /** The cents fields as USD decimals, e.g. 120.50, for exports; always set */
  balance?: Maybe<Scalars["String"]["output"]>;
  balanceCents: Scalars["Int"]["output"];
  /** Messages in the org's payout conversation */
  commentCount: Scalars["Int"]["output"];
  /** When the org was put on hold; set on held orgs only */
  heldAt?: Maybe<Scalars["DateTime"]["output"]>;
  itemCount: Scalars["Int"]["output"];
  legacy?: Maybe<Scalars["String"]["output"]>;
  legacyCents: Scalars["Int"]["output"];
  /** The org's legacy marketplace user; null unless the org came from the marketplace */
  marketplaceUserId?: Maybe<Scalars["Int"]["output"]>;
  minimumPayout?: Maybe<Scalars["String"]["output"]>;
  minimumPayoutCents: Scalars["Int"]["output"];
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  statementCents: Scalars["Int"]["output"];
  statements?: Maybe<Scalars["String"]["output"]>;
  /** Active and Unknown orgs can be batched */
  trolleyStatus: PayoutTrolleyStatus;
};

export type PayoutEligibleOrgPage = {
  __typename?: "PayoutEligibleOrgPage";
  items: Array<PayoutEligibleOrg>;
  total: Scalars["Int"]["output"];
};

export type PayoutEligibleSort = {
  direction: SortDirection;
  key?: InputMaybe<PayoutEligibleSortKey>;
};

export enum PayoutEligibleSortKey {
  BalanceCents = "balanceCents",
}

/** Why a payout needs an admin, as the last complete refresh found it */
export enum PayoutIssueKind {
  DifferentAmount = "DifferentAmount",
  DifferentRecipient = "DifferentRecipient",
  /** Trolley failed the payment; its items stay claimed in case Finance re-sends it */
  Failed = "Failed",
  /** Trolley's batch has no payment for it */
  Missing = "Missing",
  /** Trolley pays a payout whose items already returned to the balance */
  PaidAfterRelease = "PaidAfterRelease",
  UnknownStatus = "UnknownStatus",
}

/** Where a ledger item's amount comes from */
export enum PayoutItemSource {
  /** A correction, e.g. a returned payment credited back */
  Adjustment = "Adjustment",
  /** The org's balance on the legacy marketplace, refreshed until it is paid */
  LegacyOpening = "LegacyOpening",
  /** A statement paid by the statement processor */
  Statement = "Statement",
}

export enum PayoutItemStatus {
  /** Claimed by a payout in a Trolley batch that hasn't been paid yet */
  Batched = "Batched",
  Paid = "Paid",
  Unpaid = "Unpaid",
}

export type PayoutQueries = {
  __typename?: "PayoutQueries";
  /** Null for an unknown batch */
  batch?: Maybe<PayoutBatch>;
  /** Payout batches, newest first */
  batches?: Maybe<PayoutBatchPage>;
  /** An org's payout conversation, oldest first */
  comments?: Maybe<Array<PayoutComment>>;
  /** Orgs that can be paid in the next batch, highest balance first unless sorted; every match without a limit */
  eligible?: Maybe<PayoutEligibleOrgPage>;
  /** Orgs on hold, whatever their balance; latest hold first */
  held?: Maybe<Array<PayoutEligibleOrg>>;
};

export type PayoutQueriesBatchArgs = {
  id: Scalars["String"]["input"];
};

export type PayoutQueriesBatchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PayoutQueriesCommentsArgs = {
  orgId: Scalars["String"]["input"];
};

export type PayoutQueriesEligibleArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<PayoutEligibleSort>;
  trolleyStatuses?: InputMaybe<Array<PayoutTrolleyStatus>>;
};

export type PayoutQueriesHeldArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** An org left out of a new batch, and why */
export type PayoutSkippedOrg = {
  __typename?: "PayoutSkippedOrg";
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
};

export enum PayoutStatus {
  Cancelled = "Cancelled",
  Failed = "Failed",
  Open = "Open",
  Paid = "Paid",
  Processing = "Processing",
}

export enum PayoutTrolleyStatus {
  /** An active Trolley recipient; the org can be batched */
  Active = "Active",
  /** A Trolley recipient that isn't active yet, e.g. onboarding unfinished */
  NotActive = "NotActive",
  /** No Trolley recipient for the org, or Trolley deleted it */
  NotSetUp = "NotSetUp",
  /** No stored status and no completed refresh yet; batching checks Trolley */
  Unknown = "Unknown",
}

/** A legal document the current user still needs to accept. Mirrors LegalDocument fields needed by the agreement modal. */
export type PendingLegalAgreement = {
  __typename?: "PendingLegalAgreement";
  /** Confirmations the user must tick to accept */
  confirmations: Array<LegalConfirmation>;
  /** Document body (HTML) */
  content: Scalars["String"]["output"];
  /** Active document version ID (used as the target of recordLegalAgreement) */
  documentId: Scalars["ID"]["output"];
  /** Date this version takes effect */
  effectiveDate: Scalars["DateTime"]["output"];
  /** Stable key (matches the input to pendingLegalAgreements) */
  key: Scalars["String"]["output"];
  /** Display name */
  name: Scalars["String"]["output"];
  /** Version the user previously accepted (null if they have never accepted any version of this document) */
  previousAcceptedVersion?: Maybe<Scalars["Int"]["output"]>;
  /** Whether the user must scroll to the end of the document before accepting */
  requiresScrollToAccept: Scalars["Boolean"]["output"];
  /** Document version the user is being asked to accept */
  version: Scalars["Int"]["output"];
};

export type Playlist = {
  __typename?: "Playlist";
  createdBy?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duration: Scalars["Int"]["output"];
  hasCustomImage: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  imageGuid?: Maybe<Scalars["String"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  isOwner: Scalars["Boolean"]["output"];
  liked: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  segmentTracksCount: Scalars["Int"]["output"];
  shareable: Scalars["Boolean"]["output"];
  totalCount: Scalars["Int"]["output"];
  trackIds: Array<Scalars["String"]["output"]>;
  tracks: TracksPage;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type PlaylistImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlaylistTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlaylistList = {
  __typename?: "PlaylistList";
  results: Array<Playlist>;
  total: Scalars["Int"]["output"];
};

export type PlaylistQueries = {
  __typename?: "PlaylistQueries";
  /** Get a single playlist by id */
  byId?: Maybe<Playlist>;
  /** Shared playlist queries */
  shared?: Maybe<SharedPlaylistQueries>;
};

export type PlaylistQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type PlaylistsQueries = {
  __typename?: "PlaylistsQueries";
  /** Get curated playlists */
  curated?: Maybe<CuratedPlaylistQueries>;
  /** Get the current user's liked playlists */
  liked?: Maybe<Array<Playlist>>;
  /** Get recently played playlists for the current user */
  recent?: Maybe<Array<Playlist>>;
  /** Get the current user's team playlists */
  team?: Maybe<Array<Playlist>>;
  /** Get the current user's personal playlists */
  user?: Maybe<Array<Playlist>>;
};

export type PlaylistsQueriesCuratedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PlaylistsQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PortableText = {
  __typename?: "PortableText";
  /** The key of the portable text */
  _key?: Maybe<Scalars["String"]["output"]>;
  /** The type of the portable text */
  _type?: Maybe<Scalars["String"]["output"]>;
  /** The children of the portable text */
  children?: Maybe<Array<Maybe<PortableTextChildren>>>;
  /** The list item of the portable text */
  listItem?: Maybe<Scalars["String"]["output"]>;
  /** The style of the portable text */
  style?: Maybe<Scalars["String"]["output"]>;
};

export type PortableTextChildren = {
  __typename?: "PortableTextChildren";
  /** The key of the portable text */
  _key?: Maybe<Scalars["String"]["output"]>;
  /** The type of the portable text */
  _type?: Maybe<Scalars["String"]["output"]>;
  /** The marks of the portable text */
  marks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The text of the portable text */
  text?: Maybe<Scalars["String"]["output"]>;
};

export type PreparedChannel = {
  __typename?: "PreparedChannel";
  channelTitle?: Maybe<Scalars["String"]["output"]>;
  duplicate: Scalars["Boolean"]["output"];
  handle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  platform: ChannelPlatform;
};

export type PreparedChannelResult = ChannelLookupError | PreparedChannel;

export type Query = {
  __typename?: "Query";
  /** Get App */
  app: LabApp;
  /** Get differences between dev and production */
  appDevDifferences: Array<LabAppDevDifference>;
  /** Get Apps */
  apps: Array<LabApp>;
  /** Query individual artists */
  artist: ArtistQueries;
  /** Query lists of artists */
  artists: ArtistsQueries;
  /** Return analyzed brief */
  briefAnalysis: BriefAnalysis;
  /** Fetch a bulk-download (org-scoped); includes a download link when completed */
  bulkDownload?: Maybe<BulkDownload>;
  /** Query lists of channels */
  channels: ChannelsQueries;
  /** Single clearance assigned to user organization based on provided clearance id */
  clearance: Clearance;
  /** All clearances assigned to user organization optionally filtered by client id */
  clearances: ClearancePage;
  /** Single client assigned to user organization based on provided client id */
  client: Client;
  /** All clients assigned to user organization */
  clients: ClientPage;
  /** Query collections of channels */
  collections: CollectionsQueries;
  /** Get single commercial license */
  commercialLicense: CommercialLicense;
  /** Get commercial licenses */
  commercialLicenses: CommercialLicensePage;
  /** Get datastore records for admin */
  datastoreAdminRecords: LabDatastoreAdminResponse;
  /** Query distribution partner integrations */
  distribution: DistributionQueries;
  /** Get available Gemini models. When labAppId is provided and the app has a GEMINI_API_KEY secret, models are scoped to that key. */
  geminiModels: Array<GeminiModel>;
  /** Single client assigned to user organization based on provided client id extended with assigned clearances */
  getClientDetails?: Maybe<Client>;
  getMsaDocument: MsaDocumentGetResponse;
  getMsaLogEntriesByUserKey?: Maybe<Array<MsaLogEntry>>;
  getMsaProfilesByStatus: Array<Maybe<MsaProfile>>;
  getMsaSurveyResponses?: Maybe<Array<Maybe<MsaLogEntry>>>;
  /** Get a single ingestion job by ID */
  ingestionJob?: Maybe<IngestionJob>;
  /** Get ingestion jobs for the current org with pagination and search */
  ingestionJobs: IngestionJobsResult;
  /** Get ingestion settings for the current org */
  ingestionSettings?: Maybe<IngestionSettingsResult>;
  /** Get Lab Categories */
  labCategories: Array<LabCategory>;
  /** Execute Labs Service Command */
  labsServiceCommand: LabsCommandResult;
  /** Get a legal document by key. When version is supplied, returns that historic version (read-only on the client); otherwise returns the active one. */
  legalDocument: LegalDocument;
  /** Get the change log for a legal document key (newest first) */
  legalDocumentChangeLog: LegalDocumentChangeLogPage;
  /** List legal documents */
  legalDocuments: LegalDocumentPage;
  /** Get single library license */
  libraryLicense: LibraryLicense;
  /** Get list of library licenses */
  libraryLicenses: Array<LibraryLicense>;
  /** Get summary data for library licenses */
  libraryLicensesSummary: LibraryLicensesSummary;
  /** Query lists of notifications */
  notifications: NotificationsQueries;
  /** Get org */
  org: Org;
  /** Classify addresses before inviting: member, inactive, pending or available */
  orgUserInviteLookup: Array<OrgUserInviteLookupResult>;
  /** Get all invites */
  orgUserInvites: OrgUserInvitesPage;
  /** Get all org users */
  orgUsers: OrgUsersPage;
  /** Get orgs assigned to user */
  orgs: OrgsPage;
  /** The current org's payout balance */
  payoutBalance: PayoutBalance;
  /** Payout administration queries */
  payouts: PayoutQueries;
  /** Returns the subset of the requested document keys that the current user still needs to accept. Keys with no active document, or where the user has already accepted the latest version (or any historic version, if requiresReagreement is false), are omitted. */
  pendingLegalAgreements: Array<PendingLegalAgreement>;
  /** Query individual playlists */
  playlist: PlaylistQueries;
  /** Query lists of playlists */
  playlists: PlaylistsQueries;
  /** Get user's recent searches */
  recentSearches: Array<RecentSearch>;
  /** Get a report definition including its parameter options */
  report: ReportDefinition;
  /** Run a report and return only its flat rows, for exports */
  reportRows: Array<Scalars["JSON"]["output"]>;
  /** List all available reports */
  reports: Array<ReportDefinition>;
  /** A single resource by id */
  resource: Resource;
  /** All resources available to the current organization */
  resources: ResourcePage;
  /** Run a report with the given parameter values */
  runReport: ReportResult;
  /** Search for music */
  search: SearchQueries;
  /** Get a shared track resolved from the request's share token */
  sharedTrack?: Maybe<Track>;
  signatureDocument: SignatureDocument;
  signatureDocumentTemplate: SignatureDocumentTemplate;
  /** Single statement assigned to user organization based on provided statement id */
  statement: Statement;
  /** Statement import queries */
  statementImports: StatementImportQueries;
  /** Payment statuses the user organization has statements in */
  statementPaymentStatuses: Array<StatementPaymentStatus>;
  /** Services the user organization has statements for */
  statementServices: Array<Scalars["String"]["output"]>;
  /** Period years for statements assigned to user organization */
  statementYears: Array<Scalars["Int"]["output"]>;
  /** Statements assigned to user organization */
  statements: StatementPage;
  /** Query lists of stems */
  stems: StemsQueries;
  tikTokOembed?: Maybe<TikTokOembed>;
  /** Get a single track by id */
  track?: Maybe<Track>;
  /** Query lists of tracks */
  tracks: TracksQueries;
  user: CurrentUser;
  verifyMsaProfile: MsaProfile;
  youtubeChannel?: Maybe<YouTubeChannelMetadata>;
};

export type QueryAppArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  id: Scalars["String"]["input"];
};

export type QueryAppDevDifferencesArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAppsArgs = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBriefAnalysisArgs = {
  brief: Scalars["String"]["input"];
};

export type QueryBulkDownloadArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryClearanceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryClearancesArgs = {
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platform?: InputMaybe<ClearanceMediaPlatform>;
  sortBy?: InputMaybe<ClearanceSort>;
  status?: InputMaybe<ClearanceStatus>;
  type?: InputMaybe<ClearanceMediaType>;
};

export type QueryClientArgs = {
  clientId: Scalars["ID"]["input"];
};

export type QueryClientsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy?: InputMaybe<ClientSort>;
};

export type QueryCommercialLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type QueryCommercialLicensesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<CommercialLicenseSort>;
  status?: InputMaybe<CommercialLicenseStatus>;
};

export type QueryDatastoreAdminRecordsArgs = {
  input: LabDatastoreAdminQueryInput;
};

export type QueryGeminiModelsArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  labAppId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetClientDetailsArgs = {
  clientId: Scalars["ID"]["input"];
};

export type QueryGetMsaDocumentArgs = {
  key: Scalars["String"]["input"];
};

export type QueryGetMsaLogEntriesByUserKeyArgs = {
  key: Scalars["String"]["input"];
};

export type QueryGetMsaProfilesByStatusArgs = {
  status: MsaProfileStatus;
};

export type QueryIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type QueryIngestionJobsArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLabsServiceCommandArgs = {
  input: LabsCommandInput;
};

export type QueryLegalDocumentArgs = {
  key: Scalars["String"]["input"];
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegalDocumentChangeLogArgs = {
  key: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegalDocumentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLibraryLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLibraryLicensesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<LibraryLicenseSort>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryLibraryLicensesSummaryArgs = {
  query?: InputMaybe<Scalars["String"]["input"]>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryOrgArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryOrgUserInviteLookupArgs = {
  emails: Array<Scalars["String"]["input"]>;
};

export type QueryOrgUserInvitesArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgUserInviteSort>;
};

export type QueryOrgUsersArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryOrgsArgs = {
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgsSort>;
};

export type QueryPendingLegalAgreementsArgs = {
  keys: Array<Scalars["String"]["input"]>;
};

export type QueryRecentSearchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryReportArgs = {
  key: Scalars["String"]["input"];
};

export type QueryReportRowsArgs = {
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<Array<ReportParameterValueInput>>;
};

export type QueryResourceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryResourcesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ResourceSort>;
};

export type QueryRunReportArgs = {
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<Array<ReportParameterValueInput>>;
};

export type QuerySearchArgs = {
  filter?: InputMaybe<Array<SearchFilterInput>>;
  query: Scalars["String"]["input"];
  type: SearchType;
};

export type QuerySignatureDocumentArgs = {
  input: SignatureDocumentQueryInput;
};

export type QuerySignatureDocumentTemplateArgs = {
  templateKey: Scalars["String"]["input"];
};

export type QueryStatementArgs = {
  id: Scalars["String"]["input"];
};

export type QueryStatementsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  months?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  service?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<StatementSort>;
  statuses?: InputMaybe<Array<StatementPaymentStatus>>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryTikTokOembedArgs = {
  url: Scalars["String"]["input"];
};

export type QueryTrackArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVerifyMsaProfileArgs = {
  key: Scalars["String"]["input"];
};

export type QueryYoutubeChannelArgs = {
  url: Scalars["String"]["input"];
};

export type RateLimitConfig = {
  __typename?: "RateLimitConfig";
  /** App-wide rate limit */
  app?: Maybe<RateLimitSettings>;
  /** Per-user rate limit */
  user?: Maybe<RateLimitSettings>;
};

export type RateLimitConfigInput = {
  /** App-wide rate limit */
  app?: InputMaybe<RateLimitSettingsInput>;
  /** Per-user rate limit */
  user?: InputMaybe<RateLimitSettingsInput>;
};

export type RateLimitSettings = {
  __typename?: "RateLimitSettings";
  /** Maximum number of requests */
  maxRequests?: Maybe<Scalars["Int"]["output"]>;
  /** Enable rate limiting */
  useRateLimiting?: Maybe<Scalars["Boolean"]["output"]>;
  /** Time window in seconds */
  windowSeconds?: Maybe<Scalars["Int"]["output"]>;
};

export type RateLimitSettingsInput = {
  /** Maximum number of requests */
  maxRequests?: InputMaybe<Scalars["Int"]["input"]>;
  /** Enable rate limiting */
  useRateLimiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Time window in seconds */
  windowSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RateLimits = {
  __typename?: "RateLimits";
  /** App-wide calls */
  appWide?: Maybe<RateLimitConfig>;
  /** Datastore calls */
  dataStore?: Maybe<RateLimitConfig>;
  /** Gemini AI calls */
  gemini?: Maybe<RateLimitConfig>;
  /** Music Search calls */
  musicSearch?: Maybe<RateLimitConfig>;
};

export type RateLimitsInput = {
  /** App-wide calls */
  appWide?: InputMaybe<RateLimitConfigInput>;
  /** Datastore calls */
  dataStore?: InputMaybe<RateLimitConfigInput>;
  /** Gemini AI calls */
  gemini?: InputMaybe<RateLimitConfigInput>;
  /** Music Search calls */
  musicSearch?: InputMaybe<RateLimitConfigInput>;
};

export type RecentSearch = {
  __typename?: "RecentSearch";
  /** Search filters */
  filter?: Maybe<Array<SearchFilterOutput>>;
  /** Unique identifier for the recent search entry */
  id: Scalars["String"]["output"];
  /** Search query string */
  query: Scalars["String"]["output"];
  /** Search type */
  type: SearchType;
  /** URL search result details */
  urlResult?: Maybe<UrlResult>;
};

export type RecordLegalAgreementInput = {
  /** Labels of every confirmation the user ticked. Must match the document's confirmation labels exactly. */
  acceptedConfirmations: Array<Scalars["String"]["input"]>;
  /** Base64-encoded pipe-joined client fingerprint material (userAgent, screen, timezone, language, cpuClass). Combined with the server-observed client IP to produce an opaque proof-of-client token stored alongside the agreement. */
  clientInfo: Scalars["String"]["input"];
  /** ID of the document version the user is accepting */
  documentId: Scalars["ID"]["input"];
};

export type Release = {
  __typename?: "Release";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ReportColumn = {
  __typename?: "ReportColumn";
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  type: ReportColumnType;
};

export enum ReportColumnType {
  Date = "DATE",
  Number = "NUMBER",
  String = "STRING",
}

export type ReportDefinition = {
  __typename?: "ReportDefinition";
  columns: Array<ReportColumn>;
  description: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  parameters: Array<ReportParameter>;
};

/** A user input of a report. The client renders it as a form field and submits the value as a string. */
export type ReportParameter = {
  __typename?: "ReportParameter";
  /** Default value, serialized as a string */
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  helpText?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Choices for SELECT parameters. Only resolved when a single report is queried. */
  options?: Maybe<Array<ReportParameterOption>>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  type: ReportParameterType;
};

export type ReportParameterOption = {
  __typename?: "ReportParameterOption";
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum ReportParameterType {
  Date = "DATE",
  Number = "NUMBER",
  Select = "SELECT",
  Text = "TEXT",
  Toggle = "TOGGLE",
}

export type ReportParameterValueInput = {
  name: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReportResult = {
  __typename?: "ReportResult";
  columns: Array<ReportColumn>;
  generatedAt: Scalars["DateTime"]["output"];
  key: Scalars["String"]["output"];
  /** One object per row, keyed by column key. Numbers are numbers, dates are ISO strings. */
  rows: Array<Scalars["JSON"]["output"]>;
};

export type Resource = {
  __typename?: "Resource";
  /** Content of the resource */
  content: Array<ResourceContent>;
  /** Description of the resource */
  description: Scalars["String"]["output"];
  /** Title of the resource */
  title: Scalars["String"]["output"];
};

export type ResourceColumns = {
  __typename?: "ResourceColumns";
  /** Any custom text sections in the content item */
  customTextSection?: Maybe<ResourceCustomTextSection>;
  /** Any documents in the content item */
  document?: Maybe<ResourceDocument>;
  /** Any iframes in the content item */
  iframe?: Maybe<ResourceIframe>;
  /** Any music player tracks in the content item */
  musicPlayerTracks?: Maybe<Array<ResourceMusicPlayerTracksItem>>;
  /** Any text sections in the content item */
  textSection?: Maybe<ResourceTextSection>;
  /** Any videos in the content item */
  video?: Maybe<ResourceVideo>;
};

export type ResourceContent = {
  __typename?: "ResourceContent";
  /** Columns of the content item */
  columns: ResourceColumns;
  /** Title of the content item */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Type of the content item */
  type: Scalars["String"]["output"];
};

export type ResourceCustomTextSection = {
  __typename?: "ResourceCustomTextSection";
  /** The portable text of the custom text section (read with react-portable-text) */
  portableText: Array<PortableText>;
  /** The width of the custom text section */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type ResourceDocument = {
  __typename?: "ResourceDocument";
  /** The id of the document */
  id: Scalars["String"]["output"];
  /** Whether the document is downloadable */
  isDownloadable?: Maybe<Scalars["Boolean"]["output"]>;
  /** The title of the document */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The date of the document */
  uploadDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** The URL of the document */
  url: Scalars["String"]["output"];
};

export type ResourceIframe = {
  __typename?: "ResourceIframe";
  /** The URL of the iframe */
  url: Scalars["String"]["output"];
};

export type ResourceList = {
  __typename?: "ResourceList";
  /** Description of the resource */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier for the resource */
  id: Scalars["String"]["output"];
  /** Name of the resource */
  name: Scalars["String"]["output"];
  /** Type of the resource */
  type: Scalars["String"]["output"];
  /** Date of last update */
  updated: Scalars["DateTime"]["output"];
};

export type ResourceMusicPlayerTracksItem = {
  __typename?: "ResourceMusicPlayerTracksItem";
  /** Whether the music player track is downloadable */
  isDownloadable?: Maybe<Scalars["Boolean"]["output"]>;
  /** The title of the music player track */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the music player track */
  url: Scalars["String"]["output"];
};

export type ResourcePage = {
  __typename?: "ResourcePage";
  /** List of resources */
  items: Array<ResourceList>;
  /** Total number of resources */
  total: Scalars["Int"]["output"];
};

export type ResourceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ResourceSortKey>;
};

export enum ResourceSortKey {
  Name = "name",
  Updated = "updated",
}

export type ResourceTextSection = {
  __typename?: "ResourceTextSection";
  /** The description of the text section */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The title of the text section */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The width of the text section */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type ResourceVideo = {
  __typename?: "ResourceVideo";
  /** The URL of the video */
  url?: Maybe<Scalars["String"]["output"]>;
  /** The width of the video */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type SavedMediaFile = {
  __typename?: "SavedMediaFile";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
  uploadComplete: Scalars["Boolean"]["output"];
};

export type SavedMediaFileInput = {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  uploadComplete: Scalars["Boolean"]["input"];
};

export type SearchArgs = {
  __typename?: "SearchArgs";
  /** Search filters */
  filter?: Maybe<Array<SearchFilterOutput>>;
  /** Search query string */
  query: Scalars["String"]["output"];
  /** Search type */
  type: SearchType;
};

export type SearchFilterInput = {
  name: SearchFilterName;
  values: Array<Scalars["String"]["input"]>;
};

export enum SearchFilterName {
  AllComposersInApprovedSocieties = "all_composers_in_approved_societies",
  Arousal = "arousal",
  AudienceAges = "audience_ages",
  AudienceGender = "audience_gender",
  AudienceRegions = "audience_regions",
  Bpm = "bpm",
  BrandAttributes = "brand_attributes",
  Content = "content",
  Curateability = "curateability",
  Duration = "duration",
  Energy = "energy",
  Engagement = "engagement",
  Explicit = "explicit",
  Grooviness = "grooviness",
  Harmony = "harmony",
  IndustrySuitability = "industry_suitability",
  Instruments = "instruments",
  Key = "key",
  Level1Genres = "level1_genres",
  Level2Genres = "level2_genres",
  Loudness = "loudness",
  Moods = "moods",
  OriginDecade = "origin_decade",
  OriginRegion = "origin_region",
  PlayerLevel1Genres = "player_level1_genres",
  PlayerLevel2Genres = "player_level2_genres",
  Pleasantness = "pleasantness",
  RecordingEnvironment = "recording_environment",
  Rhythm = "rhythm",
  Roughness = "roughness",
  Scale = "scale",
  SongRating = "song_rating",
  SoundGeneration = "sound_generation",
  Space = "space",
  Tempo = "tempo",
  Texture = "texture",
  Timbre = "timbre",
  Tonality = "tonality",
  UseCases = "use_cases",
  Valence = "valence",
  Vocals = "vocals",
  YoutubeSafe = "youtube_safe",
}

export type SearchFilterOutput = {
  __typename?: "SearchFilterOutput";
  name: SearchFilterName;
  values: Array<Scalars["String"]["output"]>;
};

export type SearchQueries = {
  __typename?: "SearchQueries";
  /** The args passed to search */
  args: SearchArgs;
  /** Paginated list of playlists that match the search criteria */
  playlists?: Maybe<Array<Playlist>>;
  /** Search summary with total count and URL analysis */
  summary?: Maybe<SearchSummary>;
  /** Paginated list of tracks that match the search criteria */
  tracks?: Maybe<Array<Track>>;
};

export type SearchQueriesPlaylistsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy?: InputMaybe<SearchSortKey>;
  sortDirection?: InputMaybe<SearchSortDirection>;
};

export type SearchQueriesSummaryArgs = {
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<SearchSortKey>;
  sortDirection?: InputMaybe<SearchSortDirection>;
};

export enum SearchSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum SearchSortKey {
  Artist = "artist",
  BestMatch = "best_match",
  Duration = "duration",
  Name = "name",
  Quality = "quality",
  Title = "title",
}

export type SearchSummary = {
  __typename?: "SearchSummary";
  /** Similar track if the search was a similar tracks search, otherwise null */
  similarTo?: Maybe<Track>;
  /** Total number of tracks based on filters */
  total: Scalars["Int"]["output"];
  /** URL search result details if the search query was a URL and could be analyzed, otherwise null */
  urlResult?: Maybe<UrlResult>;
};

export enum SearchType {
  Reference = "REFERENCE",
  Similar = "SIMILAR",
  SmartSearch = "SMART_SEARCH",
  TracksArtists = "TRACKS_ARTISTS",
}

export enum SessionEvent {
  Clear = "Clear",
  MobileSigningInProgress = "MobileSigningInProgress",
}

export type SessionUpdate = {
  __typename?: "SessionUpdate";
  event: SessionEvent;
};

export enum ShareResourceType {
  Artist = "artist",
  Playlist = "playlist",
  Track = "track",
}

export type SharedArtistQueries = {
  __typename?: "SharedArtistQueries";
  /** Get artist details from share token */
  details?: Maybe<Artist>;
  /** Get paginated tracks for a shared artist */
  tracks?: Maybe<TracksPage>;
};

export type SharedArtistQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SharedPlaylistQueries = {
  __typename?: "SharedPlaylistQueries";
  /** Get a shared playlist resolved from the request's share token */
  details?: Maybe<Playlist>;
  /** Get a shared playlist's tracks resolved from the request's share token */
  tracks?: Maybe<TracksPage>;
};

export type SharedPlaylistQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SignatoryCreateResponse = {
  __typename?: "SignatoryCreateResponse";
  signatoryCompanyName?: Maybe<Scalars["String"]["output"]>;
  signatoryFirstName: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
  signatoryLastName: Scalars["String"]["output"];
  signatoryUrl: Scalars["String"]["output"];
};

export enum SignatoryStatus {
  Declined = "Declined",
  Expired = "Expired",
  Pending = "Pending",
  Signed = "Signed",
}

export type SignatureDocument = {
  __typename?: "SignatureDocument";
  declineRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["String"]["output"];
  hideWelcomeDialog?: Maybe<Scalars["Boolean"]["output"]>;
  pdfBase64: Scalars["String"]["output"];
  sessionId?: Maybe<Scalars["String"]["output"]>;
  signatories: Array<SignatureDocumentSignatory>;
  status: SignatureDocumentStatus;
  successRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  templateKey: Scalars["String"]["output"];
  userConfirmData?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SignatureDocumentCreateInput = {
  declineRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  expiresInSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  hideWelcomeDialog?: InputMaybe<Scalars["Boolean"]["input"]>;
  signatories: Array<SignatureDocumentSignatoryInput>;
  successRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  templateKey: Scalars["String"]["input"];
  userConfirmData?: InputMaybe<Scalars["Boolean"]["input"]>;
  webhookUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureDocumentCreateResponse = {
  __typename?: "SignatureDocumentCreateResponse";
  documentId: Scalars["String"]["output"];
  documentUrls?: Maybe<Array<SignatoryCreateResponse>>;
};

export type SignatureDocumentDeclineInput = {
  declineReasons: Array<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentDeclineReason = {
  __typename?: "SignatureDocumentDeclineReason";
  reasonKey: Scalars["String"]["output"];
  reasonText: Scalars["String"]["output"];
};

export type SignatureDocumentDeclineReasonInput = {
  reasonKey: Scalars["String"]["input"];
  reasonText: Scalars["String"]["input"];
};

export type SignatureDocumentQueryInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  mobileSigningInProgress?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentSignInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
  signatureBase64: Scalars["String"]["input"];
};

export type SignatureDocumentSignatory = {
  __typename?: "SignatureDocumentSignatory";
  companyName?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
  status: SignatoryStatus;
};

export type SignatureDocumentSignatoryInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryUpdateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryUpdateResponse = {
  __typename?: "SignatureDocumentSignatoryUpdateResponse";
  documentId: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
};

export enum SignatureDocumentStatus {
  Declined = "Declined",
  Expired = "Expired",
  Pending = "Pending",
  Signed = "Signed",
}

export type SignatureDocumentTemplate = {
  __typename?: "SignatureDocumentTemplate";
  declineReasons: Array<SignatureDocumentDeclineReason>;
  description: Scalars["String"]["output"];
  internalNotificationEmails?: Maybe<Array<Scalars["String"]["output"]>>;
  templateKey: Scalars["String"]["output"];
};

export type SignatureDocumentTemplateCreateInput = {
  declineReasons: Array<SignatureDocumentDeclineReasonInput>;
  description: Scalars["String"]["input"];
  internalNotificationEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pdfUrl: Scalars["String"]["input"];
  templateKey: Scalars["String"]["input"];
};

export enum SortDirection {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
  None = "NONE",
}

export type SsoUser = {
  __typename?: "SsoUser";
  /** Email address */
  email: Scalars["String"]["output"];
  /** Full name */
  fullName: Scalars["String"]["output"];
  /** User sub (cognito ID) */
  userSub: Scalars["ID"]["output"];
};

export type Statement = {
  __typename?: "Statement";
  /** Statement details */
  details: Array<StatementDetail>;
  /** Statement ID */
  id: Scalars["String"]["output"];
  /** Statement additional information */
  information?: Maybe<Scalars["String"]["output"]>;
  /** Statement issued date */
  issued: Scalars["DateTime"]["output"];
  /** Statement net revenue */
  netRevenue: Scalars["Float"]["output"];
  /** Organization ID */
  orgId: Scalars["String"]["output"];
  /** Organization name (resolved via SSO) */
  orgName?: Maybe<Scalars["String"]["output"]>;
  /** Statement payment */
  payment: StatementPayment;
  /** Statement period */
  period: Array<Scalars["DateTime"]["output"]>;
  /** Statement report */
  report: StatementReport;
  /** Statement service (ex. YouTube) */
  service: Scalars["String"]["output"];
  /** Statement source */
  source: StatementSource;
};

export type StatementCreateInput = {
  /** Statement details */
  details: Array<StatementDetailCreateInput>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued: Scalars["DateTime"]["input"];
  /** Statement net revenue */
  netRevenue: Scalars["Float"]["input"];
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment: StatementPaymentCreateInput;
  /** Statement period */
  period: Array<Scalars["DateTime"]["input"]>;
  /** Statement report */
  report: StatementReportCreateInput;
  /** Statement service */
  service: Scalars["String"]["input"];
  /** Statement source */
  source: StatementSourceCreateInput;
};

export type StatementDetail = {
  __typename?: "StatementDetail";
  /** Detail label */
  label: Scalars["String"]["output"];
  /** Detail value */
  value: Scalars["String"]["output"];
};

export type StatementDetailCreateInput = {
  /** Detail label */
  label: Scalars["String"]["input"];
  /** Detail value */
  value: Scalars["String"]["input"];
};

export type StatementImportBatch = {
  __typename?: "StatementImportBatch";
  /** Batch creation date */
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who created the batch */
  createUser?: Maybe<SsoUser>;
  /** Currency of the file */
  currency: Scalars["String"]["output"];
  /** Error message when the batch failed */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Original file name */
  fileName: Scalars["String"]["output"];
  /** Import format the file was processed with */
  format: ImportFormat;
  /** Batch ID */
  id: Scalars["String"]["output"];
  /** Whether a Parsing/Generating batch has stopped updating (crashed) and can be recovered */
  isStale: Scalars["Boolean"]["output"];
  /** Distinct period IDs found in the file */
  periodIds: Array<Scalars["String"]["output"]>;
  /** Current counts/amounts of included rows (computed live) */
  selection?: Maybe<StatementImportSelection>;
  /** File rows left out because they have no numeric SongtradrUserID */
  skippedRows: Array<StatementImportSkippedRow>;
  /** Batch lifecycle status */
  status: ImportBatchStatus;
  /** Parse-time totals */
  totals: StatementImportTotals;
  /** Non-fatal warnings collected while processing */
  warnings: Array<Scalars["String"]["output"]>;
};

export type StatementImportCreateBatchInput = {
  /** S3 key of the uploaded file */
  fileKey: Scalars["String"]["input"];
  /** Original file name */
  fileName: Scalars["String"]["input"];
  /** Import format to process the file with */
  format: ImportFormat;
};

export type StatementImportData = {
  __typename?: "StatementImportData";
  /** Royalty balance */
  amount: Scalars["Float"]["output"];
  /** Beneficiary code from the file */
  beneficiaryCode: Scalars["String"]["output"];
  /** Matched company name */
  companyName?: Maybe<Scalars["String"]["output"]>;
  /** Row currency */
  currency: Scalars["String"]["output"];
  /** Matched contact email */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** External user id from the file (source company id) */
  externalUserId: Scalars["Int"]["output"];
  /** Data row ID */
  id: Scalars["String"]["output"];
  /** Whether the row is included in generation/payment */
  included: Scalars["Boolean"]["output"];
  /** Matched organization id */
  matchedOrgId?: Maybe<Scalars["String"]["output"]>;
  /** Accounting period id from the file */
  periodId: Scalars["String"]["output"];
  /** Generated statement id */
  statementId?: Maybe<Scalars["String"]["output"]>;
  /** Statement reference from the file */
  statementReference?: Maybe<Scalars["String"]["output"]>;
  /** Row lifecycle status */
  status: ImportDataStatus;
};

export type StatementImportDataPage = {
  __typename?: "StatementImportDataPage";
  /** List of import data rows */
  items: Array<StatementImportData>;
  /** Sum of amounts of all rows matching the filter */
  totalAmount: Scalars["Float"]["output"];
  /** Total number of rows matching the filter */
  totalCount: Scalars["Int"]["output"];
};

export type StatementImportDataSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementImportDataSortKey>;
};

export enum StatementImportDataSortKey {
  Amount = "amount",
  BeneficiaryCode = "beneficiaryCode",
  PeriodId = "periodId",
  Status = "status",
}

export type StatementImportQueries = {
  __typename?: "StatementImportQueries";
  /** Single statement import batch */
  batch?: Maybe<StatementImportBatch>;
  /** Statement import batches, newest first */
  batches?: Maybe<Array<StatementImportBatch>>;
  /** Data rows of a statement import batch */
  data?: Maybe<StatementImportDataPage>;
};

export type StatementImportQueriesBatchArgs = {
  id: Scalars["String"]["input"];
};

export type StatementImportQueriesBatchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type StatementImportQueriesDataArgs = {
  batchId: Scalars["String"]["input"];
  includedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<StatementImportDataSort>;
  statuses?: InputMaybe<Array<ImportDataStatus>>;
};

export type StatementImportSelection = {
  __typename?: "StatementImportSelection";
  /** Total amount of included rows pending statement generation */
  generateAmount: Scalars["Float"]["output"];
  /** Included rows pending statement generation */
  generateCount: Scalars["Int"]["output"];
  /** Rows whose statement has been paid */
  paidCount: Scalars["Int"]["output"];
  /** Total amount of included rows with a statement, pending payment */
  payAmount: Scalars["Float"]["output"];
  /** Included rows with a statement, pending payment */
  payCount: Scalars["Int"]["output"];
  /** Rows with a generated statement (any payment state, included or not) */
  statementCount: Scalars["Int"]["output"];
};

export type StatementImportSkippedRow = {
  __typename?: "StatementImportSkippedRow";
  /** Royalty balance */
  amount: Scalars["Float"]["output"];
  /** Beneficiary code from the file */
  beneficiaryCode: Scalars["String"]["output"];
  /** Row number in the file */
  rowNumber: Scalars["Int"]["output"];
};

export type StatementImportTotals = {
  __typename?: "StatementImportTotals";
  /** Rows matched to an org via a source connection */
  matchedCount: Scalars["Int"]["output"];
  /** Number of data rows in the file */
  rowCount: Scalars["Int"]["output"];
  /** Sum of all royalty balances */
  totalAmount: Scalars["Float"]["output"];
  /** Rows without a matching source connection */
  unmatchedCount: Scalars["Int"]["output"];
  /** Rows with a zero royalty balance */
  zeroBalanceCount: Scalars["Int"]["output"];
};

export type StatementPage = {
  __typename?: "StatementPage";
  /** List of statements */
  items: Array<Statement>;
  /** Total number of statements */
  total: Scalars["Int"]["output"];
};

export type StatementPayment = {
  __typename?: "StatementPayment";
  /** Payment date */
  date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Payment status */
  status: StatementPaymentStatus;
};

export type StatementPaymentCreateInput = {
  /** Payment date */
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Payment status; Pending is derived from payouts and rejected here */
  status: StatementPaymentStatus;
};

export enum StatementPaymentStatus {
  Adjustment = "Adjustment",
  Paid = "Paid",
  /** In a payout that hasn't been paid yet */
  Pending = "Pending",
  /** Paid out, then returned by Trolley; its amount is back in the balance */
  Returned = "Returned",
  Unpaid = "Unpaid",
}

export type StatementReport = {
  __typename?: "StatementReport";
  /** Report file object */
  file?: Maybe<StatementReportFile>;
  /** Report file source URL */
  sourceUrl: Scalars["String"]["output"];
};

export type StatementReportCreateInput = {
  /** Report file object */
  file: StatementReportFileCreateInput;
  /** Report file source URL */
  sourceUrl: Scalars["String"]["input"];
};

export type StatementReportFile = {
  __typename?: "StatementReportFile";
  /** File extension */
  extension: Scalars["String"]["output"];
  /** S3 file key */
  key: Scalars["String"]["output"];
  /** Temporary URL */
  temporaryUrl?: Maybe<Scalars["String"]["output"]>;
};

export type StatementReportFileCreateInput = {
  /** File extension */
  extension: Scalars["String"]["input"];
};

export type StatementSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementSortKey>;
};

export enum StatementSortKey {
  Issued = "issued",
  NetRevenue = "netRevenue",
  Period = "period",
}

export type StatementSource = {
  __typename?: "StatementSource";
  /** Source ID */
  id: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type StatementSourceCreateInput = {
  /** Source app ID */
  id: Scalars["String"]["input"];
  /** Source app type */
  type: Scalars["String"]["input"];
};

export type StatementUpdateInput = {
  /** Statement details */
  details?: InputMaybe<Array<InputMaybe<StatementDetailCreateInput>>>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Statement net revenue */
  netRevenue?: InputMaybe<Scalars["Float"]["input"]>;
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment?: InputMaybe<StatementPaymentCreateInput>;
  /** Statement period */
  period?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  /** Statement service */
  service?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement source */
  source?: InputMaybe<StatementSourceCreateInput>;
};

export type Stem = {
  __typename?: "Stem";
  /** Requested output format */
  format: StemOutputFormat;
  /** Stem record ID */
  id: Scalars["ID"]["output"];
  /** Provider-agnostic model identifier */
  modelId: Scalars["String"]["output"];
  /** Provider task ID */
  providerTaskId: Scalars["ID"]["output"];
  /** Our S3 object key once the file has been persisted */
  s3Key?: Maybe<Scalars["String"]["output"]>;
  /** Current processing status */
  status: StemStatus;
  /** Source track ID */
  trackId: Scalars["ID"]["output"];
};

export enum StemOutputFormat {
  Mp3 = "mp3",
  Wav = "wav",
}

export enum StemStatus {
  Completed = "completed",
  Error = "error",
  Processing = "processing",
}

export type StemsQueries = {
  __typename?: "StemsQueries";
  /** Get stems by id */
  byId?: Maybe<Array<Stem>>;
};

export type StemsQueriesByIdArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  documentUpdated: Scalars["Boolean"]["output"];
  newNotification: Scalars["Boolean"]["output"];
  sessionUpdated?: Maybe<SessionUpdate>;
};

export type SubscriptionDocumentUpdatedArgs = {
  documentId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SubscriptionSessionUpdatedArgs = {
  sessionId: Scalars["String"]["input"];
};

export type TikTokOembed = {
  __typename?: "TikTokOembed";
  html?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type Track = {
  __typename?: "Track";
  /** Track characteristics derived from tag strengths */
  analysis?: Maybe<TrackAnalysis>;
  /** Track artist */
  artists: Array<Artist>;
  /** Track URL */
  audioUrls: AudioUrls;
  /** Track Curator */
  curator?: Maybe<Curator>;
  /** Get track to download by id */
  downloadLink?: Maybe<Scalars["String"]["output"]>;
  /** Track Duration */
  duration: Scalars["Int"]["output"];
  /** Track genres */
  genres: Scalars["String"]["output"];
  /** Track ID */
  id: Scalars["ID"]["output"];
  /** Track Image GUID */
  imageGuid?: Maybe<Scalars["String"]["output"]>;
  /** Track Image URL */
  imageUrl: Scalars["String"]["output"];
  /**
   * Legacy data
   * @deprecated Field no longer supported
   */
  legacy?: Maybe<TrackLegacy>;
  /** Album or release associated with the track, if available */
  release?: Maybe<Release>;
  /** Per-moment energy intensity samples across the track's duration, used to draw the dynamic overlay on its waveform */
  taggrams?: Maybe<Array<TrackTaggram>>;
  /** Track title */
  title: Scalars["String"]["output"];
  /** Track Traits */
  traits: TrackTraits;
  /** Track type - null for a base track, set for variants like stems */
  type?: Maybe<TrackType>;
  /** Current User's Track Metadata */
  userMeta?: Maybe<TrackUserMeta>;
  /** Track Waveform */
  waveform: Waveform;
  /** Track Waveform URL */
  waveformUrl?: Maybe<Scalars["String"]["output"]>;
};

export type TrackDownloadLinkArgs = {
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<DownloadType>;
};

export type TrackImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type TrackAnalysis = {
  __typename?: "TrackAnalysis";
  characteristics: TrackCharacteristics;
  visuals: TrackVisuals;
};

export type TrackCharacteristics = {
  __typename?: "TrackCharacteristics";
  ageAffinity?: Maybe<Array<Scalars["String"]["output"]>>;
  bpm?: Maybe<Scalars["Int"]["output"]>;
  decade?: Maybe<Scalars["String"]["output"]>;
  genderAffinity?: Maybe<Scalars["String"]["output"]>;
  genre?: Maybe<Scalars["String"]["output"]>;
  instruments?: Maybe<Array<Scalars["String"]["output"]>>;
  key?: Maybe<Scalars["String"]["output"]>;
  mood?: Maybe<Array<Scalars["String"]["output"]>>;
  regionAffinity?: Maybe<Array<Scalars["String"]["output"]>>;
  tempo?: Maybe<Scalars["String"]["output"]>;
  useCasePredictions?: Maybe<Array<Scalars["String"]["output"]>>;
  vocals?: Maybe<Scalars["String"]["output"]>;
};

export type TrackLegacy = {
  __typename?: "TrackLegacy";
  liked?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum TrackSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum TrackSortKey {
  Title = "title",
}

export type TrackTaggram = {
  __typename?: "TrackTaggram";
  intensity: Scalars["Float"]["output"];
  key: Scalars["String"]["output"];
};

export type TrackTraits = {
  __typename?: "TrackTraits";
  explicit?: Maybe<Scalars["Boolean"]["output"]>;
  vocals?: Maybe<Scalars["Boolean"]["output"]>;
  youtubeSafe?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum TrackType {
  Stem = "stem",
}

export type TrackUserMeta = {
  __typename?: "TrackUserMeta";
  /** Liked by current user */
  liked?: Maybe<Scalars["Boolean"]["output"]>;
};

export type TrackVisualDataPoint = {
  __typename?: "TrackVisualDataPoint";
  label: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type TrackVisuals = {
  __typename?: "TrackVisuals";
  ageAffinity: Array<TrackVisualDataPoint>;
  genderAffinity: Array<TrackVisualDataPoint>;
  genres: Array<TrackVisualDataPoint>;
  moods: Array<TrackVisualDataPoint>;
  regionAffinity: Array<TrackVisualDataPoint>;
  subGenres: Array<TrackVisualDataPoint>;
};

export type TracksPage = {
  __typename?: "TracksPage";
  items: Array<Track>;
  total: Scalars["Int"]["output"];
};

export type TracksQueries = {
  __typename?: "TracksQueries";
  /** Get list of tracks by id */
  byId?: Maybe<Array<Track>>;
  /** Get downloaded tracks for the current user, or for the whole organization */
  downloaded?: Maybe<TracksPage>;
  /** Get featured tracks */
  featured?: Maybe<Array<Track>>;
  /** Get liked tracks for the current user */
  liked?: Maybe<TracksPage>;
  /** Get recently played tracks for the current user */
  recent?: Maybe<TracksPage>;
  /** Get similar tracks to a track */
  similar?: Maybe<Array<Track>>;
};

export type TracksQueriesByIdArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type TracksQueriesDownloadedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  scope?: InputMaybe<DownloadsScope>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesFeaturedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TracksQueriesLikedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesSimilarArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  trackId: Scalars["ID"]["input"];
};

export type UpdateClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client ID */
  id: Scalars["ID"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export type UpdateIngestionJobInput = {
  csvOriginalFilename?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportId?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  dromoSessionId?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["ID"]["input"];
  jobName?: InputMaybe<Scalars["String"]["input"]>;
  licensorDpid?: InputMaybe<Scalars["String"]["input"]>;
  mappingSnapshot?: InputMaybe<Scalars["JSON"]["input"]>;
  mediaFiles?: InputMaybe<Array<SavedMediaFileInput>>;
  metadataRowCount?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<IngestionJobStatus>;
};

export type UpdateLegalDocumentInput = {
  confirmations?: InputMaybe<Array<LegalConfirmationInput>>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  effectiveDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  requiresReagreement?: InputMaybe<Scalars["Boolean"]["input"]>;
  requiresScrollToAccept?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateOrgDetailsInput = {
  metadata: UpdateOrgDetailsMetadataInput;
  /** Org name */
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdateOrgDetailsMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Analytics Heap enabled */
  analyticsHeapEnabled: Scalars["Boolean"]["input"];
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
  /** Org HubSpot IDs. Used to link the org to it's counterpart in the HubSpot system. */
  hubSpotIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Org billing email address */
  payoutsBillingEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Minimum payout in USD cents, at least the platform minimum. Null resets it to the default; omitted keeps it. */
  payoutsMinimumPayoutCents?: InputMaybe<Scalars["Int"]["input"]>;
  /** Org Trolley reference ID. Custom identifier that can be assigned to an entity when creating it within Trolley's system. By default, it is the same as the organization ID. */
  payoutsTrolleyRefId: Scalars["ID"]["input"];
  priceEstimationCurrency?: InputMaybe<Scalars["Currency"]["input"]>;
  priceEstimationInstagramFollowers?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketCap?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketSymbol?: InputMaybe<Scalars["String"]["input"]>;
  priceEstimationNumberOfEmployees?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationPublicCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  priceEstimationTikTokFollowers?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateOrgModulesInput = {
  /** Metadata for modules settings */
  metadata: UpdateOrgModulesMetadataInput;
  /** List of modules to be enabled for the organization */
  modules: Array<UpdateOrgModulesModuleInput>;
};

export type UpdateOrgModulesMetadataInput = {
  adaptiveMusicUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateOrgModulesModuleInput = {
  name: Scalars["String"]["input"];
  value: Scalars["Boolean"]["input"];
};

export type UrlResult = {
  __typename?: "UrlResult";
  /** Artists of the track if the search was a URL search and the artists could be extracted */
  artists?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Platform specific identifier for the track (e.g. Spotify ID, YouTube ID) */
  id?: Maybe<Scalars["String"]["output"]>;
  /** International Standard Recording Code of the track */
  isrc?: Maybe<Scalars["String"]["output"]>;
  /** Title of the track if the search was a URL search and the title could be extracted */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Type of URL (e.g. Spotify, YouTube) */
  type?: Maybe<Scalars["String"]["output"]>;
  /** The original URL that was searched */
  url: Scalars["String"]["output"];
};

export enum UrlType {
  Spotify = "Spotify",
  YouTube = "YouTube",
}

export enum UserActionLogSource {
  Artist = "ARTIST",
  CuratedPlaylist = "CURATED_PLAYLIST",
  Library = "LIBRARY",
  Other = "OTHER",
  Playlist = "PLAYLIST",
  Search = "SEARCH",
}

export type UserOrg = {
  __typename?: "UserOrg";
  /** Org ID */
  id: Scalars["ID"]["output"];
  /** Org name */
  name: Scalars["String"]["output"];
  /** Parent Org ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Workspace */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export enum UserPlaylistsSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum UserPlaylistsSortKey {
  Name = "name",
}

/** The current org's subscription (not the user's own), whichever system bills it */
export type UserSubscription = {
  __typename?: "UserSubscription";
  /** Whether the org's subscription is currently active */
  isActive: Scalars["Boolean"]["output"];
  /** External page to view and manage the org's subscription; null when it is not self-managed */
  manageUrl?: Maybe<Scalars["String"]["output"]>;
  /** Plan in force for the org, e.g. Songtradr PRO; null without an active plan */
  name?: Maybe<Scalars["String"]["output"]>;
  /** System billing the org's subscription */
  provider: UserSubscriptionProvider;
  /** Plans the org can subscribe to; empty while its subscription is active */
  subscribePlans: Array<UserSubscriptionPlan>;
};

/** How an add-on's price tiers add up */
export enum UserSubscriptionAddOnPricing {
  /** Every unit at one price */
  Flat = "flat",
  /** The price of the tier the total quantity falls in, as a whole */
  Stairstep = "stairstep",
  /** Each unit at the price of the tier it falls in */
  Tiered = "tiered",
  /** Every unit at the price of the tier the total quantity falls in */
  Volume = "volume",
}

/** Price per unit up to a quantity */
export type UserSubscriptionAddOnTier = {
  __typename?: "UserSubscriptionAddOnTier";
  /** Last quantity at this price; null when unbounded */
  endingQuantity?: Maybe<Scalars["Int"]["output"]>;
  /** Price per unit, in the plan's currency */
  unitAmount: Scalars["Float"]["output"];
};

/** A plan the org can subscribe to on an external checkout page */
export type UserSubscriptionPlan = {
  __typename?: "UserSubscriptionPlan";
  /** Number of artists to distribute, chosen before checkout; null when the plan has a fixed number */
  artistsAddOn?: Maybe<UserSubscriptionPlanAddOn>;
  /** Months per billing period, e.g. 1 or 12; null when not month-based */
  billingMonths?: Maybe<Scalars["Int"]["output"]>;
  /** ISO 4217 currency of the price, e.g. USD */
  currency?: Maybe<Scalars["String"]["output"]>;
  /** Number of artists the plan covers at most; null when unknown */
  maxArtists?: Maybe<Scalars["Int"]["output"]>;
  /** Plan name, e.g. Songtradr Pro - Monthly */
  name: Scalars["String"]["output"];
  /** Price per billing period before add-ons and tax; null when unknown */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** External checkout page subscribing the org to this plan (add-on quantities go in its query string) */
  subscribeUrl: Scalars["String"]["output"];
};

/** A quantity-priced add-on chosen before checkout, e.g. the number of artists */
export type UserSubscriptionPlanAddOn = {
  __typename?: "UserSubscriptionPlanAddOn";
  /** Add-on code the checkout page expects */
  code: Scalars["String"]["output"];
  /** Quantity to start with */
  defaultQuantity: Scalars["Int"]["output"];
  /** Largest quantity that can be chosen */
  maxQuantity: Scalars["Int"]["output"];
  /** How the tiers add up */
  pricing: UserSubscriptionAddOnPricing;
  /** Price tiers, ascending by quantity */
  tiers: Array<UserSubscriptionAddOnTier>;
};

/** The system a subscription is billed in */
export enum UserSubscriptionProvider {
  /** Legacy marketplace subscription, carried over from before the migration */
  LegacyMarketplace = "LegacyMarketplace",
}

export type ValidateFilesInput = {
  catalogUploadId: Scalars["String"]["input"];
  filenames: Array<Scalars["String"]["input"]>;
};

export type Waveform = {
  __typename?: "Waveform";
  data: Array<Scalars["Int"]["output"]>;
  length: Scalars["Int"]["output"];
};

export type YouTubeChannelMetadata = {
  __typename?: "YouTubeChannelMetadata";
  canonical?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DistributionSigninLinkQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DistributionSigninLinkQuery = {
  __typename?: "Query";
  distribution: {
    __typename?: "DistributionQueries";
    signinLink?: {
      __typename?: "DistributionSigninLinkResult";
      url: string;
    } | null;
  };
};

export type SourceSigninQueryVariables = Exact<{ [key: string]: never }>;

export type SourceSigninQuery = {
  __typename?: "Query";
  user: {
    __typename?: "CurrentUser";
    id: string;
    subscription?: {
      __typename?: "UserSubscription";
      isActive: boolean;
    } | null;
  };
};

export type SubscribeQueryVariables = Exact<{ [key: string]: never }>;

export type SubscribeQuery = {
  __typename?: "Query";
  user: {
    __typename?: "CurrentUser";
    id: string;
    subscription?: {
      __typename?: "UserSubscription";
      isActive: boolean;
      manageUrl?: string | null;
      subscribePlans: Array<{
        __typename?: "UserSubscriptionPlan";
        name: string;
        price?: number | null;
        currency?: string | null;
        billingMonths?: number | null;
        maxArtists?: number | null;
        subscribeUrl: string;
        artistsAddOn?: {
          __typename?: "UserSubscriptionPlanAddOn";
          code: string;
          defaultQuantity: number;
          maxQuantity: number;
          pricing: UserSubscriptionAddOnPricing;
          tiers: Array<{
            __typename?: "UserSubscriptionAddOnTier";
            endingQuantity?: number | null;
            unitAmount: number;
          }>;
        } | null;
      }>;
    } | null;
  };
};

export type LabsDatastoreSaveCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsDatastoreSaveCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | {
        __typename?: "LabsCommandDatastoreResponse";
        id?: string | null;
        success?: boolean | null;
      }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsDatastoreLoadCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsDatastoreLoadCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | {
        __typename?: "LabsCommandDatastoreResponse";
        id?: string | null;
        data?: any | null;
      }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsDatastoreSearchCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsDatastoreSearchCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | {
        __typename?: "LabsCommandDatastoreResponse";
        total?: number | null;
        items?: Array<{
          __typename?: "LabsCommandDatastoreItem";
          id: string;
          data: any;
        }> | null;
      }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsDatastoreDeleteCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsDatastoreDeleteCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse"; success?: boolean | null }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsDatastoreCountCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsDatastoreCountCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse"; total?: number | null }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsServiceCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsServiceCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse" }
    | {
        __typename?: "LabsCommandGeminiResponse";
        text: string;
        finishReason?: string | null;
      }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsServiceCommandInitQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsServiceCommandInitQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse" }
    | { __typename?: "LabsCommandGeminiResponse" }
    | {
        __typename?: "LabsCommandInitResponse";
        authToken: string;
        roles: Array<string>;
      }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsServiceCommandLogErrorQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsServiceCommandLogErrorQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse" }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse"; success: boolean }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsMusicSearchCommandQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsMusicSearchCommandQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse" }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | {
        __typename?: "LabsCommandMusicSearchResponse";
        total: number;
        tracks: Array<{
          __typename?: "Track";
          id: string;
          title: string;
          imageUrl: string;
          duration: number;
          artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
          traits: {
            __typename?: "TrackTraits";
            youtubeSafe?: boolean | null;
            explicit?: boolean | null;
            vocals?: boolean | null;
          };
          audioUrls: {
            __typename?: "AudioUrls";
            low: string;
            normal: string;
            high: string;
            veryHigh: string;
          };
          waveform: {
            __typename?: "Waveform";
            length: number;
            data: Array<number>;
          };
          userMeta?: {
            __typename?: "TrackUserMeta";
            liked?: boolean | null;
          } | null;
        }>;
      }
    | { __typename?: "LabsCommandUserActionLogResponse" };
};

export type LabsServiceCommandUserActionLogQueryVariables = Exact<{
  input: LabsCommandInput;
}>;

export type LabsServiceCommandUserActionLogQuery = {
  __typename?: "Query";
  labsServiceCommand:
    | { __typename?: "LabsCommandDatastoreResponse" }
    | { __typename?: "LabsCommandGeminiResponse" }
    | { __typename?: "LabsCommandInitResponse" }
    | { __typename?: "LabsCommandLogErrorResponse" }
    | { __typename?: "LabsCommandMusicSearchResponse" }
    | { __typename?: "LabsCommandUserActionLogResponse"; success: boolean };
};

export type LabAppEditQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  env?: InputMaybe<LabAppEnvironment>;
}>;

export type LabAppEditQuery = {
  __typename?: "Query";
  app: {
    __typename?: "LabApp";
    id: string;
    status: LabAppStatus;
    label: string;
    displayOrder?: number | null;
    description: string;
    icon?: string | null;
    hostingUrl: string;
    localDevelopmentUrl?: string | null;
    repositoryLink?: string | null;
    apiKey: string;
    bridgeKey: string;
    labsVersion: LabsVersion;
    hideBottomBar: boolean;
    allowFullscreen: boolean;
    defaultViewInDraftMode?: DefaultViewInDraftMode | null;
    categoryId?: string | null;
    linkedAppId?: string | null;
    env: LabAppEnvironment;
    access: Array<{
      __typename?: "LabAppAccess";
      label: string;
      value: string;
    }>;
    roles: Array<{
      __typename?: "LabAppRole";
      roleId: string;
      members: Array<{
        __typename?: "LabAppRoleMember";
        label: string;
        value: string;
      }>;
    }>;
    parameters: Array<{
      __typename?: "LabAppParameter";
      key: string;
      value: string;
    }>;
    secrets: Array<{
      __typename?: "LabAppParameter";
      key: string;
      value: string;
    }>;
    legalDocuments: Array<{ __typename?: "LabAppLegalDocument"; key: string }>;
    modules: {
      __typename?: "LabAppModules";
      gemini: boolean;
      geminiModel?: string | null;
      musicSearch: boolean;
      dataStore: boolean;
      heapTracking?: boolean | null;
    };
    datastoreTables: Array<{
      __typename?: "LabDatastoreTable";
      tableName: string;
      scope: LabDatastoreScope;
      replaceDataOnMerge?: boolean | null;
      fields: Array<{
        __typename?: "LabDatastoreFieldDefinition";
        name: string;
        type: LabDatastoreFieldType;
        required?: boolean | null;
        searchable?: boolean | null;
        caseInsensitive?: boolean | null;
      }>;
    }>;
    rateLimits?: {
      __typename?: "RateLimits";
      appWide?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      gemini?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      musicSearch?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      dataStore?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
    } | null;
  };
  labCategories: Array<{
    __typename?: "LabCategory";
    id: string;
    name: string;
    slug: string;
    sortOrder: number;
  }>;
  geminiModels: Array<{
    __typename?: "GeminiModel";
    name: string;
    displayName?: string | null;
  }>;
};

export type LabAppEditSaveMutationVariables = Exact<{
  input: LabAppInput;
  env?: InputMaybe<LabAppEnvironment>;
}>;

export type LabAppEditSaveMutation = {
  __typename?: "Mutation";
  updateApp: {
    __typename?: "LabApp";
    id: string;
    status: LabAppStatus;
    label: string;
    displayOrder?: number | null;
    description: string;
    icon?: string | null;
    hostingUrl: string;
    localDevelopmentUrl?: string | null;
    repositoryLink?: string | null;
    labsVersion: LabsVersion;
    hideBottomBar: boolean;
    allowFullscreen: boolean;
    defaultViewInDraftMode?: DefaultViewInDraftMode | null;
    categoryId?: string | null;
    access: Array<{
      __typename?: "LabAppAccess";
      label: string;
      value: string;
    }>;
    roles: Array<{
      __typename?: "LabAppRole";
      roleId: string;
      members: Array<{
        __typename?: "LabAppRoleMember";
        label: string;
        value: string;
      }>;
    }>;
    parameters: Array<{
      __typename?: "LabAppParameter";
      key: string;
      value: string;
    }>;
    secrets: Array<{
      __typename?: "LabAppParameter";
      key: string;
      value: string;
    }>;
    legalDocuments: Array<{ __typename?: "LabAppLegalDocument"; key: string }>;
    modules: {
      __typename?: "LabAppModules";
      gemini: boolean;
      geminiModel?: string | null;
      musicSearch: boolean;
      dataStore: boolean;
      heapTracking?: boolean | null;
    };
    datastoreTables: Array<{
      __typename?: "LabDatastoreTable";
      tableName: string;
      scope: LabDatastoreScope;
      replaceDataOnMerge?: boolean | null;
      fields: Array<{
        __typename?: "LabDatastoreFieldDefinition";
        name: string;
        type: LabDatastoreFieldType;
        required?: boolean | null;
        searchable?: boolean | null;
        caseInsensitive?: boolean | null;
      }>;
    }>;
    rateLimits?: {
      __typename?: "RateLimits";
      appWide?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      gemini?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      musicSearch?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
      dataStore?: {
        __typename?: "RateLimitConfig";
        app?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
        user?: {
          __typename?: "RateLimitSettings";
          useRateLimiting?: boolean | null;
          maxRequests?: number | null;
          windowSeconds?: number | null;
        } | null;
      } | null;
    } | null;
  };
};

export type LabAppEditMergeDevMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type LabAppEditMergeDevMutation = {
  __typename?: "Mutation";
  mergeDevToProduction: {
    __typename?: "LabApp";
    id: string;
    status: LabAppStatus;
    label: string;
  };
};

export type LabAppEditDevDifferencesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type LabAppEditDevDifferencesQuery = {
  __typename?: "Query";
  appDevDifferences: Array<{
    __typename?: "LabAppDevDifference";
    field: string;
    prodValue?: string | null;
    devValue?: string | null;
    records?: Array<{
      __typename?: "LabAppDevDifferenceRecord";
      id: string;
      changeType: string;
      prodData?: string | null;
      devData?: string | null;
    }> | null;
  }>;
};

export type LabAppEditRevertDevFieldMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  field: Scalars["String"]["input"];
}>;

export type LabAppEditRevertDevFieldMutation = {
  __typename?: "Mutation";
  revertDevField: boolean;
};

export type AccessSelectDialog_OrgsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccessSelectDialog_OrgsQuery = {
  __typename?: "Query";
  orgs: {
    __typename?: "OrgsPage";
    total: number;
    orgs: Array<{ __typename?: "Org"; id: string; name: string }>;
  };
};

export type AccessSelectDialog_UsersQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccessSelectDialog_UsersQuery = {
  __typename?: "Query";
  orgUsers: {
    __typename?: "OrgUsersPage";
    total: number;
    users: Array<{
      __typename?: "OrgUser";
      id: string;
      name: string;
      email: string;
    }>;
  };
};

export type LabAppEditLegalDocumentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LabAppEditLegalDocumentsQuery = {
  __typename?: "Query";
  legalDocuments: {
    __typename?: "LegalDocumentPage";
    items: Array<{
      __typename?: "LegalDocument";
      id: string;
      key: string;
      name: string;
    }>;
  };
};

export type LabAppQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  env?: InputMaybe<LabAppEnvironment>;
}>;

export type LabAppQuery = {
  __typename?: "Query";
  app: {
    __typename?: "LabApp";
    id: string;
    status: LabAppStatus;
    label: string;
    icon?: string | null;
    hostingUrl: string;
    lastUpdatedOn: any;
    hideBottomBar: boolean;
    allowFullscreen: boolean;
    defaultViewInDraftMode?: DefaultViewInDraftMode | null;
    localDevelopmentUrl?: string | null;
    latestLabsPackageVersion?: string | null;
    labsVersion: LabsVersion;
    env: LabAppEnvironment;
    parametersEncoded?: Array<{
      __typename?: "LabAppParameter";
      key: string;
      value: string;
    }> | null;
    legalDocuments: Array<{ __typename?: "LabAppLegalDocument"; key: string }>;
    modules: {
      __typename?: "LabAppModules";
      gemini: boolean;
      musicSearch: boolean;
      dataStore: boolean;
      heapTracking?: boolean | null;
    };
  };
};

export type LabAppsQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LabAppsQuery = {
  __typename?: "Query";
  apps: Array<{
    __typename?: "LabApp";
    id: string;
    status: LabAppStatus;
    label: string;
    description: string;
    icon?: string | null;
    categoryId?: string | null;
    isFavorited: boolean;
  }>;
  labCategories: Array<{
    __typename?: "LabCategory";
    id: string;
    name: string;
    slug: string;
    sortOrder: number;
  }>;
};

export type LabAppsDeleteMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type LabAppsDeleteMutation = {
  __typename?: "Mutation";
  deleteApp: { __typename?: "LabAppDeleteResponse"; id: string };
};

export type LabAppsCreateMutationVariables = Exact<{
  label: Scalars["String"]["input"];
}>;

export type LabAppsCreateMutation = {
  __typename?: "Mutation";
  createApp: { __typename?: "LabApp"; id: string };
};

export type LabAppsAddFavoriteMutationVariables = Exact<{
  labAppId: Scalars["String"]["input"];
}>;

export type LabAppsAddFavoriteMutation = {
  __typename?: "Mutation";
  addLabAppFavorite: boolean;
};

export type LabAppsDeleteFavoriteMutationVariables = Exact<{
  labAppId: Scalars["String"]["input"];
}>;

export type LabAppsDeleteFavoriteMutation = {
  __typename?: "Mutation";
  deleteLabAppFavorite: boolean;
};

export type LabAppsUpdateCategoriesMutationVariables = Exact<{
  input: Array<LabCategoryInput> | LabCategoryInput;
}>;

export type LabAppsUpdateCategoriesMutation = {
  __typename?: "Mutation";
  updateLabCategories: Array<{
    __typename?: "LabCategory";
    id: string;
    name: string;
    slug: string;
    sortOrder: number;
  }>;
};

export type DatastoreAdminRecordsQueryVariables = Exact<{
  input: LabDatastoreAdminQueryInput;
  labAppId: Scalars["String"]["input"];
  env?: InputMaybe<LabAppEnvironment>;
}>;

export type DatastoreAdminRecordsQuery = {
  __typename?: "Query";
  datastoreAdminRecords: {
    __typename?: "LabDatastoreAdminResponse";
    total?: number | null;
    items: Array<{
      __typename?: "LabDatastoreAdminRecord";
      id: string;
      userId?: string | null;
      scope: LabDatastoreScope;
      data: any;
    }>;
  };
  app: {
    __typename?: "LabApp";
    label: string;
    datastoreTables: Array<{
      __typename?: "LabDatastoreTable";
      tableName: string;
      scope: LabDatastoreScope;
      fields: Array<{
        __typename?: "LabDatastoreFieldDefinition";
        name: string;
        type: LabDatastoreFieldType;
        required?: boolean | null;
      }>;
    }>;
  };
};

export type DatastoreAdminUpdateMutationVariables = Exact<{
  input: LabDatastoreAdminUpdateInput;
}>;

export type DatastoreAdminUpdateMutation = {
  __typename?: "Mutation";
  updateDatastoreAdminRecord: {
    __typename?: "LabDatastoreAdminRecord";
    id: string;
    userId?: string | null;
    scope: LabDatastoreScope;
    data: any;
  };
};

export type DatastoreAdminDeleteMutationVariables = Exact<{
  input: LabDatastoreAdminDeleteInput;
}>;

export type DatastoreAdminDeleteMutation = {
  __typename?: "Mutation";
  deleteDatastoreAdminRecords: {
    __typename?: "LabsCommandDatastoreResponse";
    success?: boolean | null;
  };
};

export type DatastoreAdminCreateMutationVariables = Exact<{
  input: LabDatastoreAdminCreateInput;
}>;

export type DatastoreAdminCreateMutation = {
  __typename?: "Mutation";
  createDatastoreAdminRecord: {
    __typename?: "LabDatastoreAdminRecord";
    id: string;
    userId?: string | null;
    scope: LabDatastoreScope;
    data: any;
  };
};

export type LegalAgreementPendingQueryVariables = Exact<{
  keys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type LegalAgreementPendingQuery = {
  __typename?: "Query";
  pendingLegalAgreements: Array<{
    __typename?: "PendingLegalAgreement";
    documentId: string;
    key: string;
    name: string;
    version: number;
    requiresScrollToAccept: boolean;
    content: string;
    effectiveDate: any;
    previousAcceptedVersion?: number | null;
    confirmations: Array<{ __typename?: "LegalConfirmation"; label: string }>;
  }>;
};

export type LegalAgreementRecordMutationVariables = Exact<{
  input: RecordLegalAgreementInput;
}>;

export type LegalAgreementRecordMutation = {
  __typename?: "Mutation";
  recordLegalAgreement: {
    __typename?: "LegalAgreementRecord";
    id: string;
    key: string;
    version: number;
    agreedAt: any;
  };
};

export type LegalDocumentEditQueryVariables = Exact<{
  key: Scalars["String"]["input"];
  version?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LegalDocumentEditQuery = {
  __typename?: "Query";
  legalDocument: {
    __typename?: "LegalDocument";
    id: string;
    key: string;
    name: string;
    effectiveDate: any;
    version: number;
    active: boolean;
    previousVersionId?: string | null;
    requiresReagreement: boolean;
    requiresScrollToAccept: boolean;
    content: string;
    createDate?: any | null;
    changeDate?: any | null;
    changedByUser?: {
      __typename?: "SsoUser";
      userSub: string;
      fullName: string;
      email: string;
    } | null;
    confirmations: Array<{ __typename?: "LegalConfirmation"; label: string }>;
  };
};

export type LegalDocumentEditSaveMutationVariables = Exact<{
  key: Scalars["String"]["input"];
  input: UpdateLegalDocumentInput;
}>;

export type LegalDocumentEditSaveMutation = {
  __typename?: "Mutation";
  updateLegalDocument: {
    __typename?: "LegalDocument";
    id: string;
    key: string;
    name: string;
    effectiveDate: any;
    version: number;
    active: boolean;
    previousVersionId?: string | null;
    requiresReagreement: boolean;
    requiresScrollToAccept: boolean;
    content: string;
    createDate?: any | null;
    changeDate?: any | null;
    changedByUser?: {
      __typename?: "SsoUser";
      userSub: string;
      fullName: string;
      email: string;
    } | null;
    confirmations: Array<{ __typename?: "LegalConfirmation"; label: string }>;
  };
};

export type LegalDocumentHistoryQueryVariables = Exact<{
  key: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LegalDocumentHistoryQuery = {
  __typename?: "Query";
  legalDocumentChangeLog: {
    __typename?: "LegalDocumentChangeLogPage";
    total: number;
    items: Array<{
      __typename?: "LegalDocumentChangeLogEntry";
      id: string;
      version: number;
      summary: Array<string>;
      createdAt: any;
      user?: {
        __typename?: "SsoUser";
        userSub: string;
        fullName: string;
        email: string;
      } | null;
    }>;
  };
};

export type LegalCreateDocumentMutationVariables = Exact<{
  input: CreateLegalDocumentInput;
}>;

export type LegalCreateDocumentMutation = {
  __typename?: "Mutation";
  createLegalDocument: {
    __typename?: "LegalDocument";
    id: string;
    key: string;
  };
};

export type LegalDocumentsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LegalDocumentsListQuery = {
  __typename?: "Query";
  legalDocuments: {
    __typename?: "LegalDocumentPage";
    total: number;
    items: Array<{
      __typename?: "LegalDocument";
      id: string;
      key: string;
      name: string;
      version: number;
      effectiveDate: any;
      changeDate?: any | null;
      createDate?: any | null;
      requiresReagreement: boolean;
    }>;
  };
};

export type LegalDocumentsDeleteMutationVariables = Exact<{
  key: Scalars["String"]["input"];
}>;

export type LegalDocumentsDeleteMutation = {
  __typename?: "Mutation";
  deleteLegalDocument: boolean;
};

export type TrackPlayerFragmentFragment = {
  __typename?: "CommercialLicenseTrackAttachment";
  name: string;
  url: string;
} & { " $fragmentName"?: "TrackPlayerFragmentFragment" };

export type CommercialLicensesQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  status?: InputMaybe<CommercialLicenseStatus>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<CommercialLicenseSort>;
}>;

export type CommercialLicensesQuery = {
  __typename?: "Query";
  commercialLicenses: {
    __typename?: "CommercialLicensePage";
    total: number;
    items: Array<{
      __typename?: "CommercialLicense";
      id: string;
      brand: string;
      tracks?: Array<{
        __typename?: "CommercialLicenseTrack";
        name: string;
      }> | null;
      terms?: Array<{
        __typename?: "CommercialLicenseTerm";
        mediaType: string;
        startDate?: any | null;
        status: CommercialLicenseStatus;
        timeRemaining: string;
        territories: {
          __typename?: "CommercialLicenseTerritories";
          included: Array<string>;
        };
      }> | null;
    }>;
  };
};

export type LibraryLicensesSummaryQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
}>;

export type LibraryLicensesSummaryQuery = {
  __typename?: "Query";
  libraryLicensesSummary: {
    __typename?: "LibraryLicensesSummary";
    total: number;
    years: Array<number>;
  } & {
    " $fragmentRefs"?: {
      LibraryLicensesSummary_YearsFragment: LibraryLicensesSummary_YearsFragment;
    };
  };
};

export type LibraryLicensesQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  sortBy?: InputMaybe<LibraryLicenseSort>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
}>;

export type LibraryLicensesQuery = {
  __typename?: "Query";
  libraryLicenses: Array<{
    __typename?: "LibraryLicense";
    id: string;
    projectName: string;
    projectDescription?: string | null;
    trackTitle: string;
    trackArtist: string;
    goLiveDate: any;
    downloadLink?: string | null;
    orgName?: string | null;
    declaredByUser: { __typename?: "LibraryLicenseUser"; name: string };
  }>;
};

export type LibraryLicensesExportButtonQueryVariables = Exact<{
  sortBy?: InputMaybe<LibraryLicenseSort>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
}>;

export type LibraryLicensesExportButtonQuery = {
  __typename?: "Query";
  libraryLicenses: Array<{
    __typename?: "LibraryLicense";
    trackId: string;
    trackTitle: string;
    trackArtist: string;
    declaredDate: any;
    projectName: string;
    projectDescription?: string | null;
    businessBrand?: string | null;
    regions: Array<string>;
    goLiveDate: any;
    downloadedByUser: {
      __typename?: "LibraryLicenseUser";
      name: string;
      email: string;
    };
    declaredByUser: {
      __typename?: "LibraryLicenseUser";
      name: string;
      email: string;
    };
    channels: Array<{
      __typename?: "LibraryLicenseDeclaredUsageChannel";
      name?: string | null;
    }>;
  }>;
};

export type LibraryLicensesSummary_YearsFragment = {
  __typename?: "LibraryLicensesSummary";
  years: Array<number>;
} & { " $fragmentName"?: "LibraryLicensesSummary_YearsFragment" };

export type ViewCommercialLicenseQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ViewCommercialLicenseQuery = {
  __typename?: "Query";
  commercialLicense: { __typename?: "CommercialLicense" } & {
    " $fragmentRefs"?: {
      CommercialLicenseHeaderFragment: CommercialLicenseHeaderFragment;
      CommercialLicenseTracksFragment: CommercialLicenseTracksFragment;
      CommercialLicenseTermsFragment: CommercialLicenseTermsFragment;
      CommercialLicenseServicesFragment: CommercialLicenseServicesFragment;
      CommercialLicenseDocumentsFragment: CommercialLicenseDocumentsFragment;
      CommercialLicenseContactsFragment: CommercialLicenseContactsFragment;
    };
  };
};

export type CommercialLicenseContactsFragment = {
  __typename?: "CommercialLicense";
  contacts?: {
    __typename?: "CommercialLicenseContacts";
    projectLeads?: Array<{
      __typename?: "CommercialLicenseContact";
      name: string;
      email: string;
    }> | null;
    additionalContacts?: Array<{
      __typename?: "CommercialLicenseContact";
      name: string;
      email: string;
    }> | null;
  } | null;
} & { " $fragmentName"?: "CommercialLicenseContactsFragment" };

export type CommercialLicenseDocumentsFragment = {
  __typename?: "CommercialLicense";
  documents?: Array<{
    __typename?: "CommercialLicenseDocument";
    id: string;
    type: string;
    name: string;
    uploadDate: any;
    url: string;
  }> | null;
} & { " $fragmentName"?: "CommercialLicenseDocumentsFragment" };

export type CommercialLicenseHeaderFragment = {
  __typename?: "CommercialLicense";
  id: string;
  campaignName: string;
} & { " $fragmentName"?: "CommercialLicenseHeaderFragment" };

export type CommercialLicenseServicesFragment = {
  __typename?: "CommercialLicense";
  services?: Array<{
    __typename?: "CommercialLicenseService";
    id: string;
    serviceType: string;
    musicType: string;
    cost: number;
    currencyCode: string;
  }> | null;
} & { " $fragmentName"?: "CommercialLicenseServicesFragment" };

export type CommercialLicenseTermsFragment = {
  __typename?: "CommercialLicense";
  terms?: Array<
    {
      __typename?: "CommercialLicenseTerm";
      name: string;
      duration: string;
      status: CommercialLicenseStatus;
      timeRemaining: string;
    } & {
      " $fragmentRefs"?: {
        CommercialLicenseTermFragmentFragment: CommercialLicenseTermFragmentFragment;
      };
    }
  > | null;
} & { " $fragmentName"?: "CommercialLicenseTermsFragment" };

export type CommercialLicenseTermFragmentFragment = {
  __typename?: "CommercialLicenseTerm";
  startDate?: any | null;
  endDate?: any | null;
  mediaType: string;
  finalTracks: Array<string>;
  territories: {
    __typename?: "CommercialLicenseTerritories";
    included: Array<string>;
  };
} & { " $fragmentName"?: "CommercialLicenseTermFragmentFragment" };

export type CommercialLicenseTracksFragment = {
  __typename?: "CommercialLicense";
  tracks?: Array<
    { __typename?: "CommercialLicenseTrack"; name: string; artist: string } & {
      " $fragmentRefs"?: { TrackAttachmentsFragment: TrackAttachmentsFragment };
    }
  > | null;
} & { " $fragmentName"?: "CommercialLicenseTracksFragment" };

export type TrackAttachmentsFragment = {
  __typename?: "CommercialLicenseTrack";
  attachments?: Array<
    { __typename?: "CommercialLicenseTrackAttachment" } & {
      " $fragmentRefs"?: {
        TrackPlayerFragmentFragment: TrackPlayerFragmentFragment;
      };
    }
  > | null;
} & { " $fragmentName"?: "TrackAttachmentsFragment" };

export type ViewLibraryLicenseQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ViewLibraryLicenseQuery = {
  __typename?: "Query";
  libraryLicense: {
    __typename?: "LibraryLicense";
    id: string;
    trackId: string;
    trackTitle: string;
    trackArtist: string;
    orgId: string;
    declaredDate: any;
    goLiveDate: any;
    projectName: string;
    regions: Array<string>;
    projectDescription?: string | null;
    businessBrand?: string | null;
    downloadLink?: string | null;
    downloadedByUser: {
      __typename?: "LibraryLicenseUser";
      id: string;
      email: string;
      name: string;
    };
    declaredByUser: {
      __typename?: "LibraryLicenseUser";
      id: string;
      email: string;
      name: string;
    };
    channels: Array<{
      __typename?: "LibraryLicenseDeclaredUsageChannel";
      type: LibraryLicenseChannelType;
      usageLinks?: Array<string | null> | null;
      name?: string | null;
      url?: string | null;
    }>;
  };
};

export type MsaLayoutQueryVariables = Exact<{
  key: Scalars["String"]["input"];
}>;

export type MsaLayoutQuery = {
  __typename?: "Query";
  verifyMsaProfile: {
    __typename?: "MsaProfile";
    key: string;
    status: MsaProfileStatus;
    firstName: string;
    monetizationPreference: MsaMonetizationPreference;
    documentSelection: MsaDocumentSelection;
  };
};

export type MsaLayoutUpdateStatusMutationVariables = Exact<{
  input: MsaProfileStatusUpdateInput;
}>;

export type MsaLayoutUpdateStatusMutation = {
  __typename?: "Mutation";
  updateMsaProfileStatus: {
    __typename?: "MsaProfile";
    key: string;
    status: MsaProfileStatus;
  };
};

export type MsaDashboardCreateDocumentMutationVariables = Exact<{
  input: MsaDocumentCreateInput;
}>;

export type MsaDashboardCreateDocumentMutation = {
  __typename?: "Mutation";
  createMsaDocument: { __typename?: "MsaDocumentCreateResponse"; url: string };
};

export type CatalogUpdateMsaProfileDocumentSelectionMutationVariables = Exact<{
  input: MsaProfileDocumentSelectionUpdateInput;
}>;

export type CatalogUpdateMsaProfileDocumentSelectionMutation = {
  __typename?: "Mutation";
  updateMsaProfileDocumentSelection: {
    __typename?: "MsaProfile";
    key: string;
    documentSelection: MsaDocumentSelection;
  };
};

export type MonetizationSelectionUpdatePreferenceMutationVariables = Exact<{
  input: MsaProfileMonetizationPrefUpdateInput;
}>;

export type MonetizationSelectionUpdatePreferenceMutation = {
  __typename?: "Mutation";
  updateMsaProfileMonetizationPref: {
    __typename?: "MsaProfile";
    key: string;
    monetizationPreference: MsaMonetizationPreference;
  };
};

export type SurveyDeclineAddSurveyLogEntryMutationVariables = Exact<{
  input: MsaSurveyLogEntryInput;
}>;

export type SurveyDeclineAddSurveyLogEntryMutation = {
  __typename?: "Mutation";
  addMsaSurveyLogEntry: { __typename: "MsaLogEntry" };
};

export type SignedQueryVariables = Exact<{
  key: Scalars["String"]["input"];
}>;

export type SignedQuery = {
  __typename?: "Query";
  getMsaDocument: { __typename?: "MsaDocumentGetResponse"; url: string };
};

export type MsaContextLogActionMutationVariables = Exact<{
  input: MsaLogEntryInput;
}>;

export type MsaContextLogActionMutation = {
  __typename?: "Mutation";
  addMsaLogEntry: { __typename: "MsaLogEntry" };
};

export type DownloadQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  type: DownloadType;
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DownloadQuery = {
  __typename?: "Query";
  track?: { __typename?: "Track"; downloadLink?: string | null } | null;
};

export type LikeAddMutationVariables = Exact<{
  itemId: Scalars["ID"]["input"];
  itemType: LikeItemsType;
}>;

export type LikeAddMutation = { __typename?: "Mutation"; addLikes: boolean };

export type LikeDeleteMutationVariables = Exact<{
  itemId: Scalars["ID"]["input"];
  itemType: LikeItemsType;
}>;

export type LikeDeleteMutation = {
  __typename?: "Mutation";
  deleteLikes: boolean;
};

export type AddTracksToPlaylistsMutationVariables = Exact<{
  trackIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  playlistIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AddTracksToPlaylistsMutation = {
  __typename?: "Mutation";
  addTracksToPlaylists: boolean;
};

export type RemoveTracksFromPlaylistsMutationVariables = Exact<{
  trackIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  playlistIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type RemoveTracksFromPlaylistsMutation = {
  __typename?: "Mutation";
  removeTracksFromPlaylists: boolean;
};

export type CreateShareTokenMutationVariables = Exact<{
  input: CreateShareTokenInput;
}>;

export type CreateShareTokenMutation = {
  __typename?: "Mutation";
  createShareToken: string;
};

export type BulkDownloadMutationVariables = Exact<{
  referenceIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  referenceType: BulkDownloadReferenceType;
  referenceFormat: BulkDownloadReferenceFormat;
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type BulkDownloadMutation = {
  __typename?: "Mutation";
  bulkDownload: {
    __typename?: "BulkDownload";
    id: string;
    status: BulkDownloadStatus;
  };
};

export type BulkLikeStateQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type BulkLikeStateQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    byId?: Array<{
      __typename?: "Track";
      id: string;
      userMeta?: {
        __typename?: "TrackUserMeta";
        liked?: boolean | null;
      } | null;
    }> | null;
  };
};

export type BulkLikeAddMutationVariables = Exact<{
  itemIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  itemType: LikeItemsType;
}>;

export type BulkLikeAddMutation = {
  __typename?: "Mutation";
  addLikes: boolean;
};

export type BulkLikeDeleteMutationVariables = Exact<{
  itemIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  itemType: LikeItemsType;
}>;

export type BulkLikeDeleteMutation = {
  __typename?: "Mutation";
  deleteLikes: boolean;
};

export type ReorderPlaylistTracksMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  trackIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type ReorderPlaylistTracksMutation = {
  __typename?: "Mutation";
  reorderPlaylistTracks: {
    __typename?: "Playlist";
    id: string;
    trackIds: Array<string>;
  };
};

export type MoveBulkButtonPlaylistOrderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type MoveBulkButtonPlaylistOrderQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistQueries";
    byId?: {
      __typename?: "Playlist";
      id: string;
      trackIds: Array<string>;
    } | null;
  };
};

export type ArtistGalleryFragment = ({ __typename?: "Artist"; id: string } & {
  " $fragmentRefs"?: { ArtistGalleryTileFragment: ArtistGalleryTileFragment };
}) & { " $fragmentName"?: "ArtistGalleryFragment" };

export type PlaylistGalleryFragment = ({
  __typename?: "Playlist";
  id: string;
} & {
  " $fragmentRefs"?: {
    PlaylistGalleryTileFragment: PlaylistGalleryTileFragment;
  };
}) & { " $fragmentName"?: "PlaylistGalleryFragment" };

export type PlaylistGalleryTileFragment = {
  __typename?: "Playlist";
  id: string;
  name: string;
  imageUrl: string;
  trackIds: Array<string>;
  tracks: {
    __typename?: "TracksPage";
    items: Array<
      { __typename?: "Track" } & {
        " $fragmentRefs"?: {
          AudioContextTrackFragment: AudioContextTrackFragment;
        };
      }
    >;
  };
} & { " $fragmentName"?: "PlaylistGalleryTileFragment" };

export type ArtistGalleryTileFragment = {
  __typename?: "Artist";
  id: string;
  name: string;
  imageUrl?: string | null;
  trackIds?: Array<string> | null;
  tracks?: Array<
    { __typename?: "Track" } & {
      " $fragmentRefs"?: {
        AudioContextTrackFragment: AudioContextTrackFragment;
      };
    }
  > | null;
} & { " $fragmentName"?: "ArtistGalleryTileFragment" };

export type TrackActionsFragment = {
  __typename?: "Track";
  id: string;
  title: string;
  imageUrl: string;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
  traits: {
    __typename?: "TrackTraits";
    youtubeSafe?: boolean | null;
    explicit?: boolean | null;
    vocals?: boolean | null;
  };
  userMeta?: { __typename?: "TrackUserMeta"; liked?: boolean | null } | null;
} & { " $fragmentName"?: "TrackActionsFragment" };

export type TrackListFragment = ({ __typename?: "Track"; id: string } & {
  " $fragmentRefs"?: {
    TrackFragment: TrackFragment;
    TrackActionsFragment: TrackActionsFragment;
    AudioContextTrackFragment: AudioContextTrackFragment;
  };
}) & { " $fragmentName"?: "TrackListFragment" };

export type TrackFragment = {
  __typename?: "Track";
  id: string;
  title: string;
  imageUrl: string;
  duration: number;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
  traits: {
    __typename?: "TrackTraits";
    youtubeSafe?: boolean | null;
    explicit?: boolean | null;
    vocals?: boolean | null;
  };
  waveform: { __typename?: "Waveform"; length: number; data: Array<number> };
} & { " $fragmentName"?: "TrackFragment" };

export type UpsertPlaylistMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  imageS3Key?: InputMaybe<Scalars["String"]["input"]>;
  shareable?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpsertPlaylistMutation = {
  __typename?: "Mutation";
  upsertPlaylist: {
    __typename?: "Playlist";
    id: string;
    name: string;
    description?: string | null;
    imageUrl: string;
    shareable: boolean;
  };
};

export type TrackPreview_TaggramsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TrackPreview_TaggramsQuery = {
  __typename?: "Query";
  track?: {
    __typename?: "Track";
    id: string;
    taggrams?: Array<{
      __typename?: "TrackTaggram";
      key: string;
      intensity: number;
    }> | null;
  } | null;
};

export type AudioContextUserPlaylistsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AudioContextUserPlaylistsQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    user?: Array<{
      __typename?: "Playlist";
      id: string;
      name: string;
      createdBy?: string | null;
      imageUrl: string;
      trackIds: Array<string>;
      shareable: boolean;
    }> | null;
    team?: Array<{
      __typename?: "Playlist";
      id: string;
      name: string;
      createdBy?: string | null;
      imageUrl: string;
      trackIds: Array<string>;
      shareable: boolean;
    }> | null;
  };
};

export type AudioContextTracksQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AudioContextTracksQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    byId?: Array<
      { __typename?: "Track" } & {
        " $fragmentRefs"?: {
          AudioContextTrackFragment: AudioContextTrackFragment;
        };
      }
    > | null;
  };
};

export type AudioContextTrackQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AudioContextTrackQuery = {
  __typename?: "Query";
  track?:
    | ({ __typename?: "Track" } & {
        " $fragmentRefs"?: {
          AudioContextTrackFragment: AudioContextTrackFragment;
        };
      })
    | null;
};

export type AudioContextTrackFragment = {
  __typename?: "Track";
  id: string;
  title: string;
  imageUrl: string;
  duration: number;
  release?: { __typename?: "Release"; id: string; title: string } | null;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
  audioUrls: {
    __typename?: "AudioUrls";
    low: string;
    normal: string;
    high: string;
    veryHigh: string;
  };
  traits: {
    __typename?: "TrackTraits";
    youtubeSafe?: boolean | null;
    explicit?: boolean | null;
    vocals?: boolean | null;
  };
  waveform: { __typename?: "Waveform"; length: number; data: Array<number> };
  userMeta?: { __typename?: "TrackUserMeta"; liked?: boolean | null } | null;
} & { " $fragmentName"?: "AudioContextTrackFragment" };

export type DeactivateChannelsMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DeactivateChannelsMutation = {
  __typename?: "Mutation";
  deactivateChannels: Array<{ __typename?: "Channel"; id: string }>;
};

export type AddChannelsQueryVariables = Exact<{
  input: Array<ChannelLookupInput> | ChannelLookupInput;
}>;

export type AddChannelsQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    prepared?: Array<
      | { __typename: "ChannelLookupError"; url: string }
      | {
          __typename: "PreparedChannel";
          id: string;
          name: string;
          platform: ChannelPlatform;
          imageUrl?: string | null;
          channelTitle?: string | null;
          handle?: string | null;
          duplicate: boolean;
        }
    > | null;
  };
};

export type ConnectChannelsMutationVariables = Exact<{
  input: Array<ConnectChannelInput> | ConnectChannelInput;
  collectionIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
}>;

export type ConnectChannelsMutation = {
  __typename?: "Mutation";
  connectChannels: Array<{
    __typename?: "Channel";
    id: string;
    name: string;
    platform: ChannelPlatform;
    imageUrl?: string | null;
  }>;
};

export type AddCollections_CreateMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  channelIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
}>;

export type AddCollections_CreateMutation = {
  __typename?: "Mutation";
  createCollection: {
    __typename?: "Collection";
    id: string;
    name: string;
    numberOfChannels: number;
  };
};

export type CollectionChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type CollectionChannelsQuery = {
  __typename?: "Query";
  collections: {
    __typename?: "CollectionsQueries";
    all?: {
      __typename?: "CollectionsPage";
      items: Array<{
        __typename?: "Collection";
        id: string;
        name: string;
        numberOfChannels: number;
        channelIds: Array<string>;
      }>;
    } | null;
  };
};

export type AddChannelsToCollectionsMutationVariables = Exact<{
  channelIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  collectionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AddChannelsToCollectionsMutation = {
  __typename?: "Mutation";
  addChannelsToCollections: Array<{
    __typename?: "Collection";
    id: string;
    numberOfChannels: number;
    channelIds: Array<string>;
  }>;
};

export type RemoveChannelsFromCollectionsMutationVariables = Exact<{
  channelIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  collectionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type RemoveChannelsFromCollectionsMutation = {
  __typename?: "Mutation";
  removeChannelsFromCollections: Array<{
    __typename?: "Collection";
    id: string;
    numberOfChannels: number;
    channelIds: Array<string>;
  }>;
};

export type ChannelsQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform> | ChannelPlatform>;
}>;

export type ChannelsQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    connected?: {
      __typename?: "ChannelsPage";
      total: number;
      items: Array<{
        __typename?: "Channel";
        id: string;
        name: string;
        platform: ChannelPlatform;
        imageUrl?: string | null;
        handle?: string | null;
        url?: string | null;
      }>;
    } | null;
  };
};

export type ChannelsExportQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
}>;

export type ChannelsExportQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    connected?: {
      __typename?: "ChannelsPage";
      items: Array<{
        __typename?: "Channel";
        id: string;
        name: string;
        platform: ChannelPlatform;
        handle?: string | null;
      }>;
    } | null;
  };
};

export type SelectedChannelsExportQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SelectedChannelsExportQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    byIds?: Array<{
      __typename?: "Channel";
      id: string;
      name: string;
      platform: ChannelPlatform;
      handle?: string | null;
    }> | null;
  };
};

export type CollectionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform> | ChannelPlatform>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CollectionsQuery = {
  __typename?: "Query";
  collections: {
    __typename?: "CollectionsQueries";
    all?: {
      __typename?: "CollectionsPage";
      total: number;
      items: Array<{
        __typename?: "Collection";
        id: string;
        name: string;
        numberOfChannels: number;
        channels: {
          __typename?: "ChannelsPage";
          items: Array<{ __typename?: "Channel"; platform: ChannelPlatform }>;
        };
      }>;
    } | null;
  };
};

export type DeleteCollectionsMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DeleteCollectionsMutation = {
  __typename?: "Mutation";
  deleteCollections: Array<string>;
};

export type DownloadCollectionsQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DownloadCollectionsQuery = {
  __typename?: "Query";
  collections: {
    __typename?: "CollectionsQueries";
    byIds?: Array<{
      __typename?: "Collection";
      name: string;
      channels: {
        __typename?: "ChannelsPage";
        items: Array<{ __typename?: "Channel"; name: string }>;
      };
    }> | null;
  };
};

export type DuplicateCollectionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DuplicateCollectionMutation = {
  __typename?: "Mutation";
  duplicateCollection: { __typename?: "Collection"; id: string; name: string };
};

export type RenameCollectionPanel_FragmentFragment = {
  __typename?: "Collection";
  id: string;
  name: string;
} & { " $fragmentName"?: "RenameCollectionPanel_FragmentFragment" };

export type RenameCollectionPanelQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type RenameCollectionPanelQuery = {
  __typename?: "Query";
  collections: {
    __typename?: "CollectionsQueries";
    byId?: { __typename?: "Collection"; id: string; name: string } | null;
  };
};

export type RenameCollectionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}>;

export type RenameCollectionMutation = {
  __typename?: "Mutation";
  renameCollection: { __typename?: "Collection"; id: string; name: string };
};

export type ViewCollectionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform> | ChannelPlatform>;
}>;

export type ViewCollectionQuery = {
  __typename?: "Query";
  collections: {
    __typename?: "CollectionsQueries";
    byId?: {
      __typename?: "Collection";
      id: string;
      name: string;
      channels: {
        __typename?: "ChannelsPage";
        total: number;
        items: Array<{
          __typename?: "Channel";
          id: string;
          name: string;
          platform: ChannelPlatform;
          imageUrl?: string | null;
          handle?: string | null;
          url?: string | null;
        }>;
      };
    } | null;
  };
};

export type DeactivatedChannelsQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform> | ChannelPlatform>;
}>;

export type DeactivatedChannelsQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    deactivated?: {
      __typename?: "ChannelsPage";
      total: number;
      items: Array<{
        __typename?: "Channel";
        id: string;
        name: string;
        platform: ChannelPlatform;
        imageUrl?: string | null;
        handle?: string | null;
        url?: string | null;
        changeDate?: any | null;
      }>;
    } | null;
  };
};

export type ReactivateChannelsMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type ReactivateChannelsMutation = {
  __typename?: "Mutation";
  reactivateChannels: Array<{ __typename?: "Channel"; id: string }>;
};

export type ViewChannelInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewChannelInfoQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    byId?:
      | ({ __typename?: "Channel"; id: string; name: string } & {
          " $fragmentRefs"?: {
            ChannelHeadingFragment: ChannelHeadingFragment;
            ViewChannelInfoBodyFragment: ViewChannelInfoBodyFragment;
          };
        })
      | null;
  };
};

export type ChannelHeadingFragment = {
  __typename?: "Channel";
  name: string;
  imageUrl?: string | null;
  platform: ChannelPlatform;
} & { " $fragmentName"?: "ChannelHeadingFragment" };

export type ViewChannelInfoBodyFragment = {
  __typename?: "Channel";
  id: string;
  platform: ChannelPlatform;
  handle?: string | null;
  url?: string | null;
  createDate?: any | null;
  changeDate?: any | null;
  imported?: boolean | null;
  createUser?: {
    __typename?: "SsoUser";
    userSub: string;
    fullName: string;
  } | null;
  collections?: Array<{
    __typename?: "Collection";
    id: string;
    name: string;
  }> | null;
} & { " $fragmentName"?: "ViewChannelInfoBodyFragment" };

export type ArtistQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ArtistQuery = {
  __typename?: "Query";
  artist: {
    __typename?: "ArtistQueries";
    byId?:
      | ({
          __typename?: "Artist";
          id: string;
          name: string;
          trackIds?: Array<string> | null;
          stats?: {
            __typename?: "ArtistStats";
            totalCount: number;
            segmentTracksCount: number;
          } | null;
          tracks?: Array<
            { __typename?: "Track"; id: string } & {
              " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
            }
          > | null;
        } & {
          " $fragmentRefs"?: { ArtistHeaderFragment: ArtistHeaderFragment };
        })
      | null;
  };
};

export type ArtistHeaderFragment = {
  __typename?: "Artist";
  id: string;
  trackIds?: Array<string> | null;
  imageUrl?: string | null;
  name: string;
  stats?: {
    __typename?: "ArtistStats";
    totalCount: number;
    segmentTracksCount: number;
    duration: number;
    albumsCount: number;
    mostCommonGenre?: string | null;
  } | null;
} & { " $fragmentName"?: "ArtistHeaderFragment" };

export type CuratedPlaylistsQueryVariables = Exact<{ [key: string]: never }>;

export type CuratedPlaylistsQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    curated?: {
      __typename?: "CuratedPlaylistQueries";
      categories?: Array<{
        __typename?: "CuratedPlaylistCategory";
        title: string;
        slug: string;
      }> | null;
    } | null;
  };
};

export type CuratedPlaylistGalleryQueryVariables = Exact<{
  all: Scalars["Boolean"]["input"];
  slug: Scalars["String"]["input"];
}>;

export type CuratedPlaylistGalleryQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    curated?: {
      __typename?: "CuratedPlaylistQueries";
      total?: number;
      results?: Array<
        { __typename?: "Playlist" } & {
          " $fragmentRefs"?: {
            PlaylistGalleryFragment: PlaylistGalleryFragment;
          };
        }
      >;
      byCategorySlug?: {
        __typename?: "PlaylistList";
        total: number;
        results: Array<
          { __typename?: "Playlist" } & {
            " $fragmentRefs"?: {
              PlaylistGalleryFragment: PlaylistGalleryFragment;
            };
          }
        >;
      } | null;
    } | null;
  };
};

export type ViewPlaylistQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewPlaylistQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistQueries";
    byId?:
      | ({ __typename?: "Playlist" } & {
          " $fragmentRefs"?: {
            PlaylistHeaderFragment: PlaylistHeaderFragment;
            PlaylistBulkActionsFragment: PlaylistBulkActionsFragment;
          };
        })
      | null;
  };
};

export type PlaylistBulkActionsFragment = {
  __typename?: "Playlist";
  id: string;
  isOwner: boolean;
  trackIds: Array<string>;
} & { " $fragmentName"?: "PlaylistBulkActionsFragment" };

export type PlaylistHeaderFragment = ({
  __typename?: "Playlist";
  id: string;
  isOwner: boolean;
  name: string;
  description?: string | null;
  imageUrl: string;
  hasCustomImage: boolean;
  totalCount: number;
  duration: number;
  shareable: boolean;
  createdBy?: string | null;
  trackIds: Array<string>;
} & {
  " $fragmentRefs"?: {
    PlaylistHeaderActionsFragment: PlaylistHeaderActionsFragment;
  };
}) & { " $fragmentName"?: "PlaylistHeaderFragment" };

export type PlaylistHeaderActionsFragment = {
  __typename?: "Playlist";
  id: string;
  name: string;
  liked: boolean;
  isOwner: boolean;
  trackIds: Array<string>;
  totalCount: number;
  segmentTracksCount: number;
} & { " $fragmentName"?: "PlaylistHeaderActionsFragment" };

export type PlaylistDeleteMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type PlaylistDeleteMutation = {
  __typename?: "Mutation";
  deletePlaylist: boolean;
};

export type PlaylistTracksQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  sort?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type PlaylistTracksQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistQueries";
    byId?: {
      __typename?: "Playlist";
      id: string;
      segmentTracksCount: number;
      tracks: {
        __typename?: "TracksPage";
        total: number;
        items: Array<
          { __typename?: "Track" } & {
            " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
          }
        >;
      };
    } | null;
  };
};

export type SearchHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type SearchHistoryQuery = {
  __typename?: "Query";
  recentSearches: Array<{
    __typename?: "RecentSearch";
    id: string;
    query: string;
    type: SearchType;
    filter?: Array<{
      __typename?: "SearchFilterOutput";
      name: SearchFilterName;
      values: Array<string>;
    }> | null;
    urlResult?: {
      __typename?: "UrlResult";
      title?: string | null;
      artists?: Array<string> | null;
    } | null;
  }>;
};

export type SearchHistoryDeleteRecentSearchMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type SearchHistoryDeleteRecentSearchMutation = {
  __typename?: "Mutation";
  deleteRecentSearch: boolean;
};

export type SearchHistoryDeleteAllRecentSearchesMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SearchHistoryDeleteAllRecentSearchesMutation = {
  __typename?: "Mutation";
  deleteAllRecentSearches: boolean;
};

export type BriefAnalysisQueryVariables = Exact<{
  brief: Scalars["String"]["input"];
}>;

export type BriefAnalysisQuery = {
  __typename?: "Query";
  briefAnalysis: {
    __typename?: "BriefAnalysis";
    description: string;
    filter?: Array<{
      __typename?: "SearchFilterOutput";
      name: SearchFilterName;
      values: Array<string>;
    }> | null;
  };
};

export type SearchLandingQueryVariables = Exact<{
  curatedPageSize: Scalars["Int"]["input"];
  trackPageSize: Scalars["Int"]["input"];
}>;

export type SearchLandingQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    recent?: {
      __typename?: "TracksPage";
      items: Array<{ __typename?: "Track"; id: string }>;
    } | null;
  };
} & {
  " $fragmentRefs"?: {
    SearchLandingCuratedFragment: SearchLandingCuratedFragment;
  };
};

export type SearchLandingCuratedFragment = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    curated?: {
      __typename?: "CuratedPlaylistQueries";
      total: number;
      all: Array<
        { __typename?: "Playlist" } & {
          " $fragmentRefs"?: {
            PlaylistGalleryFragment: PlaylistGalleryFragment;
          };
        }
      >;
    } | null;
  };
} & { " $fragmentName"?: "SearchLandingCuratedFragment" };

export type SearchLandingFeaturedQueryVariables = Exact<{
  trackPageSize: Scalars["Int"]["input"];
}>;

export type SearchLandingFeaturedQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    featured?: Array<
      { __typename?: "Track" } & {
        " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
      }
    > | null;
  };
};

export type RecentlyPlayedTabQueryVariables = Exact<{
  trackPageSize: Scalars["Int"]["input"];
  artistPageSize: Scalars["Int"]["input"];
  playlistPageSize: Scalars["Int"]["input"];
  includeTrackDetails: Scalars["Boolean"]["input"];
  includeArtists: Scalars["Boolean"]["input"];
  includePlaylists: Scalars["Boolean"]["input"];
}>;

export type RecentlyPlayedTabQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    recent?: {
      __typename?: "TracksPage";
      items: Array<
        { __typename?: "Track" } & {
          " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
        }
      >;
    } | null;
  };
  artists?: {
    __typename?: "ArtistsQueries";
    recent?: Array<
      { __typename?: "Artist" } & {
        " $fragmentRefs"?: { ArtistGalleryFragment: ArtistGalleryFragment };
      }
    > | null;
  };
  playlists: {
    __typename?: "PlaylistsQueries";
    recent?: Array<
      { __typename?: "Playlist" } & {
        " $fragmentRefs"?: { PlaylistGalleryFragment: PlaylistGalleryFragment };
      }
    > | null;
  };
};

export type SearchSummaryQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  type: SearchType;
  filter?: InputMaybe<Array<SearchFilterInput> | SearchFilterInput>;
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SearchSummaryQuery = {
  __typename?: "Query";
  search: {
    __typename?: "SearchQueries";
    summary?: {
      __typename?: "SearchSummary";
      total: number;
      urlResult?: {
        __typename?: "UrlResult";
        title?: string | null;
        artists?: Array<string> | null;
      } | null;
      similarTo?: { __typename?: "Track"; id: string; title: string } | null;
    } | null;
  };
};

export type SearchTracksQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query: Scalars["String"]["input"];
  type: SearchType;
  sortBy?: InputMaybe<SearchSortKey>;
  sortDirection?: InputMaybe<SearchSortDirection>;
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<Array<SearchFilterInput> | SearchFilterInput>;
}>;

export type SearchTracksQuery = {
  __typename?: "Query";
  search: {
    __typename?: "SearchQueries";
    tracks?: Array<
      { __typename?: "Track" } & {
        " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
      }
    > | null;
  };
};

export type TrackQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TrackQuery = {
  __typename?: "Query";
  track?:
    | ({ __typename?: "Track"; id: string; title: string } & {
        " $fragmentRefs"?: {
          TrackFragment: TrackFragment;
          TrackHeaderFragment: TrackHeaderFragment;
          TrackActionsFragment: TrackActionsFragment;
          TrackDetailsFragment: TrackDetailsFragment;
          AudioContextTrackFragment: AudioContextTrackFragment;
        };
      })
    | null;
};

export type AudioVersionsRouteQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AudioVersionsRouteQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    byId?: Array<
      { __typename?: "Track"; id: string } & {
        " $fragmentRefs"?: {
          AudioVersionItem_TrackFragment: AudioVersionItem_TrackFragment;
        };
      }
    > | null;
  };
  stems: {
    __typename?: "StemsQueries";
    byId?: Array<{
      __typename: "Stem";
      status: StemStatus;
      modelId: string;
      trackId: string;
    }> | null;
  };
};

export type AudioVersionItem_TrackFragment = ({
  __typename?: "Track";
  id: string;
  userMeta?: { __typename?: "TrackUserMeta"; liked?: boolean | null } | null;
  audioUrls: { __typename?: "AudioUrls"; normal: string };
} & { " $fragmentRefs"?: { TrackFragment: TrackFragment } }) & {
  " $fragmentName"?: "AudioVersionItem_TrackFragment";
};

export type StemsCreateMutationVariables = Exact<{
  trackId: Scalars["ID"]["input"];
  modelId: Scalars["String"]["input"];
}>;

export type StemsCreateMutation = {
  __typename?: "Mutation";
  createStems: {
    __typename?: "Stem";
    status: StemStatus;
    trackId: string;
    modelId: string;
  };
};

export type TrackDetailsAnalysisFragment = {
  __typename?: "Track";
  id: string;
  analysis?: {
    __typename?: "TrackAnalysis";
    characteristics: {
      __typename?: "TrackCharacteristics";
      genre?: string | null;
      mood?: Array<string> | null;
      vocals?: string | null;
      tempo?: string | null;
      bpm?: number | null;
      key?: string | null;
      decade?: string | null;
      instruments?: Array<string> | null;
      ageAffinity?: Array<string> | null;
      genderAffinity?: string | null;
      regionAffinity?: Array<string> | null;
      useCasePredictions?: Array<string> | null;
    };
    visuals: {
      __typename?: "TrackVisuals";
      genres: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
      subGenres: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
      moods: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
      ageAffinity: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
      genderAffinity: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
      regionAffinity: Array<{
        __typename?: "TrackVisualDataPoint";
        label: string;
        value: number;
      }>;
    };
  } | null;
} & { " $fragmentName"?: "TrackDetailsAnalysisFragment" };

export type TrackDetailsRouteQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TrackDetailsRouteQuery = {
  __typename?: "Query";
  track?:
    | ({ __typename?: "Track" } & {
        " $fragmentRefs"?: {
          TrackDetailsAnalysisFragment: TrackDetailsAnalysisFragment;
        };
      })
    | null;
};

export type TrackDetailsFragment = {
  __typename?: "Track";
  id: string;
  title: string;
  duration: number;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
  traits: { __typename?: "TrackTraits"; explicit?: boolean | null };
  release?: { __typename?: "Release"; id: string; title: string } | null;
} & { " $fragmentName"?: "TrackDetailsFragment" };

export type TrackSimilarRouteQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TrackSimilarRouteQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    similar?: Array<
      { __typename?: "Track"; id: string } & {
        " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
      }
    > | null;
  };
};

export type TrackHeaderFragment = ({
  __typename?: "Track";
  id: string;
  imageUrl: string;
  title: string;
  genres: string;
  duration: number;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
} & {
  " $fragmentRefs"?: {
    TrackHeaderTrackActionsFragment: TrackHeaderTrackActionsFragment;
  };
}) & { " $fragmentName"?: "TrackHeaderFragment" };

export type TrackHeaderTrackActionsFragment = {
  __typename?: "Track";
  id: string;
  title: string;
  imageUrl: string;
  artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
  traits: {
    __typename?: "TrackTraits";
    vocals?: boolean | null;
    explicit?: boolean | null;
    youtubeSafe?: boolean | null;
  };
  userMeta?: { __typename?: "TrackUserMeta"; liked?: boolean | null } | null;
} & { " $fragmentName"?: "TrackHeaderTrackActionsFragment" };

export type DownloadedTracksQueryVariables = Exact<{
  scope?: InputMaybe<DownloadsScope>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DownloadedTracksQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    downloaded?: {
      __typename?: "TracksPage";
      total: number;
      items: Array<
        { __typename?: "Track" } & {
          " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
        }
      >;
    } | null;
  };
};

export type DeclareSubmitMutationVariables = Exact<{
  input: DeclareTracksInput;
}>;

export type DeclareSubmitMutation = {
  __typename?: "Mutation";
  declareTracks: boolean;
};

export type DeclareChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type DeclareChannelsQuery = {
  __typename?: "Query";
  channels: {
    __typename?: "ChannelsQueries";
    connected?: {
      __typename?: "ChannelsPage";
      items: Array<{
        __typename?: "Channel";
        id: string;
        name: string;
        platform: ChannelPlatform;
        imageUrl?: string | null;
        handle?: string | null;
      }>;
    } | null;
  };
  collections: {
    __typename?: "CollectionsQueries";
    all?: {
      __typename?: "CollectionsPage";
      items: Array<{
        __typename?: "Collection";
        id: string;
        name: string;
        channelIds: Array<string>;
      }>;
    } | null;
  };
};

export type DeclareTracksQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DeclareTracksQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    byId?: Array<{
      __typename?: "Track";
      id: string;
      title: string;
      imageUrl: string;
      artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
    }> | null;
  };
};

export type LikedTracksQueryVariables = Exact<{
  sort?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LikedTracksQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    liked?: {
      __typename?: "TracksPage";
      total: number;
      items: Array<
        { __typename?: "Track" } & {
          " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
        }
      >;
    } | null;
  };
};

export type UserPlaylistsQueryVariables = Exact<{ [key: string]: never }>;

export type UserPlaylistsQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    user?: Array<
      { __typename?: "Playlist" } & {
        " $fragmentRefs"?: { PlaylistGalleryFragment: PlaylistGalleryFragment };
      }
    > | null;
  };
};

export type TeamPlaylistsQueryVariables = Exact<{ [key: string]: never }>;

export type TeamPlaylistsQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    team?: Array<
      { __typename?: "Playlist" } & {
        " $fragmentRefs"?: { PlaylistGalleryFragment: PlaylistGalleryFragment };
      }
    > | null;
  };
};

export type LikedPlaylistsQueryVariables = Exact<{ [key: string]: never }>;

export type LikedPlaylistsQuery = {
  __typename?: "Query";
  playlists: {
    __typename?: "PlaylistsQueries";
    liked?: Array<
      { __typename?: "Playlist" } & {
        " $fragmentRefs"?: { PlaylistGalleryFragment: PlaylistGalleryFragment };
      }
    > | null;
  };
};

export type RecentTracksQueryVariables = Exact<{
  sort?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type RecentTracksQuery = {
  __typename?: "Query";
  tracks: {
    __typename?: "TracksQueries";
    recent?: {
      __typename?: "TracksPage";
      total: number;
      items: Array<
        { __typename?: "Track" } & {
          " $fragmentRefs"?: { TrackListFragment: TrackListFragment };
        }
      >;
    } | null;
  };
};

export type SharedArtistQueryVariables = Exact<{ [key: string]: never }>;

export type SharedArtistQuery = {
  __typename?: "Query";
  artist: {
    __typename?: "ArtistQueries";
    shared?: {
      __typename?: "SharedArtistQueries";
      details?:
        | ({
            __typename?: "Artist";
            id: string;
            name: string;
            trackIds?: Array<string> | null;
          } & {
            " $fragmentRefs"?: {
              SharedArtistHeaderFragment: SharedArtistHeaderFragment;
            };
          })
        | null;
    } | null;
  };
};

export type SharedArtistHeaderFragment = {
  __typename?: "Artist";
  name: string;
  imageUrl?: string | null;
  trackIds?: Array<string> | null;
  stats?: {
    __typename?: "ArtistStats";
    duration: number;
    totalCount: number;
    albumsCount: number;
    mostCommonGenre?: string | null;
  } | null;
} & { " $fragmentName"?: "SharedArtistHeaderFragment" };

export type SharedArtistTracksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SharedArtistTracksQuery = {
  __typename?: "Query";
  artist: {
    __typename?: "ArtistQueries";
    shared?: {
      __typename?: "SharedArtistQueries";
      tracks?: {
        __typename?: "TracksPage";
        total: number;
        items: Array<
          { __typename?: "Track"; id: string } & {
            " $fragmentRefs"?: {
              TrackFragment: TrackFragment;
              AudioContextTrackFragment: AudioContextTrackFragment;
            };
          }
        >;
      } | null;
    } | null;
  };
};

export type SharedPlaylistQueryVariables = Exact<{ [key: string]: never }>;

export type SharedPlaylistQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistQueries";
    shared?: {
      __typename?: "SharedPlaylistQueries";
      details?: {
        __typename?: "Playlist";
        id: string;
        name: string;
        description?: string | null;
        imageUrl: string;
        totalCount: number;
        duration: number;
        createdBy?: string | null;
      } | null;
    } | null;
  };
};

export type SharedPlaylistTracksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SharedPlaylistTracksQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistQueries";
    shared?: {
      __typename?: "SharedPlaylistQueries";
      tracks?: {
        __typename?: "TracksPage";
        total: number;
        items: Array<
          { __typename?: "Track"; id: string } & {
            " $fragmentRefs"?: {
              TrackFragment: TrackFragment;
              AudioContextTrackFragment: AudioContextTrackFragment;
            };
          }
        >;
      } | null;
    } | null;
  };
};

export type SharedTrackQueryVariables = Exact<{ [key: string]: never }>;

export type SharedTrackQuery = {
  __typename?: "Query";
  track?:
    | ({
        __typename?: "Track";
        id: string;
        title: string;
        imageUrl: string;
        genres: string;
        duration: number;
        artists: Array<{ __typename?: "Artist"; id: string; name: string }>;
      } & {
        " $fragmentRefs"?: {
          TrackDetailsFragment: TrackDetailsFragment;
          AudioContextTrackFragment: AudioContextTrackFragment;
        };
      })
    | null;
};

export type SharedTrackDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type SharedTrackDetailsQuery = {
  __typename?: "Query";
  track?:
    | ({ __typename?: "Track" } & {
        " $fragmentRefs"?: {
          TrackDetailsAnalysisFragment: TrackDetailsAnalysisFragment;
        };
      })
    | null;
};

export type ValidateFilesInS3MutationVariables = Exact<{
  input: ValidateFilesInput;
}>;

export type ValidateFilesInS3Mutation = {
  __typename?: "Mutation";
  validateFilesInS3: Array<{
    __typename?: "FileValidationResult";
    filename: string;
    exists: boolean;
    error?: string | null;
  }>;
};

export type StartIngestionJobMutationVariables = Exact<{
  licensorDpid: Scalars["String"]["input"];
  jobName: Scalars["String"]["input"];
}>;

export type StartIngestionJobMutation = {
  __typename?: "Mutation";
  startIngestionJob: { __typename?: "IngestionJobResult"; id: number };
};

export type ExecuteCatalogUploadMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  dromoUploadId: Scalars["String"]["input"];
}>;

export type ExecuteCatalogUploadMutation = {
  __typename?: "Mutation";
  executeCatalogUpload: { __typename?: "IngestionJobResult"; id: number };
};

export type IngestionJobsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type IngestionJobsQuery = {
  __typename?: "Query";
  ingestionJobs: {
    __typename?: "IngestionJobsResult";
    total: number;
    items: Array<{
      __typename?: "IngestionJob";
      id: string;
      catalogUploadId: number;
      userId: string;
      orgId: string;
      orgName?: string | null;
      status: IngestionJobStatus;
      dromoSessionId?: string | null;
      dromoImportId?: string | null;
      dromoImportIdentifier: string;
      csvOriginalFilename?: string | null;
      metadataRowCount?: number | null;
      updatedAt: string;
      licensorDpid: string;
      jobName: string;
      createdAt?: string | null;
      createUser?: { __typename?: "SsoUser"; fullName: string } | null;
      changeUser?: { __typename?: "SsoUser"; fullName: string } | null;
    }>;
  };
};

export type IngestionJobQueryVariables = Exact<{
  jobId: Scalars["ID"]["input"];
}>;

export type IngestionJobQuery = {
  __typename?: "Query";
  ingestionJob?: {
    __typename?: "IngestionJob";
    id: string;
    catalogUploadId: number;
    userId: string;
    orgId: string;
    orgName?: string | null;
    status: IngestionJobStatus;
    dromoSessionId?: string | null;
    dromoImportId?: string | null;
    dromoImportIdentifier: string;
    csvOriginalFilename?: string | null;
    metadataRowCount?: number | null;
    updatedAt: string;
    licensorDpid: string;
    jobName: string;
    createdAt?: string | null;
    createUser?: { __typename?: "SsoUser"; fullName: string } | null;
    changeUser?: { __typename?: "SsoUser"; fullName: string } | null;
    mediaFiles: Array<{
      __typename?: "SavedMediaFile";
      id: string;
      name: string;
      type: string;
      size: number;
      uploadComplete: boolean;
    }>;
  } | null;
};

export type CreateIngestionJobMutationVariables = Exact<{
  licensorDpid: Scalars["String"]["input"];
  jobName: Scalars["String"]["input"];
}>;

export type CreateIngestionJobMutation = {
  __typename?: "Mutation";
  createIngestionJob: {
    __typename?: "IngestionJob";
    id: string;
    catalogUploadId: number;
    userId: string;
    orgId: string;
    orgName?: string | null;
    status: IngestionJobStatus;
    dromoSessionId?: string | null;
    dromoImportId?: string | null;
    dromoImportIdentifier: string;
    csvOriginalFilename?: string | null;
    metadataRowCount?: number | null;
    updatedAt: string;
    licensorDpid: string;
    jobName: string;
    createdAt?: string | null;
    createUser?: { __typename?: "SsoUser"; fullName: string } | null;
    changeUser?: { __typename?: "SsoUser"; fullName: string } | null;
  };
};

export type UpdateIngestionJobMutationVariables = Exact<{
  input: UpdateIngestionJobInput;
}>;

export type UpdateIngestionJobMutation = {
  __typename?: "Mutation";
  updateIngestionJob: {
    __typename?: "IngestionJob";
    id: string;
    catalogUploadId: number;
    status: IngestionJobStatus;
    dromoSessionId?: string | null;
    dromoImportId?: string | null;
    dromoImportIdentifier: string;
    csvOriginalFilename?: string | null;
    metadataRowCount?: number | null;
    licensorDpid: string;
    jobName: string;
    updatedAt: string;
    mediaFiles: Array<{
      __typename?: "SavedMediaFile";
      id: string;
      name: string;
      type: string;
      size: number;
      uploadComplete: boolean;
    }>;
  };
};

export type DeleteIngestionJobMediaFileMutationVariables = Exact<{
  jobId: Scalars["ID"]["input"];
  mediaFileId: Scalars["String"]["input"];
}>;

export type DeleteIngestionJobMediaFileMutation = {
  __typename?: "Mutation";
  deleteIngestionJobMediaFile: {
    __typename?: "IngestionJob";
    id: string;
    mediaFiles: Array<{
      __typename?: "SavedMediaFile";
      id: string;
      name: string;
      type: string;
      size: number;
      uploadComplete: boolean;
    }>;
  };
};

export type CancelIngestionJobMutationVariables = Exact<{
  jobId: Scalars["ID"]["input"];
}>;

export type CancelIngestionJobMutation = {
  __typename?: "Mutation";
  cancelIngestionJob: {
    __typename?: "IngestionJob";
    id: string;
    status: IngestionJobStatus;
  };
};

export type DeleteIngestionJobMutationVariables = Exact<{
  jobId: Scalars["ID"]["input"];
}>;

export type DeleteIngestionJobMutation = {
  __typename?: "Mutation";
  deleteIngestionJob: boolean;
};

export type IngestionSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type IngestionSettingsQuery = {
  __typename?: "Query";
  ingestionSettings?: {
    __typename?: "IngestionSettingsResult";
    dpid: string;
  } | null;
};

export type UpdateIngestionSettingsMutationVariables = Exact<{
  dpid: Scalars["String"]["input"];
}>;

export type UpdateIngestionSettingsMutation = {
  __typename?: "Mutation";
  updateIngestionSettings: {
    __typename?: "IngestionSettingsResult";
    dpid: string;
  };
};

export type CustomerSupportSubmitInquiryMutationVariables = Exact<{
  inquiry: Scalars["String"]["input"];
  category: Scalars["String"]["input"];
}>;

export type CustomerSupportSubmitInquiryMutation = {
  __typename?: "Mutation";
  submitInquiry: boolean;
};

export type NotificationsPanelQueryVariables = Exact<{ [key: string]: never }>;

export type NotificationsPanelQuery = {
  __typename?: "Query";
  notifications: {
    __typename?: "NotificationsQueries";
    unreadCount?: number | null;
  };
};

export type NotificationsPanelListQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
}>;

export type NotificationsPanelListQuery = {
  __typename?: "Query";
  notifications: {
    __typename?: "NotificationsQueries";
    user?: {
      __typename?: "NotificationsPage";
      total?: number | null;
      items: Array<
        {
          __typename?: "Notification";
          id: string;
          status: NotificationStatus;
        } & {
          " $fragmentRefs"?: {
            NotificationItemFragment: NotificationItemFragment;
          };
        }
      >;
    } | null;
  };
};

export type NotificationsPanelListFeedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type NotificationsPanelListFeedSubscription = {
  __typename?: "Subscription";
  newNotification: boolean;
};

export type NotificationsPanelTabsClearUnreadMutationVariables = Exact<{
  [key: string]: never;
}>;

export type NotificationsPanelTabsClearUnreadMutation = {
  __typename?: "Mutation";
  clearUnreadNotifications: boolean;
};

export type BulkDownloadLinkQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type BulkDownloadLinkQuery = {
  __typename?: "Query";
  bulkDownload?: {
    __typename?: "BulkDownload";
    id: string;
    status: BulkDownloadStatus;
    downloadUrl?: string | null;
  } | null;
};

export type NotificationItemFragment = {
  __typename?: "Notification";
  id: string;
  status: NotificationStatus;
  date: any;
  key: string;
  dest?: string | null;
  subject?: {
    __typename?: "NotificationSubject";
    name: string;
    avatar?: string | null;
  } | null;
  data?: Array<{
    __typename?: "NotificationData";
    key: string;
    value: string;
  }> | null;
} & { " $fragmentName"?: "NotificationItemFragment" };

export type NotificationItemMarkAsReadMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type NotificationItemMarkAsReadMutation = {
  __typename?: "Mutation";
  markNotificationAsRead: boolean;
};

export type InviteAcceptAcceptMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type InviteAcceptAcceptMutation = {
  __typename?: "Mutation";
  acceptUserInviteToOrg: { __typename?: "OrgUser"; id: string };
};

export type InviteCreateQueryVariables = Exact<{ [key: string]: never }>;

export type InviteCreateQuery = {
  __typename?: "Query";
  org: {
    __typename?: "Org";
    id: string;
    roles: Array<{
      __typename?: "OrgRoleX";
      name: string;
      label: string;
      permissions: Array<{
        __typename?: "OrgPermissionX";
        name: string;
        label: string;
        hidden?: boolean | null;
      }>;
    }>;
  };
};

export type InviteCreateSendMutationVariables = Exact<{
  invites: Array<OrgUserInviteInput> | OrgUserInviteInput;
}>;

export type InviteCreateSendMutation = {
  __typename?: "Mutation";
  inviteUserToOrg: {
    __typename?: "OrgUserInviteBatch";
    id: string;
    status: OrgUserInviteBatchStatus;
    requested: number;
    skipped: number;
    invalid: Array<string>;
  };
};

export type EmailsFieldLookupQueryVariables = Exact<{
  emails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type EmailsFieldLookupQuery = {
  __typename?: "Query";
  orgUserInviteLookup: Array<{
    __typename?: "OrgUserInviteLookupResult";
    email: string;
    status: OrgUserInviteLookupStatus;
  }>;
};

export type OrgCreateQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OrgCreateQuery = {
  __typename?: "Query";
  orgs: {
    __typename?: "OrgsPage";
    orgs: Array<{ __typename?: "Org"; id: string; name: string }>;
  };
};

export type OrgCreateCreateMutationVariables = Exact<{
  input: CreateOrgInput;
}>;

export type OrgCreateCreateMutation = {
  __typename?: "Mutation";
  createOrg: { __typename?: "Org"; id: string; name: string };
};

export type OrgBrandingQueryVariables = Exact<{ [key: string]: never }>;

export type OrgBrandingQuery = {
  __typename?: "Query";
  org: {
    __typename?: "Org";
    id: string;
    metadata?: {
      __typename?: "OrgMetadata";
      assets?: {
        __typename?: "OrgMetadataAssets";
        logo?: string | null;
        background?: string | null;
      } | null;
    } | null;
  };
};

export type UpdateOrgAssetsMutationVariables = Exact<{
  logo?: InputMaybe<Scalars["String"]["input"]>;
  background?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateOrgAssetsMutation = {
  __typename?: "Mutation";
  updateOrgAssets: boolean;
};

export type CreateOrgAssetSignedUploadUrlMutationVariables = Exact<{
  hash: Scalars["String"]["input"];
  contentType: Scalars["String"]["input"];
}>;

export type CreateOrgAssetSignedUploadUrlMutation = {
  __typename?: "Mutation";
  createOrgAssetSignedUploadUrl: {
    __typename?: "OrgAssetSignedUploadUrl";
    url: string;
    fileName: string;
  };
};

export type OrgDetailsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OrgDetailsQuery = {
  __typename?: "Query";
  orgs: {
    __typename?: "OrgsPage";
    orgs: Array<{ __typename?: "Org"; id: string; name: string }>;
  };
  org: {
    __typename?: "Org";
    id: string;
    name: string;
    parentOrgId?: string | null;
    metadata?: {
      __typename?: "OrgMetadata";
      analytics?: {
        __typename?: "OrgMetadataAnalytics";
        heap?: {
          __typename?: "OrgMetadataAnalyticsHeap";
          enabled: boolean;
        } | null;
      } | null;
      accountManager?: {
        __typename?: "OrgMetadataAccountManager";
        firstName: string;
        lastName: string;
        email: string;
        phone?: string | null;
      } | null;
      priceEstimation?: {
        __typename?: "OrgMetadataPriceEstimation";
        publicCompany?: boolean | null;
        marketSymbol?: string | null;
        marketCap?: any | null;
        numberOfEmployees?: any | null;
        currency?: any | null;
        instagramFollowers?: any | null;
        tikTokFollowers?: any | null;
      } | null;
      basic?: {
        __typename?: "OrgMetadataBasic";
        holdingOrgId?: string | null;
        servicingOrgId: string;
        servicingOrgEmail: string;
        dealId: string;
      } | null;
      payouts?: {
        __typename?: "OrgMetadataPayouts";
        billingEmail?: string | null;
        trolleyRefId?: string | null;
        minimumPayoutCents?: number | null;
      } | null;
      other?: {
        __typename?: "OrgMetadataOther";
        hubSpotIds?: Array<string> | null;
      } | null;
    } | null;
  };
};

export type UpdateOrgDetailsMutationVariables = Exact<{
  input: UpdateOrgDetailsInput;
}>;

export type UpdateOrgDetailsMutation = {
  __typename?: "Mutation";
  updateOrgDetails: boolean;
};

export type OrgModulesQueryVariables = Exact<{ [key: string]: never }>;

export type OrgModulesQuery = {
  __typename?: "Query";
  org: {
    __typename?: "Org";
    id: string;
    name: string;
    modules: Array<string>;
    metadata?: {
      __typename?: "OrgMetadata";
      modules?: {
        __typename?: "OrgMetadataModules";
        adaptiveMusic?: {
          __typename?: "OrgMetadataModulesAdaptiveMusic";
          url: string;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateOrgModulesMutationVariables = Exact<{
  input: UpdateOrgModulesInput;
}>;

export type UpdateOrgModulesMutation = {
  __typename?: "Mutation";
  updateOrgModules: boolean;
};

export type OrgUsersActiveQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OrgUsersActiveQuery = {
  __typename?: "Query";
  orgUsers: {
    __typename?: "OrgUsersPage";
    offset: number;
    total: number;
    users: Array<{
      __typename?: "OrgUser";
      id: string;
      name: string;
      email: string;
      roles: Array<string>;
      status: OrgUserStatus;
      activeDate: any;
      permissions: Array<string>;
    }>;
  };
  org: { __typename?: "Org"; id: string } & {
    " $fragmentRefs"?: {
      OrgUsers_RolesColumnFragment: OrgUsers_RolesColumnFragment;
      OrgUsers_UpdateModalFragment: OrgUsers_UpdateModalFragment;
      OrgUsers_OrgRolesFragment: OrgUsers_OrgRolesFragment;
    };
  };
};

export type OrgUsersActiveDeactivateMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersActiveDeactivateMutation = {
  __typename?: "Mutation";
  deactivateUserInOrg: {
    __typename?: "OrgUser";
    id: string;
    status: OrgUserStatus;
  };
};

export type OrgUsersActiveUpdateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  roles: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  permissions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersActiveUpdateMutation = {
  __typename?: "Mutation";
  updateUserPermissionsInOrg: { __typename: "OrgUser" };
};

export type OrgUsersInactiveQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OrgUsersInactiveQuery = {
  __typename?: "Query";
  orgUsers: {
    __typename?: "OrgUsersPage";
    offset: number;
    total: number;
    users: Array<{
      __typename?: "OrgUser";
      id: string;
      name: string;
      email: string;
      roles: Array<string>;
      status: OrgUserStatus;
      permissions: Array<string>;
      inactiveDate?: any | null;
    }>;
  };
  org: { __typename?: "Org"; id: string } & {
    " $fragmentRefs"?: {
      OrgUsers_RolesColumnFragment: OrgUsers_RolesColumnFragment;
      OrgUsers_UpdateModalFragment: OrgUsers_UpdateModalFragment;
      OrgUsers_OrgRolesFragment: OrgUsers_OrgRolesFragment;
    };
  };
};

export type OrgUsersInactiveRemoveMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersInactiveRemoveMutation = {
  __typename?: "Mutation";
  removeUserFromOrg: {
    __typename?: "OrgUser";
    id: string;
    status: OrgUserStatus;
  };
};

export type OrgUsersInactiveUpdateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  roles: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  permissions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersInactiveUpdateMutation = {
  __typename?: "Mutation";
  updateUserPermissionsInOrg: { __typename: "OrgUser" };
};

export type OrgUsersInactiveReactivateMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersInactiveReactivateMutation = {
  __typename?: "Mutation";
  reactivateUserInOrg: { __typename: "OrgUser" };
};

export type OrgUsersInvitedQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgUserInviteSort>;
}>;

export type OrgUsersInvitedQuery = {
  __typename?: "Query";
  orgUserInvites: {
    __typename?: "OrgUserInvitesPage";
    offset: number;
    total: number;
    invites: Array<{
      __typename?: "OrgUserInvite";
      id: string;
      email: string;
      roles: Array<string>;
      status: OrgUserInviteStatus;
      workspace?: string | null;
      permissions: Array<string>;
      lastSendDate?: any | null;
    }>;
  };
  org: { __typename?: "Org"; id: string } & {
    " $fragmentRefs"?: {
      OrgUsers_UpdateModalFragment: OrgUsers_UpdateModalFragment;
      OrgUsers_RolesColumnFragment: OrgUsers_RolesColumnFragment;
      OrgUsers_OrgRolesFragment: OrgUsers_OrgRolesFragment;
    };
  };
};

export type OrgUsersInvitedResendMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type OrgUsersInvitedResendMutation = {
  __typename?: "Mutation";
  resendOrgUserInvite: boolean;
};

export type OrgUsersInvitedRemoveMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type OrgUsersInvitedRemoveMutation = {
  __typename?: "Mutation";
  removeOrgUserInvite: boolean;
};

export type OrgUsersInvitedUpdateMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
  roles: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  permissions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersInvitedUpdateMutation = {
  __typename?: "Mutation";
  updateOrgUserInvite: { __typename: "OrgUserInvite" };
};

export type OrgsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgsSort>;
}>;

export type OrgsQuery = {
  __typename?: "Query";
  orgs: {
    __typename?: "OrgsPage";
    offset: number;
    total: number;
    orgs: Array<{ __typename?: "Org"; id: string; name: string }>;
  };
};

export type OrgUsersDeactivateMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersDeactivateMutation = {
  __typename?: "Mutation";
  deactivateUserInOrg: {
    __typename?: "OrgUser";
    id: string;
    status: OrgUserStatus;
  };
};

export type OrgUsersReactivateMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersReactivateMutation = {
  __typename?: "Mutation";
  reactivateUserInOrg: { __typename?: "OrgUser"; id: string };
};

export type OrgUsersRemoveInviteMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type OrgUsersRemoveInviteMutation = {
  __typename?: "Mutation";
  removeOrgUserInvite: boolean;
};

export type OrgUsersRemoveOrgUserMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgUsersRemoveOrgUserMutation = {
  __typename?: "Mutation";
  removeUserFromOrg: {
    __typename?: "OrgUser";
    id: string;
    status: OrgUserStatus;
  };
};

export type OrgUsersResendMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type OrgUsersResendMutation = {
  __typename?: "Mutation";
  resendOrgUserInvite: boolean;
};

export type OrgUsers_OrgRolesFragment = {
  __typename?: "Org";
  id: string;
  roles: Array<{
    __typename?: "OrgRoleX";
    name: string;
    label: string;
    permissions: Array<{
      __typename?: "OrgPermissionX";
      name: string;
      label: string;
      hidden?: boolean | null;
    }>;
  }>;
} & { " $fragmentName"?: "OrgUsers_OrgRolesFragment" };

export type OrgUsersUpdateOrgUserInviteMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
  roles: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  permissions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersUpdateOrgUserInviteMutation = {
  __typename?: "Mutation";
  updateOrgUserInvite: { __typename: "OrgUserInvite" };
};

export type OrgUsersUpdateOrgUserMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  roles: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  permissions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersUpdateOrgUserMutation = {
  __typename?: "Mutation";
  updateUserPermissionsInOrg: { __typename: "OrgUser" };
};

export type OrgUsers_RolesColumnFragment = {
  __typename?: "Org";
  id: string;
  roles: Array<{ __typename?: "OrgRoleX"; name: string; label: string }>;
} & { " $fragmentName"?: "OrgUsers_RolesColumnFragment" };

export type OrgUsers_UpdateModalFragment = {
  __typename?: "Org";
  id: string;
  roles: Array<{
    __typename?: "OrgRoleX";
    name: string;
    label: string;
    permissions: Array<{
      __typename?: "OrgPermissionX";
      name: string;
      label: string;
      hidden?: boolean | null;
    }>;
  }>;
} & { " $fragmentName"?: "OrgUsers_UpdateModalFragment" };

export type OrgPayoutsQueryVariables = Exact<{ [key: string]: never }>;

export type OrgPayoutsQuery = {
  __typename?: "Query";
  org: {
    __typename?: "Org";
    id: string;
    metadata?: {
      __typename?: "OrgMetadata";
      payouts?: {
        __typename?: "OrgMetadataPayouts";
        trolleyUrl?: string | null;
      } | null;
    } | null;
  };
};

export type PayoutAdministrationEligibleQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  trolleyStatuses?: InputMaybe<
    Array<PayoutTrolleyStatus> | PayoutTrolleyStatus
  >;
  sortBy?: InputMaybe<PayoutEligibleSort>;
}>;

export type PayoutAdministrationEligibleQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    eligible?: {
      __typename?: "PayoutEligibleOrgPage";
      total: number;
      items: Array<{
        __typename?: "PayoutEligibleOrg";
        orgId: string;
        orgName?: string | null;
        marketplaceUserId?: number | null;
        balanceCents: number;
        legacyCents: number;
        statementCents: number;
        adjustmentCents: number;
        itemCount: number;
        minimumPayoutCents: number;
        trolleyStatus: PayoutTrolleyStatus;
        commentCount: number;
        id: string;
      }>;
    } | null;
  };
};

export type PayoutAdministrationEligibleExportQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>;
  trolleyStatuses?: InputMaybe<
    Array<PayoutTrolleyStatus> | PayoutTrolleyStatus
  >;
  sortBy?: InputMaybe<PayoutEligibleSort>;
}>;

export type PayoutAdministrationEligibleExportQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    eligible?: {
      __typename?: "PayoutEligibleOrgPage";
      items: Array<{
        __typename?: "PayoutEligibleOrg";
        orgId: string;
        marketplaceUserId?: number | null;
        orgName?: string | null;
        balance?: string | null;
        legacy?: string | null;
        statements?: string | null;
        adjustments?: string | null;
        itemCount: number;
        minimumPayout?: string | null;
        trolleyStatus: PayoutTrolleyStatus;
      }>;
    } | null;
  };
};

export type PayoutAdministrationEligibleSelectAllQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>;
  trolleyStatuses?: InputMaybe<
    Array<PayoutTrolleyStatus> | PayoutTrolleyStatus
  >;
}>;

export type PayoutAdministrationEligibleSelectAllQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    eligible?: {
      __typename?: "PayoutEligibleOrgPage";
      items: Array<{
        __typename?: "PayoutEligibleOrg";
        orgId: string;
        orgName?: string | null;
        marketplaceUserId?: number | null;
        balanceCents: number;
        legacyCents: number;
        statementCents: number;
        adjustmentCents: number;
        itemCount: number;
        minimumPayoutCents: number;
        trolleyStatus: PayoutTrolleyStatus;
        commentCount: number;
        id: string;
      }>;
    } | null;
  };
};

export type PayoutAdministrationSyncRecipientsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type PayoutAdministrationSyncRecipientsMutation = {
  __typename?: "Mutation";
  syncPayoutRecipients: boolean;
};

export type PayoutAdministrationCreateBatchMutationVariables = Exact<{
  orgIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type PayoutAdministrationCreateBatchMutation = {
  __typename?: "Mutation";
  createPayoutBatch: {
    __typename?: "PayoutBatch";
    id: string;
    status: PayoutBatchStatus;
  };
};

export type PayoutAdministrationHeldQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PayoutAdministrationHeldQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    held?: Array<{
      __typename?: "PayoutEligibleOrg";
      orgId: string;
      orgName?: string | null;
      marketplaceUserId?: number | null;
      balanceCents: number;
      minimumPayoutCents: number;
      trolleyStatus: PayoutTrolleyStatus;
      commentCount: number;
      heldAt?: any | null;
      id: string;
    }> | null;
  };
};

export type PayoutAdministrationBatchesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type PayoutAdministrationBatchesQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    batches?: {
      __typename?: "PayoutBatchPage";
      total: number;
      items: Array<{
        __typename?: "PayoutBatch";
        id: string;
        status: PayoutBatchStatus;
        totalCents: number;
        paymentCount: number;
        createDate?: any | null;
        lastSyncedAt?: any | null;
        createUser?: {
          __typename?: "SsoUser";
          userSub: string;
          fullName: string;
        } | null;
      }>;
    } | null;
  };
};

export type PayoutBatchViewQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PayoutBatchViewQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    batch?: {
      __typename?: "PayoutBatch";
      id: string;
      status: PayoutBatchStatus;
      trolleyBatchId?: string | null;
      totalCents: number;
      paymentCount: number;
      reviewReason?: string | null;
      createDate?: any | null;
      lastSyncedAt?: any | null;
      orgCount: number;
      preparedCount: number;
      trolleyRequestedAt?: any | null;
      changeDate?: any | null;
      syncing?: boolean | null;
      syncTask?: PayoutBatchTask | null;
      lastSyncError?: string | null;
      createUser?: {
        __typename?: "SsoUser";
        userSub: string;
        fullName: string;
      } | null;
      skipped: Array<{
        __typename?: "PayoutSkippedOrg";
        orgId: string;
        orgName?: string | null;
        reason: string;
        id: string;
      }>;
      payouts?: Array<{
        __typename?: "Payout";
        id: string;
        orgId: string;
        orgName?: string | null;
        amountCents: number;
        status: PayoutStatus;
        trolleyStatus?: string | null;
        paidAt?: any | null;
        returned?: boolean | null;
        returnedAt?: any | null;
      }> | null;
      syncProgress?: {
        __typename?: "PayoutBatchSyncProgress";
        applied: number;
        total: number;
      } | null;
      issues?: Array<{
        __typename?: "PayoutBatchIssue";
        kind: PayoutIssueKind;
        releasable: boolean;
        trolleyStatus?: string | null;
        payout: {
          __typename?: "Payout";
          id: string;
          orgId: string;
          orgName?: string | null;
          amountCents: number;
          status: PayoutStatus;
          trolleyStatus?: string | null;
          returned?: boolean | null;
        };
      }> | null;
    } | null;
  };
};

export type PayoutBatchExportQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type PayoutBatchExportQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    batch?: {
      __typename?: "PayoutBatch";
      id: string;
      payouts?: Array<{
        __typename?: "Payout";
        id: string;
        orgId: string;
        orgName?: string | null;
        amount?: string | null;
        status: PayoutStatus;
        trolleyPaymentId?: string | null;
        trolleyStatus?: string | null;
        paidAt?: any | null;
      }> | null;
    } | null;
  };
};

export type PayoutBatchProgressQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type PayoutBatchProgressQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    batch?: {
      __typename?: "PayoutBatch";
      id: string;
      status: PayoutBatchStatus;
      orgCount: number;
      preparedCount: number;
      trolleyRequestedAt?: any | null;
      changeDate?: any | null;
      syncing?: boolean | null;
      syncTask?: PayoutBatchTask | null;
      syncProgress?: {
        __typename?: "PayoutBatchSyncProgress";
        applied: number;
        total: number;
      } | null;
    } | null;
  };
};

export type PayoutBatchSyncMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type PayoutBatchSyncMutation = {
  __typename?: "Mutation";
  syncPayoutBatch: {
    __typename?: "PayoutBatch";
    id: string;
    status: PayoutBatchStatus;
    syncing?: boolean | null;
    syncTask?: PayoutBatchTask | null;
  };
};

export type PayoutBatchReleaseMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  payoutIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type PayoutBatchReleaseMutation = {
  __typename?: "Mutation";
  releasePayouts: {
    __typename?: "PayoutBatch";
    id: string;
    status: PayoutBatchStatus;
    syncing?: boolean | null;
    syncTask?: PayoutBatchTask | null;
  };
};

export type PayoutBatchMarkPaidMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  payoutId: Scalars["String"]["input"];
}>;

export type PayoutBatchMarkPaidMutation = {
  __typename?: "Mutation";
  markPayoutPaid: {
    __typename?: "PayoutBatch";
    id: string;
    status: PayoutBatchStatus;
    syncing?: boolean | null;
    syncTask?: PayoutBatchTask | null;
  };
};

export type PayoutBatchDeleteMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type PayoutBatchDeleteMutation = {
  __typename?: "Mutation";
  deletePayoutBatch: {
    __typename?: "PayoutBatch";
    id: string;
    status: PayoutBatchStatus;
    syncing?: boolean | null;
    syncTask?: PayoutBatchTask | null;
  };
};

export type PayoutAdministrationSetHoldMutationVariables = Exact<{
  orgId: Scalars["String"]["input"];
  onHold: Scalars["Boolean"]["input"];
  comment: Scalars["String"]["input"];
}>;

export type PayoutAdministrationSetHoldMutation = {
  __typename?: "Mutation";
  setPayoutHold: { __typename?: "PayoutComment"; id: string };
};

export type PayoutAdministrationCommentsQueryVariables = Exact<{
  orgId: Scalars["String"]["input"];
}>;

export type PayoutAdministrationCommentsQuery = {
  __typename?: "Query";
  payouts: {
    __typename?: "PayoutQueries";
    comments?: Array<{
      __typename?: "PayoutComment";
      id: string;
      body: string;
      action?: PayoutCommentAction | null;
      createDate?: any | null;
      createUser?: {
        __typename?: "SsoUser";
        userSub: string;
        fullName: string;
      } | null;
    }> | null;
  };
};

export type PayoutAdministrationAddCommentMutationVariables = Exact<{
  orgId: Scalars["String"]["input"];
  body: Scalars["String"]["input"];
}>;

export type PayoutAdministrationAddCommentMutation = {
  __typename?: "Mutation";
  addPayoutComment: { __typename?: "PayoutComment"; id: string };
};

export type ReportDefinitionQueryVariables = Exact<{
  key: Scalars["String"]["input"];
}>;

export type ReportDefinitionQuery = {
  __typename?: "Query";
  report: {
    __typename?: "ReportDefinition";
    key: string;
    name: string;
    description: string;
    parameters: Array<{
      __typename?: "ReportParameter";
      name: string;
      label: string;
      type: ReportParameterType;
      required: boolean;
      placeholder?: string | null;
      helpText?: string | null;
      defaultValue?: string | null;
      options?: Array<{
        __typename?: "ReportParameterOption";
        value: string;
        label: string;
      }> | null;
    }>;
    columns: Array<{
      __typename?: "ReportColumn";
      key: string;
      label: string;
      type: ReportColumnType;
    }>;
  };
};

export type ReportRunQueryVariables = Exact<{
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<
    Array<ReportParameterValueInput> | ReportParameterValueInput
  >;
}>;

export type ReportRunQuery = {
  __typename?: "Query";
  runReport: {
    __typename?: "ReportResult";
    key: string;
    generatedAt: any;
    rows: Array<any>;
    columns: Array<{
      __typename?: "ReportColumn";
      key: string;
      label: string;
      type: ReportColumnType;
    }>;
  };
};

export type ReportExportRowsQueryVariables = Exact<{
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<
    Array<ReportParameterValueInput> | ReportParameterValueInput
  >;
}>;

export type ReportExportRowsQuery = {
  __typename?: "Query";
  reportRows: Array<any>;
};

export type ReportsListQueryVariables = Exact<{ [key: string]: never }>;

export type ReportsListQuery = {
  __typename?: "Query";
  reports: Array<{
    __typename?: "ReportDefinition";
    key: string;
    name: string;
    description: string;
    parameters: Array<{ __typename?: "ReportParameter"; name: string }>;
  }>;
};

export type ResourcesTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ResourceSort>;
}>;

export type ResourcesTableQuery = {
  __typename?: "Query";
  resources: {
    __typename?: "ResourcePage";
    total: number;
    items: Array<{
      __typename?: "ResourceList";
      id: string;
      name: string;
      description?: string | null;
      updated: any;
      type: string;
    }>;
  };
};

export type ViewResourceQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ViewResourceQuery = {
  __typename?: "Query";
  resource: {
    __typename?: "Resource";
    title: string;
    description: string;
    content: Array<{
      __typename?: "ResourceContent";
      title?: string | null;
      type: string;
      columns: {
        __typename?: "ResourceColumns";
        musicPlayerTracks?: Array<
          { __typename?: "ResourceMusicPlayerTracksItem" } & {
            " $fragmentRefs"?: { ResourceTrackFragment: ResourceTrackFragment };
          }
        > | null;
      } & {
        " $fragmentRefs"?: {
          ResourceVideoFragment: ResourceVideoFragment;
          ResourceDocumentFragment: ResourceDocumentFragment;
          ResourceIframeFragment: ResourceIframeFragment;
          ResourceCustomTextFragment: ResourceCustomTextFragment;
          ResourceTextSectionFragment: ResourceTextSectionFragment;
        };
      };
    }>;
  } & { " $fragmentRefs"?: { ResourceHeaderFragment: ResourceHeaderFragment } };
};

export type ResourceCustomTextFragment = {
  __typename?: "ResourceColumns";
  customTextSection?: {
    __typename?: "ResourceCustomTextSection";
    width?: number | null;
    portableText: Array<{
      __typename?: "PortableText";
      _type?: string | null;
      _key?: string | null;
      style?: string | null;
      listItem?: string | null;
      children?: Array<{
        __typename?: "PortableTextChildren";
        text?: string | null;
        marks?: Array<string | null> | null;
        _type?: string | null;
        _key?: string | null;
      } | null> | null;
    }>;
  } | null;
} & { " $fragmentName"?: "ResourceCustomTextFragment" };

export type ResourceDocumentFragment = {
  __typename?: "ResourceColumns";
  document?: {
    __typename?: "ResourceDocument";
    id: string;
    title?: string | null;
    uploadDate?: any | null;
    url: string;
    isDownloadable?: boolean | null;
  } | null;
} & { " $fragmentName"?: "ResourceDocumentFragment" };

export type ResourceHeaderFragment = {
  __typename?: "Resource";
  title: string;
  description: string;
} & { " $fragmentName"?: "ResourceHeaderFragment" };

export type ResourceIframeFragment = {
  __typename?: "ResourceColumns";
  iframe?: { __typename?: "ResourceIframe"; url: string } | null;
} & { " $fragmentName"?: "ResourceIframeFragment" };

export type ResourceTextSectionFragment = {
  __typename?: "ResourceColumns";
  textSection?: {
    __typename?: "ResourceTextSection";
    width?: number | null;
    description?: string | null;
    title?: string | null;
  } | null;
} & { " $fragmentName"?: "ResourceTextSectionFragment" };

export type ResourceTrackFragment = {
  __typename?: "ResourceMusicPlayerTracksItem";
  title?: string | null;
  isDownloadable?: boolean | null;
  url: string;
} & { " $fragmentName"?: "ResourceTrackFragment" };

export type ResourceVideoFragment = {
  __typename?: "ResourceColumns";
  video?: {
    __typename?: "ResourceVideo";
    url?: string | null;
    width?: number | null;
  } | null;
} & { " $fragmentName"?: "ResourceVideoFragment" };

export type AuthRedirectProbeQueryVariables = Exact<{ [key: string]: never }>;

export type AuthRedirectProbeQuery = { __typename: "Query" };

export type UserLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type UserLayoutQuery = {
  __typename?: "Query";
  user: {
    __typename?: "CurrentUser";
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    picture?: string | null;
    orgId: string;
    permissions: Array<string>;
    labApps?: Array<string> | null;
    inOrgs: Array<{
      __typename?: "UserOrg";
      id: string;
      parentOrgId?: string | null;
      name: string;
      workspace?: string | null;
    }>;
    isImInfo?: {
      __typename?: "IsImInfo";
      isIm: boolean;
      title: string;
      body: string;
      disclaimer: string;
      confirmLabel: string;
    } | null;
    subscription?: {
      __typename?: "UserSubscription";
      provider: UserSubscriptionProvider;
      name?: string | null;
      isActive: boolean;
      manageUrl?: string | null;
    } | null;
  };
  org: {
    __typename?: "Org";
    id: string;
    parentOrgId?: string | null;
    name: string;
    workspace?: string | null;
    loginMethods: Array<OrgLoginMethods>;
    metadata?: {
      __typename?: "OrgMetadata";
      analytics?: {
        __typename?: "OrgMetadataAnalytics";
        heap?: {
          __typename?: "OrgMetadataAnalyticsHeap";
          enabled: boolean;
        } | null;
      } | null;
      assets?: {
        __typename?: "OrgMetadataAssets";
        logo?: string | null;
        background?: string | null;
      } | null;
    } | null;
  };
};

export type ThankYouQueryVariables = Exact<{
  input: SignatureDocumentQueryInput;
}>;

export type ThankYouQuery = {
  __typename?: "Query";
  signatureDocument: {
    __typename?: "SignatureDocument";
    pdfBase64: string;
    status: SignatureDocumentStatus;
  } & {
    " $fragmentRefs"?: {
      DocumentDisplayFragment: DocumentDisplayFragment;
      WelcomeDialogFragment: WelcomeDialogFragment;
    };
  };
};

export type ViewDocumentQueryVariables = Exact<{
  input: SignatureDocumentQueryInput;
}>;

export type ViewDocumentQuery = {
  __typename?: "Query";
  signatureDocument: {
    __typename?: "SignatureDocument";
    documentId: string;
    status: SignatureDocumentStatus;
    signatories: Array<{
      __typename?: "SignatureDocumentSignatory";
      signatoryId: string;
      status: SignatoryStatus;
    }>;
  } & {
    " $fragmentRefs"?: {
      DocumentDisplayFragment: DocumentDisplayFragment;
      WelcomeDialogFragment: WelcomeDialogFragment;
      ConfirmDialogFragment: ConfirmDialogFragment;
      SignatureDialogFragment: SignatureDialogFragment;
      DeclineDialogFragment: DeclineDialogFragment;
    };
  };
};

export type ViewDocumentFeedSubscriptionVariables = Exact<{
  documentId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
}>;

export type ViewDocumentFeedSubscription = {
  __typename?: "Subscription";
  documentUpdated: boolean;
};

export type ConfirmDialogFragment = {
  __typename?: "SignatureDocument";
  documentId: string;
  userConfirmData?: boolean | null;
  signatories: Array<{
    __typename?: "SignatureDocumentSignatory";
    signatoryId: string;
    firstName: string;
    lastName: string;
    companyName?: string | null;
  }>;
} & { " $fragmentName"?: "ConfirmDialogFragment" };

export type ConfirmDialogSubmitMutationVariables = Exact<{
  input: SignatureDocumentSignatoryUpdateInput;
}>;

export type ConfirmDialogSubmitMutation = {
  __typename?: "Mutation";
  updateSignatory: {
    __typename?: "SignatureDocumentSignatoryUpdateResponse";
    documentId: string;
    signatoryId: string;
  };
};

export type DeclineDialogFragment = {
  __typename?: "SignatureDocument";
  documentId: string;
  templateKey: string;
  sessionId?: string | null;
  signatories: Array<{
    __typename?: "SignatureDocumentSignatory";
    signatoryId: string;
  }>;
} & { " $fragmentName"?: "DeclineDialogFragment" };

export type DeclineDialogQueryVariables = Exact<{
  templateKey: Scalars["String"]["input"];
}>;

export type DeclineDialogQuery = {
  __typename?: "Query";
  signatureDocumentTemplate: {
    __typename?: "SignatureDocumentTemplate";
    declineReasons: Array<{
      __typename?: "SignatureDocumentDeclineReason";
      reasonKey: string;
      reasonText: string;
    }>;
  };
};

export type DeclineDialogSubmitMutationVariables = Exact<{
  input: SignatureDocumentDeclineInput;
}>;

export type DeclineDialogSubmitMutation = {
  __typename?: "Mutation";
  declineSignatureDocument: {
    __typename?: "SignatureDocument";
    documentId: string;
    declineRedirectUrl?: string | null;
  };
};

export type SignatureDialogFragment = {
  __typename?: "SignatureDocument";
  documentId: string;
  sessionId?: string | null;
  signatories: Array<{
    __typename?: "SignatureDocumentSignatory";
    signatoryId: string;
    status: SignatoryStatus;
  }>;
} & { " $fragmentName"?: "SignatureDialogFragment" };

export type SignatureDialogFeedSubscriptionVariables = Exact<{
  sessionId: Scalars["String"]["input"];
}>;

export type SignatureDialogFeedSubscription = {
  __typename?: "Subscription";
  sessionUpdated?: { __typename?: "SessionUpdate"; event: SessionEvent } | null;
};

export type SignatureDialogSubmitMutationVariables = Exact<{
  input: SignatureDocumentSignInput;
}>;

export type SignatureDialogSubmitMutation = {
  __typename?: "Mutation";
  signSignatureDocument: {
    __typename?: "SignatureDocument";
    documentId: string;
    successRedirectUrl?: string | null;
  };
};

export type DocumentDisplayFragment = {
  __typename?: "SignatureDocument";
  documentId: string;
  pdfBase64: string;
} & { " $fragmentName"?: "DocumentDisplayFragment" };

export type WelcomeDialogFragment = {
  __typename?: "SignatureDocument";
  documentId: string;
  hideWelcomeDialog?: boolean | null;
  signatories: Array<{
    __typename?: "SignatureDocumentSignatory";
    firstName: string;
    lastName: string;
  }>;
} & { " $fragmentName"?: "WelcomeDialogFragment" };

export type AddClientAddMutationVariables = Exact<{
  clientInput: AddClientInput;
}>;

export type AddClientAddMutation = {
  __typename?: "Mutation";
  addClient?: { __typename?: "Client"; id: string } | null;
};

export type YoutubeChannelCanonicalQueryVariables = Exact<{
  url: Scalars["String"]["input"];
}>;

export type YoutubeChannelCanonicalQuery = {
  __typename?: "Query";
  youtubeChannel?: {
    __typename?: "YouTubeChannelMetadata";
    id?: string | null;
    canonical?: string | null;
  } | null;
};

export type CreateClearanceMutationVariables = Exact<{
  input: ClearanceCreateInput;
}>;

export type CreateClearanceMutation = {
  __typename?: "Mutation";
  createClearance?: { __typename?: "Clearance"; id: string } | null;
};

export type EditClearanceQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type EditClearanceQuery = {
  __typename?: "Query";
  clearance: {
    __typename?: "Clearance";
    id: string;
    clientId: string;
    clientName?: string | null;
    endDate?: any | null;
    startDate?: any | null;
    notes?: string | null;
    media: {
      __typename?: "ClearanceMedia";
      id: string;
      url: string;
      type: ClearanceMediaType;
      platform: ClearanceMediaPlatform;
    };
  };
};

export type EditClearanceEditMutationVariables = Exact<{
  input: ClearanceUpdateInput;
}>;

export type EditClearanceEditMutation = {
  __typename?: "Mutation";
  updateClearance?: { __typename?: "Clearance"; id: string } | null;
};

export type EditClearanceExpireMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type EditClearanceExpireMutation = {
  __typename?: "Mutation";
  expireClearance?: {
    __typename?: "Clearance";
    id: string;
    status: ClearanceStatus;
  } | null;
};

export type ClearancesTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<ClearanceMediaType>;
  platform?: InputMaybe<ClearanceMediaPlatform>;
  status?: InputMaybe<ClearanceStatus>;
  sortBy?: InputMaybe<ClearanceSort>;
}>;

export type ClearancesTableQuery = {
  __typename?: "Query";
  clearances: {
    __typename?: "ClearancePage";
    total: number;
    items: Array<{
      __typename?: "Clearance";
      id: string;
      clientName?: string | null;
      clientId: string;
      startDate?: any | null;
      endDate?: any | null;
      status: ClearanceStatus;
      media: {
        __typename?: "ClearanceMedia";
        id: string;
        type: ClearanceMediaType;
        platform: ClearanceMediaPlatform;
      };
    }>;
  };
};

export type ClientsTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy?: InputMaybe<ClientSort>;
}>;

export type ClientsTableQuery = {
  __typename?: "Query";
  clients: {
    __typename?: "ClientPage";
    total: number;
    items: Array<{
      __typename?: "Client";
      id: string;
      name: string;
      contact: string;
      email: string;
    }>;
  };
};

export type UpdateClientQueryVariables = Exact<{
  clientId: Scalars["ID"]["input"];
}>;

export type UpdateClientQuery = {
  __typename?: "Query";
  client: {
    __typename?: "Client";
    id: string;
    name: string;
    contact: string;
    email: string;
  };
};

export type UpdateClientUpdateMutationVariables = Exact<{
  clientInput: UpdateClientInput;
}>;

export type UpdateClientUpdateMutation = {
  __typename?: "Mutation";
  updateClient?: { __typename: "Client" } | null;
};

export type ViewClearanceQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewClearanceQuery = {
  __typename?: "Query";
  clearance: {
    __typename?: "Clearance";
    id: string;
    clientName?: string | null;
    endDate?: any | null;
    startDate?: any | null;
    status: ClearanceStatus;
    notes?: string | null;
    media: {
      __typename?: "ClearanceMedia";
      id: string;
      type: ClearanceMediaType;
      url: string;
      platform: ClearanceMediaPlatform;
    };
  };
};

export type ViewClientQueryVariables = Exact<{
  clientId: Scalars["ID"]["input"];
}>;

export type ViewClientQuery = {
  __typename?: "Query";
  client: { __typename?: "Client"; id: string; name: string } & {
    " $fragmentRefs"?: { ClientHeaderFragment: ClientHeaderFragment };
  };
};

export type ClientClearancesTableQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  clientId: Scalars["ID"]["input"];
  sortBy: ClearanceSort;
}>;

export type ClientClearancesTableQuery = {
  __typename?: "Query";
  clearances: {
    __typename?: "ClearancePage";
    total: number;
    items: Array<{
      __typename?: "Clearance";
      id: string;
      startDate?: any | null;
      endDate?: any | null;
      status: ClearanceStatus;
      media: {
        __typename?: "ClearanceMedia";
        id: string;
        type: ClearanceMediaType;
        platform: ClearanceMediaPlatform;
      };
    }>;
  };
};

export type ClientHeaderFragment = {
  __typename?: "Client";
  id: string;
  name: string;
  contact: string;
  email: string;
} & { " $fragmentName"?: "ClientHeaderFragment" };

export type ClientFieldQueryVariables = Exact<{ [key: string]: never }>;

export type ClientFieldQuery = {
  __typename?: "Query";
  clients: {
    __typename?: "ClientPage";
    items: Array<{ __typename?: "Client"; id: string; name: string }>;
  };
};

export type TiktokProfileQueryVariables = Exact<{
  url: Scalars["String"]["input"];
}>;

export type TiktokProfileQuery = {
  __typename?: "Query";
  tikTokOembed?: {
    __typename?: "TikTokOembed";
    html?: string | null;
    type?: string | null;
  } | null;
};

export type YoutubeChannelPreviewQueryVariables = Exact<{
  url: Scalars["String"]["input"];
}>;

export type YoutubeChannelPreviewQuery = {
  __typename?: "Query";
  youtubeChannel?: {
    __typename?: "YouTubeChannelMetadata";
    id?: string | null;
    title?: string | null;
    image?: string | null;
    description?: string | null;
  } | null;
};

export type StatementImportBatchViewQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type StatementImportBatchViewQuery = {
  __typename?: "Query";
  statementImports: {
    __typename?: "StatementImportQueries";
    batch?: {
      __typename?: "StatementImportBatch";
      id: string;
      format: ImportFormat;
      status: ImportBatchStatus;
      isStale: boolean;
      fileName: string;
      periodIds: Array<string>;
      currency: string;
      warnings: Array<string>;
      error?: string | null;
      createDate?: any | null;
      skippedRows: Array<{
        __typename?: "StatementImportSkippedRow";
        rowNumber: number;
        beneficiaryCode: string;
        amount: number;
      }>;
      totals: {
        __typename?: "StatementImportTotals";
        rowCount: number;
        matchedCount: number;
        unmatchedCount: number;
        zeroBalanceCount: number;
        totalAmount: number;
      };
      selection?: {
        __typename?: "StatementImportSelection";
        generateCount: number;
        generateAmount: number;
        payCount: number;
        payAmount: number;
        statementCount: number;
        paidCount: number;
      } | null;
      createUser?: {
        __typename?: "SsoUser";
        userSub: string;
        fullName: string;
      } | null;
    } | null;
  };
};

export type StatementImportSetIncludedMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
  dataIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  included: Scalars["Boolean"]["input"];
}>;

export type StatementImportSetIncludedMutation = {
  __typename?: "Mutation";
  statementImportSetIncluded: number;
};

export type StatementImportSetAllIncludedMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
  included: Scalars["Boolean"]["input"];
  status?: InputMaybe<ImportDataStatus>;
}>;

export type StatementImportSetAllIncludedMutation = {
  __typename?: "Mutation";
  statementImportSetAllIncluded: number;
};

export type StatementImportGenerateMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
}>;

export type StatementImportGenerateMutation = {
  __typename?: "Mutation";
  statementImportGenerateStatements: {
    __typename?: "StatementImportBatch";
    id: string;
    status: ImportBatchStatus;
    error?: string | null;
    selection?: {
      __typename?: "StatementImportSelection";
      generateCount: number;
      generateAmount: number;
      payCount: number;
      payAmount: number;
    } | null;
  };
};

export type StatementImportPayMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
  dataIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type StatementImportPayMutation = {
  __typename?: "Mutation";
  statementImportPay: {
    __typename?: "StatementImportBatch";
    id: string;
    status: ImportBatchStatus;
    error?: string | null;
    selection?: {
      __typename?: "StatementImportSelection";
      generateCount: number;
      generateAmount: number;
      payCount: number;
      payAmount: number;
    } | null;
  };
};

export type StatementImportCancelMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
}>;

export type StatementImportCancelMutation = {
  __typename?: "Mutation";
  statementImportCancelBatch: {
    __typename?: "StatementImportBatch";
    id: string;
    status: ImportBatchStatus;
    error?: string | null;
  };
};

export type StatementImportDataTableQueryVariables = Exact<{
  batchId: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  statuses?: InputMaybe<Array<ImportDataStatus> | ImportDataStatus>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<StatementImportDataSort>;
}>;

export type StatementImportDataTableQuery = {
  __typename?: "Query";
  statementImports: {
    __typename?: "StatementImportQueries";
    data?: {
      __typename?: "StatementImportDataPage";
      totalCount: number;
      totalAmount: number;
      items: Array<{
        __typename?: "StatementImportData";
        id: string;
        status: ImportDataStatus;
        beneficiaryCode: string;
        externalUserId: number;
        periodId: string;
        currency: string;
        amount: number;
        statementReference?: string | null;
        matchedOrgId?: string | null;
        companyName?: string | null;
        emailAddress?: string | null;
        included: boolean;
        statementId?: string | null;
      }>;
    } | null;
    batch?: {
      __typename?: "StatementImportBatch";
      id: string;
      selection?: {
        __typename?: "StatementImportSelection";
        generateCount: number;
        generateAmount: number;
        payCount: number;
        payAmount: number;
        statementCount: number;
        paidCount: number;
      } | null;
    } | null;
  };
};

export type StatementImportsTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type StatementImportsTableQuery = {
  __typename?: "Query";
  statementImports: {
    __typename?: "StatementImportQueries";
    batches?: Array<{
      __typename?: "StatementImportBatch";
      id: string;
      format: ImportFormat;
      status: ImportBatchStatus;
      fileName: string;
      periodIds: Array<string>;
      currency: string;
      error?: string | null;
      createDate?: any | null;
      totals: {
        __typename?: "StatementImportTotals";
        rowCount: number;
        matchedCount: number;
        unmatchedCount: number;
        zeroBalanceCount: number;
        totalAmount: number;
      };
      createUser?: {
        __typename?: "SsoUser";
        userSub: string;
        fullName: string;
      } | null;
    }> | null;
  };
};

export type StatementImportCreateBatchMutationVariables = Exact<{
  input: StatementImportCreateBatchInput;
}>;

export type StatementImportCreateBatchMutation = {
  __typename?: "Mutation";
  statementImportCreateBatch: {
    __typename?: "StatementImportBatch";
    id: string;
    status: ImportBatchStatus;
    error?: string | null;
  };
};

export type StatementImportDeleteBatchMutationVariables = Exact<{
  batchId: Scalars["String"]["input"];
}>;

export type StatementImportDeleteBatchMutation = {
  __typename?: "Mutation";
  statementImportDeleteBatch: boolean;
};

export type StatementsTableQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  years?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
  months?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
  service?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<StatementPaymentStatus> | StatementPaymentStatus>;
  sortBy?: InputMaybe<StatementSort>;
}>;

export type StatementsTableQuery = {
  __typename?: "Query";
  statementYears: Array<number>;
  statementServices: Array<string>;
  statementPaymentStatuses: Array<StatementPaymentStatus>;
  statements: {
    __typename?: "StatementPage";
    total: number;
    items: Array<{
      __typename?: "Statement";
      id: string;
      period: Array<any>;
      issued: any;
      service: string;
      netRevenue: number;
      details: Array<{
        __typename?: "StatementDetail";
        label: string;
        value: string;
      }>;
      report: { __typename?: "StatementReport"; sourceUrl: string };
      payment: {
        __typename?: "StatementPayment";
        status: StatementPaymentStatus;
      };
    }>;
  };
};

export type StatementsExportButtonQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StatementsExportButtonQuery = {
  __typename?: "Query";
  statements: {
    __typename?: "StatementPage";
    items: Array<{
      __typename?: "Statement";
      id: string;
      period: Array<any>;
      issued: any;
      service: string;
      netRevenue: number;
      payment: {
        __typename?: "StatementPayment";
        status: StatementPaymentStatus;
      };
    }>;
  };
};

export type StatementsBalanceQueryVariables = Exact<{ [key: string]: never }>;

export type StatementsBalanceQuery = {
  __typename?: "Query";
  payoutBalance: {
    __typename?: "PayoutBalance";
    balanceCents: number;
    pendingPayoutCents: number;
    minimumPayoutCents: number;
    currency: string;
    payoutSetupComplete?: boolean | null;
  };
};

export type StatementsUpdatePayoutMinimumMutationVariables = Exact<{
  minimumPayoutCents: Scalars["Int"]["input"];
}>;

export type StatementsUpdatePayoutMinimumMutation = {
  __typename?: "Mutation";
  updatePayoutMinimum: {
    __typename?: "PayoutBalance";
    minimumPayoutCents: number;
  };
};

export type ViewStatementQueryVariables = Exact<{
  statementId: Scalars["String"]["input"];
}>;

export type ViewStatementQuery = {
  __typename?: "Query";
  statement: {
    __typename?: "Statement";
    id: string;
    period: Array<any>;
    service: string;
  } & {
    " $fragmentRefs"?: {
      StatementHeaderFragment: StatementHeaderFragment;
      StatementParticularsFragment: StatementParticularsFragment;
      StatementDetailsFragment: StatementDetailsFragment;
    };
  };
};

export type StatementDetailsFragment = {
  __typename?: "Statement";
  details: Array<{
    __typename?: "StatementDetail";
    label: string;
    value: string;
  }>;
} & { " $fragmentName"?: "StatementDetailsFragment" };

export type StatementHeaderFragment = {
  __typename?: "Statement";
  id: string;
  period: Array<any>;
  service: string;
  orgId: string;
  orgName?: string | null;
  report: { __typename?: "StatementReport"; sourceUrl: string };
} & { " $fragmentName"?: "StatementHeaderFragment" };

export type StatementParticularsFragment = {
  __typename?: "Statement";
  service: string;
  period: Array<any>;
  issued: any;
  information?: string | null;
  id: string;
  payment: {
    __typename?: "StatementPayment";
    status: StatementPaymentStatus;
    date?: any | null;
  };
} & { " $fragmentName"?: "StatementParticularsFragment" };

export type DownloadStatementButtonQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DownloadStatementButtonQuery = {
  __typename?: "Query";
  statement: {
    __typename?: "Statement";
    id: string;
    report: {
      __typename?: "StatementReport";
      file?: {
        __typename?: "StatementReportFile";
        temporaryUrl?: string | null;
      } | null;
    };
  };
};

export const LibraryLicensesSummary_YearsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryLicensesSummary_Years" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryLicensesSummary" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "years" } }],
      },
    },
  ],
} as unknown as DocumentNode<LibraryLicensesSummary_YearsFragment, unknown>;
export const CommercialLicenseContactsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseContacts" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectLeads" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalContacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseContactsFragment, unknown>;
export const CommercialLicenseDocumentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseDocuments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "uploadDate" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseDocumentsFragment, unknown>;
export const CommercialLicenseHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "campaignName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseHeaderFragment, unknown>;
export const CommercialLicenseServicesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseServices" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "serviceType" } },
                { kind: "Field", name: { kind: "Name", value: "musicType" } },
                { kind: "Field", name: { kind: "Name", value: "cost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyCode" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseServicesFragment, unknown>;
export const CommercialLicenseTermFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTermFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTerm" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "territories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "included" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "finalTracks" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseTermFragmentFragment, unknown>;
export const CommercialLicenseTermsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTerms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeRemaining" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CommercialLicenseTermFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTermFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTerm" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "territories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "included" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "finalTracks" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseTermsFragment, unknown>;
export const TrackPlayerFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackPlayerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrackAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackPlayerFragmentFragment, unknown>;
export const TrackAttachmentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackAttachments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrack" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackPlayerFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackPlayerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrackAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackAttachmentsFragment, unknown>;
export const CommercialLicenseTracksFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTracks" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "artist" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackAttachments" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackPlayerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrackAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackAttachments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrack" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackPlayerFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommercialLicenseTracksFragment, unknown>;
export const AudioContextTrackFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AudioContextTrackFragment, unknown>;
export const ArtistGalleryTileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArtistGalleryTileFragment, unknown>;
export const ArtistGalleryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ArtistGalleryTile" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArtistGalleryFragment, unknown>;
export const TrackFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackFragment, unknown>;
export const TrackActionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackActionsFragment, unknown>;
export const TrackListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackListFragment, unknown>;
export const RenameCollectionPanel_FragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RenameCollectionPanel_Fragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameCollectionPanel_FragmentFragment, unknown>;
export const ChannelHeadingFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChannelHeading" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Channel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "platform" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelHeadingFragment, unknown>;
export const ViewChannelInfoBodyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewChannelInfoBody" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Channel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "platform" } },
          { kind: "Field", name: { kind: "Name", value: "handle" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "createDate" } },
          { kind: "Field", name: { kind: "Name", value: "changeDate" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userSub" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewChannelInfoBodyFragment, unknown>;
export const ArtistHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "segmentTracksCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "albumsCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mostCommonGenre" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArtistHeaderFragment, unknown>;
export const PlaylistBulkActionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistBulkActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistBulkActionsFragment, unknown>;
export const PlaylistHeaderActionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistHeaderActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "liked" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "segmentTracksCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistHeaderActionsFragment, unknown>;
export const PlaylistHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "hasCustomImage" } },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "shareable" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistHeaderActions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistHeaderActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "liked" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "segmentTracksCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistHeaderFragment, unknown>;
export const PlaylistGalleryTileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistGalleryTileFragment, unknown>;
export const PlaylistGalleryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistGalleryFragment, unknown>;
export const SearchLandingCuratedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchLandingCurated" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Query" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "curated" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "curatedPageSize" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "all" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "PlaylistGallery" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchLandingCuratedFragment, unknown>;
export const AudioVersionItem_TrackFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioVersionItem_Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "normal" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AudioVersionItem_TrackFragment, unknown>;
export const TrackDetailsAnalysisFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetailsAnalysis" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "analysis" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "characteristics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "genre" } },
                      { kind: "Field", name: { kind: "Name", value: "mood" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vocals" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tempo" } },
                      { kind: "Field", name: { kind: "Name", value: "bpm" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "decade" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useCasePredictions" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visuals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subGenres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "moods" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackDetailsAnalysisFragment, unknown>;
export const TrackDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackDetailsFragment, unknown>;
export const TrackHeaderTrackActionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackHeaderTrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackHeaderTrackActionsFragment, unknown>;
export const TrackHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genres" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackHeaderTrackActions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackHeaderTrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackHeaderFragment, unknown>;
export const SharedArtistHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SharedArtistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "albumsCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mostCommonGenre" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SharedArtistHeaderFragment, unknown>;
export const NotificationItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Notification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "avatar" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "dest" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationItemFragment, unknown>;
export const OrgUsers_OrgRolesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_OrgRoles" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgUsers_OrgRolesFragment, unknown>;
export const OrgUsers_RolesColumnFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_RolesColumn" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgUsers_RolesColumnFragment, unknown>;
export const OrgUsers_UpdateModalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_UpdateModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgUsers_UpdateModalFragment, unknown>;
export const ResourceCustomTextFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceCustomText" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customTextSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "width" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "portableText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_type" } },
                      { kind: "Field", name: { kind: "Name", value: "_key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "marks" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_key" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "style" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listItem" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceCustomTextFragment, unknown>;
export const ResourceDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "document" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "uploadDate" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isDownloadable" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceDocumentFragment, unknown>;
export const ResourceHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceHeaderFragment, unknown>;
export const ResourceIframeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceIframe" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "iframe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceIframeFragment, unknown>;
export const ResourceTextSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTextSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "textSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceTextSectionFragment, unknown>;
export const ResourceTrackFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceMusicPlayerTracksItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isDownloadable" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceTrackFragment, unknown>;
export const ResourceVideoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceVideo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "video" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceVideoFragment, unknown>;
export const ConfirmDialogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConfirmDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "userConfirmData" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmDialogFragment, unknown>;
export const DeclineDialogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeclineDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "templateKey" } },
          { kind: "Field", name: { kind: "Name", value: "sessionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeclineDialogFragment, unknown>;
export const SignatureDialogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SignatureDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "sessionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SignatureDialogFragment, unknown>;
export const DocumentDisplayFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentDisplay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "pdfBase64" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentDisplayFragment, unknown>;
export const WelcomeDialogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WelcomeDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "hideWelcomeDialog" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WelcomeDialogFragment, unknown>;
export const ClientHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "contact" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientHeaderFragment, unknown>;
export const StatementDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatementDetailsFragment, unknown>;
export const StatementHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "service" } },
          { kind: "Field", name: { kind: "Name", value: "orgId" } },
          { kind: "Field", name: { kind: "Name", value: "orgName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "report" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sourceUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatementHeaderFragment, unknown>;
export const StatementParticularsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementParticulars" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "issued" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "information" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatementParticularsFragment, unknown>;
export const DistributionSigninLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DistributionSigninLink" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "distribution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signinLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DistributionSigninLinkQuery,
  DistributionSigninLinkQueryVariables
>;
export const SourceSigninDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SourceSignin" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceSigninQuery, SourceSigninQueryVariables>;
export const SubscribeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Subscribe" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manageUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscribePlans" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "billingMonths" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxArtists" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "artistsAddOn" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "defaultQuantity",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxQuantity",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "pricing" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tiers" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endingQuantity",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "unitAmount",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subscribeUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscribeQuery, SubscribeQueryVariables>;
export const LabsDatastoreSaveCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsDatastoreSaveCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandDatastoreResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsDatastoreSaveCommandQuery,
  LabsDatastoreSaveCommandQueryVariables
>;
export const LabsDatastoreLoadCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsDatastoreLoadCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandDatastoreResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "data" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsDatastoreLoadCommandQuery,
  LabsDatastoreLoadCommandQueryVariables
>;
export const LabsDatastoreSearchCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsDatastoreSearchCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandDatastoreResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsDatastoreSearchCommandQuery,
  LabsDatastoreSearchCommandQueryVariables
>;
export const LabsDatastoreDeleteCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsDatastoreDeleteCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandDatastoreResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsDatastoreDeleteCommandQuery,
  LabsDatastoreDeleteCommandQueryVariables
>;
export const LabsDatastoreCountCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsDatastoreCountCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandDatastoreResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsDatastoreCountCommandQuery,
  LabsDatastoreCountCommandQueryVariables
>;
export const LabsServiceCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsServiceCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LabsCommandGeminiResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finishReason" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsServiceCommandQuery,
  LabsServiceCommandQueryVariables
>;
export const LabsServiceCommandInitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsServiceCommandInit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LabsCommandInitResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authToken" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsServiceCommandInitQuery,
  LabsServiceCommandInitQueryVariables
>;
export const LabsServiceCommandLogErrorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsServiceCommandLogError" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandLogErrorResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsServiceCommandLogErrorQuery,
  LabsServiceCommandLogErrorQueryVariables
>;
export const LabsMusicSearchCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsMusicSearchCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandMusicSearchResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "artists" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "traits" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "youtubeSafe",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "explicit" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "vocals" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "audioUrls" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "low" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "normal" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "high" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "veryHigh" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "waveform" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "length" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userMeta" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "liked" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsMusicSearchCommandQuery,
  LabsMusicSearchCommandQueryVariables
>;
export const LabsServiceCommandUserActionLogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabsServiceCommandUserActionLog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabsCommandInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labsServiceCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LabsCommandUserActionLogResponse",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabsServiceCommandUserActionLogQuery,
  LabsServiceCommandUserActionLogQueryVariables
>;
export const LabAppEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabAppEdit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "env" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LabAppEnvironment" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "env" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "env" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayOrder" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "hostingUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localDevelopmentUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repositoryLink" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "members" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parameters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "secrets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "apiKey" } },
                { kind: "Field", name: { kind: "Name", value: "bridgeKey" } },
                { kind: "Field", name: { kind: "Name", value: "labsVersion" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gemini" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "geminiModel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "musicSearch" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataStore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heapTracking" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "datastoreTables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "scope" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "replaceDataOnMerge" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "searchable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "caseInsensitive" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rateLimits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appWide" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gemini" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "musicSearch" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataStore" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hideBottomBar" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowFullscreen" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultViewInDraftMode" },
                },
                { kind: "Field", name: { kind: "Name", value: "categoryId" } },
                { kind: "Field", name: { kind: "Name", value: "linkedAppId" } },
                { kind: "Field", name: { kind: "Name", value: "env" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "geminiModels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "labAppId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "env" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "env" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabAppEditQuery, LabAppEditQueryVariables>;
export const LabAppEditSaveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppEditSave" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabAppInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "env" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LabAppEnvironment" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "env" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "env" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayOrder" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "hostingUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localDevelopmentUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repositoryLink" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "members" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parameters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "secrets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "labsVersion" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gemini" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "geminiModel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "musicSearch" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataStore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heapTracking" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "datastoreTables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "scope" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "replaceDataOnMerge" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "searchable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "caseInsensitive" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rateLimits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appWide" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gemini" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "musicSearch" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataStore" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "useRateLimiting",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "maxRequests",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "windowSeconds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hideBottomBar" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowFullscreen" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultViewInDraftMode" },
                },
                { kind: "Field", name: { kind: "Name", value: "categoryId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppEditSaveMutation,
  LabAppEditSaveMutationVariables
>;
export const LabAppEditMergeDevDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppEditMergeDev" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeDevToProduction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppEditMergeDevMutation,
  LabAppEditMergeDevMutationVariables
>;
export const LabAppEditDevDifferencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabAppEditDevDifferences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "appDevDifferences" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "field" } },
                { kind: "Field", name: { kind: "Name", value: "prodValue" } },
                { kind: "Field", name: { kind: "Name", value: "devValue" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changeType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prodData" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "devData" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppEditDevDifferencesQuery,
  LabAppEditDevDifferencesQueryVariables
>;
export const LabAppEditRevertDevFieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppEditRevertDevField" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "field" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revertDevField" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "field" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "field" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppEditRevertDevFieldMutation,
  LabAppEditRevertDevFieldMutationVariables
>;
export const AccessSelectDialog_OrgsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccessSelectDialog_Orgs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccessSelectDialog_OrgsQuery,
  AccessSelectDialog_OrgsQueryVariables
>;
export const AccessSelectDialog_UsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccessSelectDialog_Users" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccessSelectDialog_UsersQuery,
  AccessSelectDialog_UsersQueryVariables
>;
export const LabAppEditLegalDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabAppEditLegalDocuments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "legalDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppEditLegalDocumentsQuery,
  LabAppEditLegalDocumentsQueryVariables
>;
export const LabAppDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabApp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "env" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LabAppEnvironment" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "env" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "env" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "hostingUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parametersEncoded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gemini" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "musicSearch" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataStore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heapTracking" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastUpdatedOn" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hideBottomBar" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowFullscreen" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultViewInDraftMode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localDevelopmentUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestLabsPackageVersion" },
                },
                { kind: "Field", name: { kind: "Name", value: "labsVersion" } },
                { kind: "Field", name: { kind: "Name", value: "env" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabAppQuery, LabAppQueryVariables>;
export const LabAppsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LabApps" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apps" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "categoryId" } },
                { kind: "Field", name: { kind: "Name", value: "isFavorited" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabAppsQuery, LabAppsQueryVariables>;
export const LabAppsDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppsDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteApp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppsDeleteMutation,
  LabAppsDeleteMutationVariables
>;
export const LabAppsCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppsCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "label" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createApp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "label" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "label" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppsCreateMutation,
  LabAppsCreateMutationVariables
>;
export const LabAppsAddFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppsAddFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "labAppId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLabAppFavorite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "labAppId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "labAppId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppsAddFavoriteMutation,
  LabAppsAddFavoriteMutationVariables
>;
export const LabAppsDeleteFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppsDeleteFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "labAppId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLabAppFavorite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "labAppId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "labAppId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppsDeleteFavoriteMutation,
  LabAppsDeleteFavoriteMutationVariables
>;
export const LabAppsUpdateCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LabAppsUpdateCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "LabCategoryInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLabCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LabAppsUpdateCategoriesMutation,
  LabAppsUpdateCategoriesMutationVariables
>;
export const DatastoreAdminRecordsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DatastoreAdminRecords" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabDatastoreAdminQueryInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "labAppId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "env" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LabAppEnvironment" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "datastoreAdminRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "scope" } },
                      { kind: "Field", name: { kind: "Name", value: "data" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "app" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "labAppId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "env" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "env" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "datastoreTables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tableName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "scope" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DatastoreAdminRecordsQuery,
  DatastoreAdminRecordsQueryVariables
>;
export const DatastoreAdminUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DatastoreAdminUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabDatastoreAdminUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateDatastoreAdminRecord" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "scope" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DatastoreAdminUpdateMutation,
  DatastoreAdminUpdateMutationVariables
>;
export const DatastoreAdminDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DatastoreAdminDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabDatastoreAdminDeleteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDatastoreAdminRecords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DatastoreAdminDeleteMutation,
  DatastoreAdminDeleteMutationVariables
>;
export const DatastoreAdminCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DatastoreAdminCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LabDatastoreAdminCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createDatastoreAdminRecord" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "scope" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DatastoreAdminCreateMutation,
  DatastoreAdminCreateMutationVariables
>;
export const LegalAgreementPendingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LegalAgreementPending" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "keys" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pendingLegalAgreements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "keys" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "keys" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiresScrollToAccept" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousAcceptedVersion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirmations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalAgreementPendingQuery,
  LegalAgreementPendingQueryVariables
>;
export const LegalAgreementRecordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LegalAgreementRecord" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RecordLegalAgreementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recordLegalAgreement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "agreedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalAgreementRecordMutation,
  LegalAgreementRecordMutationVariables
>;
export const LegalDocumentEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LegalDocumentEdit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "version" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "legalDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "version" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "version" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousVersionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiresReagreement" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiresScrollToAccept" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "createDate" } },
                { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userSub" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirmations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalDocumentEditQuery,
  LegalDocumentEditQueryVariables
>;
export const LegalDocumentEditSaveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LegalDocumentEditSave" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateLegalDocumentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLegalDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousVersionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiresReagreement" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiresScrollToAccept" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "createDate" } },
                { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userSub" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirmations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalDocumentEditSaveMutation,
  LegalDocumentEditSaveMutationVariables
>;
export const LegalDocumentHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LegalDocumentHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "legalDocumentChangeLog" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userSub" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalDocumentHistoryQuery,
  LegalDocumentHistoryQueryVariables
>;
export const LegalCreateDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LegalCreateDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateLegalDocumentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLegalDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalCreateDocumentMutation,
  LegalCreateDocumentMutationVariables
>;
export const LegalDocumentsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LegalDocumentsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "legalDocuments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effectiveDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changeDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requiresReagreement" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalDocumentsListQuery,
  LegalDocumentsListQueryVariables
>;
export const LegalDocumentsDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LegalDocumentsDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLegalDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LegalDocumentsDeleteMutation,
  LegalDocumentsDeleteMutationVariables
>;
export const CommercialLicensesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CommercialLicenses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CommercialLicenseStatus" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CommercialLicenseSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "commercialLicenses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "brand" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terms" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "territories" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "included" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mediaType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timeRemaining" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommercialLicensesQuery,
  CommercialLicensesQueryVariables
>;
export const LibraryLicensesSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LibraryLicensesSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "years" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryLicensesSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "years" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "years" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                { kind: "Field", name: { kind: "Name", value: "years" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryLicensesSummary_Years" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryLicensesSummary_Years" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryLicensesSummary" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "years" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  LibraryLicensesSummaryQuery,
  LibraryLicensesSummaryQueryVariables
>;
export const LibraryLicensesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LibraryLicenses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LibraryLicenseSort" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "years" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryLicenses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "years" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "years" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "trackTitle" } },
                { kind: "Field", name: { kind: "Name", value: "trackArtist" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaredByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "goLiveDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                },
                { kind: "Field", name: { kind: "Name", value: "orgName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LibraryLicensesQuery,
  LibraryLicensesQueryVariables
>;
export const LibraryLicensesExportButtonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LibraryLicensesExportButton" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LibraryLicenseSort" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "years" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryLicenses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "years" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "years" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "trackId" } },
                { kind: "Field", name: { kind: "Name", value: "trackTitle" } },
                { kind: "Field", name: { kind: "Name", value: "trackArtist" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaredByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaredDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessBrand" },
                },
                { kind: "Field", name: { kind: "Name", value: "regions" } },
                { kind: "Field", name: { kind: "Name", value: "goLiveDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "channels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LibraryLicensesExportButtonQuery,
  LibraryLicensesExportButtonQueryVariables
>;
export const ViewCommercialLicenseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewCommercialLicense" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "commercialLicense" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseHeader" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseTracks" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseTerms" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseServices" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseDocuments" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommercialLicenseContacts" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackPlayerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrackAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackAttachments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTrack" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackPlayerFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTermFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicenseTerm" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "territories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "included" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "finalTracks" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "campaignName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTracks" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "artist" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackAttachments" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseTerms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeRemaining" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CommercialLicenseTermFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseServices" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "serviceType" } },
                { kind: "Field", name: { kind: "Name", value: "musicType" } },
                { kind: "Field", name: { kind: "Name", value: "cost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyCode" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseDocuments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "uploadDate" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommercialLicenseContacts" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommercialLicense" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectLeads" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalContacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewCommercialLicenseQuery,
  ViewCommercialLicenseQueryVariables
>;
export const ViewLibraryLicenseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewLibraryLicense" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryLicense" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "trackId" } },
                { kind: "Field", name: { kind: "Name", value: "trackTitle" } },
                { kind: "Field", name: { kind: "Name", value: "trackArtist" } },
                { kind: "Field", name: { kind: "Name", value: "orgId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaredByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaredDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "goLiveDate" } },
                { kind: "Field", name: { kind: "Name", value: "projectName" } },
                { kind: "Field", name: { kind: "Name", value: "regions" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "channels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usageLinks" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessBrand" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewLibraryLicenseQuery,
  ViewLibraryLicenseQueryVariables
>;
export const MsaLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MsaLayout" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyMsaProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "monetizationPreference" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentSelection" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MsaLayoutQuery, MsaLayoutQueryVariables>;
export const MsaLayoutUpdateStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MsaLayoutUpdateStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MsaProfileStatusUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMsaProfileStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MsaLayoutUpdateStatusMutation,
  MsaLayoutUpdateStatusMutationVariables
>;
export const MsaDashboardCreateDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MsaDashboardCreateDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MsaDocumentCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMsaDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MsaDashboardCreateDocumentMutation,
  MsaDashboardCreateDocumentMutationVariables
>;
export const CatalogUpdateMsaProfileDocumentSelectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CatalogUpdateMsaProfileDocumentSelection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MsaProfileDocumentSelectionUpdateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMsaProfileDocumentSelection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentSelection" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CatalogUpdateMsaProfileDocumentSelectionMutation,
  CatalogUpdateMsaProfileDocumentSelectionMutationVariables
>;
export const MonetizationSelectionUpdatePreferenceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MonetizationSelectionUpdatePreference" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MsaProfileMonetizationPrefUpdateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMsaProfileMonetizationPref" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "monetizationPreference" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MonetizationSelectionUpdatePreferenceMutation,
  MonetizationSelectionUpdatePreferenceMutationVariables
>;
export const SurveyDeclineAddSurveyLogEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SurveyDeclineAddSurveyLogEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MsaSurveyLogEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addMsaSurveyLogEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SurveyDeclineAddSurveyLogEntryMutation,
  SurveyDeclineAddSurveyLogEntryMutationVariables
>;
export const SignedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Signed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMsaDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SignedQuery, SignedQueryVariables>;
export const MsaContextLogActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MsaContextLogAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MsaLogEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addMsaLogEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MsaContextLogActionMutation,
  MsaContextLogActionMutationVariables
>;
export const DownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Download" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DownloadType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "source" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserActionLogSource" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sourceId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "track" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "source" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "source" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sourceId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sourceId" },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadQuery, DownloadQueryVariables>;
export const LikeAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LikeAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LikeItemsType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLikes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemIds" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "Variable",
                      name: { kind: "Name", value: "itemId" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LikeAddMutation, LikeAddMutationVariables>;
export const LikeDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LikeDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LikeItemsType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLikes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemIds" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "Variable",
                      name: { kind: "Name", value: "itemId" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LikeDeleteMutation, LikeDeleteMutationVariables>;
export const AddTracksToPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddTracksToPlaylists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "playlistIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addTracksToPlaylists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "trackIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "trackIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "playlistIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "playlistIds" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddTracksToPlaylistsMutation,
  AddTracksToPlaylistsMutationVariables
>;
export const RemoveTracksFromPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveTracksFromPlaylists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "playlistIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeTracksFromPlaylists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "trackIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "trackIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "playlistIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "playlistIds" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveTracksFromPlaylistsMutation,
  RemoveTracksFromPlaylistsMutationVariables
>;
export const CreateShareTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateShareToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateShareTokenInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createShareToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateShareTokenMutation,
  CreateShareTokenMutationVariables
>;
export const BulkDownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkDownload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "referenceIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "referenceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BulkDownloadReferenceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "referenceFormat" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BulkDownloadReferenceFormat" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "source" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserActionLogSource" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sourceId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bulkDownload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "referenceIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "referenceIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "referenceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "referenceType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "referenceFormat" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "referenceFormat" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "source" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "source" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sourceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sourceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkDownloadMutation,
  BulkDownloadMutationVariables
>;
export const BulkLikeStateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BulkLikeState" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userMeta" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "liked" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkLikeStateQuery, BulkLikeStateQueryVariables>;
export const BulkLikeAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkLikeAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LikeItemsType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLikes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkLikeAddMutation, BulkLikeAddMutationVariables>;
export const BulkLikeDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkLikeDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LikeItemsType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLikes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkLikeDeleteMutation,
  BulkLikeDeleteMutationVariables
>;
export const ReorderPlaylistTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReorderPlaylistTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reorderPlaylistTracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "trackIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "trackIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "trackIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReorderPlaylistTracksMutation,
  ReorderPlaylistTracksMutationVariables
>;
export const MoveBulkButtonPlaylistOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MoveBulkButtonPlaylistOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackIds" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveBulkButtonPlaylistOrderQuery,
  MoveBulkButtonPlaylistOrderQueryVariables
>;
export const UpsertPlaylistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpsertPlaylist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "description" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "imageS3Key" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shareable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upsertPlaylist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "description" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "trackIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "trackIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "imageS3Key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "imageS3Key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "shareable" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shareable" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "size" },
                      value: {
                        kind: "StringValue",
                        value: "large",
                        block: false,
                      },
                    },
                  ],
                },
                { kind: "Field", name: { kind: "Name", value: "shareable" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertPlaylistMutation,
  UpsertPlaylistMutationVariables
>;
export const TrackPreview_TaggramsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrackPreview_Taggrams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "track" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "taggrams" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "intensity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackPreview_TaggramsQuery,
  TrackPreview_TaggramsQueryVariables
>;
export const AudioContextUserPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AudioContextUserPlaylists" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "size" },
                            value: {
                              kind: "StringValue",
                              value: "large",
                              block: false,
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shareable" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "team" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "size" },
                            value: {
                              kind: "StringValue",
                              value: "large",
                              block: false,
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shareable" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AudioContextUserPlaylistsQuery,
  AudioContextUserPlaylistsQueryVariables
>;
export const AudioContextTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AudioContextTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AudioContextTracksQuery,
  AudioContextTracksQueryVariables
>;
export const AudioContextTrackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AudioContextTrack" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "track" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AudioContextTrackQuery,
  AudioContextTrackQueryVariables
>;
export const DeactivateChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeactivateChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateChannels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateChannelsMutation,
  DeactivateChannelsMutationVariables
>;
export const AddChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AddChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ChannelLookupInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "prepared" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "input" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "input" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "PreparedChannel" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "channelTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "handle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duplicate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ChannelLookupError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddChannelsQuery, AddChannelsQueryVariables>;
export const ConnectChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConnectChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ConnectChannelInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "connectChannels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
                { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConnectChannelsMutation,
  ConnectChannelsMutationVariables
>;
export const AddCollections_CreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCollections_Create" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channelIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "channelIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "channelIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfChannels" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddCollections_CreateMutation,
  AddCollections_CreateMutationVariables
>;
export const CollectionChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CollectionChannels" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "all" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfChannels" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "channelIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CollectionChannelsQuery,
  CollectionChannelsQueryVariables
>;
export const AddChannelsToCollectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddChannelsToCollections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channelIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addChannelsToCollections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "channelIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "channelIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfChannels" },
                },
                { kind: "Field", name: { kind: "Name", value: "channelIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddChannelsToCollectionsMutation,
  AddChannelsToCollectionsMutationVariables
>;
export const RemoveChannelsFromCollectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveChannelsFromCollections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channelIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeChannelsFromCollections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "channelIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "channelIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfChannels" },
                },
                { kind: "Field", name: { kind: "Name", value: "channelIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveChannelsFromCollectionsMutation,
  RemoveChannelsFromCollectionsMutationVariables
>;
export const ChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Channels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChannelsSort" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "platforms" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ChannelPlatform" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "connected" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "platforms" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "platforms" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "handle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelsQuery, ChannelsQueryVariables>;
export const ChannelsExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ChannelsExport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChannelsSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "connected" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "handle" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelsExportQuery, ChannelsExportQueryVariables>;
export const SelectedChannelsExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SelectedChannelsExport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byIds" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platform" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "handle" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelectedChannelsExportQuery,
  SelectedChannelsExportQueryVariables
>;
export const CollectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Collections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "platforms" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ChannelPlatform" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "all" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "platforms" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "platforms" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfChannels" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "channels" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "platform",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionsQuery, CollectionsQueryVariables>;
export const DeleteCollectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCollections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCollections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCollectionsMutation,
  DeleteCollectionsMutationVariables
>;
export const DownloadCollectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadCollections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byIds" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "channels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadCollectionsQuery,
  DownloadCollectionsQueryVariables
>;
export const DuplicateCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DuplicateCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "duplicateCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateCollectionMutation,
  DuplicateCollectionMutationVariables
>;
export const RenameCollectionPanelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RenameCollectionPanel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RenameCollectionPanelQuery,
  RenameCollectionPanelQueryVariables
>;
export const RenameCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RenameCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "renameCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RenameCollectionMutation,
  RenameCollectionMutationVariables
>;
export const ViewCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChannelsSort" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "platforms" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ChannelPlatform" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "channels" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "query" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "query" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "sortBy" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "sortBy" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limit" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "offset" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "offset" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "platforms" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "platforms" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "platform" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "imageUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "handle" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewCollectionQuery, ViewCollectionQueryVariables>;
export const DeactivatedChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DeactivatedChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChannelsSort" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "platforms" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ChannelPlatform" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deactivated" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "platforms" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "platforms" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "handle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "changeDate" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivatedChannelsQuery,
  DeactivatedChannelsQueryVariables
>;
export const ReactivateChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReactivateChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reactivateChannels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReactivateChannelsMutation,
  ReactivateChannelsMutationVariables
>;
export const ViewChannelInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewChannelInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ChannelHeading" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ViewChannelInfoBody" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChannelHeading" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Channel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "platform" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewChannelInfoBody" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Channel" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "platform" } },
          { kind: "Field", name: { kind: "Name", value: "handle" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "createDate" } },
          { kind: "Field", name: { kind: "Name", value: "changeDate" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userSub" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewChannelInfoQuery,
  ViewChannelInfoQueryVariables
>;
export const ArtistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Artist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "artist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stats" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "segmentTracksCount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ArtistHeader" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limit" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrackList" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "segmentTracksCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "albumsCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mostCommonGenre" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArtistQuery, ArtistQueryVariables>;
export const CuratedPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CuratedPlaylists" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "curated" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CuratedPlaylistsQuery,
  CuratedPlaylistsQueryVariables
>;
export const CuratedPlaylistGalleryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CuratedPlaylistGallery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "all" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "curated" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "results" },
                        name: { kind: "Name", value: "all" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "include" },
                            arguments: [
                              {
                                kind: "Argument",
                                name: { kind: "Name", value: "if" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "all" },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "PlaylistGallery" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "total" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "include" },
                            arguments: [
                              {
                                kind: "Argument",
                                name: { kind: "Name", value: "if" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "all" },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "byCategorySlug" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "slug" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "skip" },
                            arguments: [
                              {
                                kind: "Argument",
                                name: { kind: "Name", value: "if" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "all" },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "results" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "PlaylistGallery",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CuratedPlaylistGalleryQuery,
  CuratedPlaylistGalleryQueryVariables
>;
export const ViewPlaylistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewPlaylist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistHeader" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistBulkActions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistHeaderActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "liked" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "segmentTracksCount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "hasCustomImage" } },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "shareable" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistHeaderActions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistBulkActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "isOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewPlaylistQuery, ViewPlaylistQueryVariables>;
export const PlaylistDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PlaylistDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePlaylist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaylistDeleteMutation,
  PlaylistDeleteMutationVariables
>;
export const PlaylistTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PlaylistTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "segmentTracksCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "sort" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "sort" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "query" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "query" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limit" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "offset" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "offset" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TrackList" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaylistTracksQuery, PlaylistTracksQueryVariables>;
export const SearchHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchHistory" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recentSearches" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "query" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "artists" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchHistoryQuery, SearchHistoryQueryVariables>;
export const SearchHistoryDeleteRecentSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SearchHistoryDeleteRecentSearch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRecentSearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchHistoryDeleteRecentSearchMutation,
  SearchHistoryDeleteRecentSearchMutationVariables
>;
export const SearchHistoryDeleteAllRecentSearchesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SearchHistoryDeleteAllRecentSearches" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAllRecentSearches" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchHistoryDeleteAllRecentSearchesMutation,
  SearchHistoryDeleteAllRecentSearchesMutationVariables
>;
export const BriefAnalysisDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BriefAnalysis" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brief" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "briefAnalysis" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "brief" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "brief" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BriefAnalysisQuery, BriefAnalysisQueryVariables>;
export const SearchLandingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchLanding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "curatedPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SearchLandingCurated" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recent" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trackPageSize" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchLandingCurated" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Query" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "curated" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "curatedPageSize" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "all" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "PlaylistGallery" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchLandingQuery, SearchLandingQueryVariables>;
export const SearchLandingFeaturedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchLandingFeatured" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "featured" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trackPageSize" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TrackList" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchLandingFeaturedQuery,
  SearchLandingFeaturedQueryVariables
>;
export const RecentlyPlayedTabDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RecentlyPlayedTab" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "artistPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "playlistPageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeTrackDetails" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeArtists" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includePlaylists" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recent" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trackPageSize" },
                      },
                    },
                  ],
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: {
                              kind: "Name",
                              value: "includeTrackDetails",
                            },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrackList" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeArtists" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recent" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "artistPageSize" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ArtistGallery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recent" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "playlistPageSize" },
                      },
                    },
                  ],
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "includePlaylists" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistGallery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArtistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ArtistGalleryTile" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecentlyPlayedTabQuery,
  RecentlyPlayedTabQueryVariables
>;
export const SearchSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SearchType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "SearchFilterInput" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "similarTrackId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "search" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "similarTrackId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "similarTrackId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "urlResult" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "artists" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "similarTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchSummaryQuery, SearchSummaryQueryVariables>;
export const SearchTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SearchType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SearchSortKey" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortDirection" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SearchSortDirection" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "similarTrackId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "SearchFilterInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "search" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tracks" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortDirection" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortDirection" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "similarTrackId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "similarTrackId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TrackList" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchTracksQuery, SearchTracksQueryVariables>;
export const TrackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Track" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "track" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Track" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackHeader" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackActions" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackDetails" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackHeaderTrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genres" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackHeaderTrackActions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackQuery, TrackQueryVariables>;
export const AudioVersionsRouteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AudioVersionsRoute" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioVersionItem_Track" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stems" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "modelId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioVersionItem_Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "normal" } },
              ],
            },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AudioVersionsRouteQuery,
  AudioVersionsRouteQueryVariables
>;
export const StemsCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StemsCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trackId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "modelId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createStems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "trackId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "trackId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "modelId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "modelId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "trackId" } },
                { kind: "Field", name: { kind: "Name", value: "modelId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StemsCreateMutation, StemsCreateMutationVariables>;
export const TrackDetailsRouteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrackDetailsRoute" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "track" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackDetailsAnalysis" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetailsAnalysis" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "analysis" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "characteristics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "genre" } },
                      { kind: "Field", name: { kind: "Name", value: "mood" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vocals" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tempo" } },
                      { kind: "Field", name: { kind: "Name", value: "bpm" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "decade" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useCasePredictions" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visuals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subGenres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "moods" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackDetailsRouteQuery,
  TrackDetailsRouteQueryVariables
>;
export const TrackSimilarRouteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrackSimilarRoute" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "similar" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "trackId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "15" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TrackList" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackSimilarRouteQuery,
  TrackSimilarRouteQueryVariables
>;
export const DownloadedTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadedTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DownloadsScope" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloaded" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "scope" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "scope" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sort" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrackList" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadedTracksQuery,
  DownloadedTracksQueryVariables
>;
export const DeclareSubmitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeclareSubmit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeclareTracksInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "declareTracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclareSubmitMutation,
  DeclareSubmitMutationVariables
>;
export const DeclareChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DeclareChannels" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "channels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "connected" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "handle" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "all" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "channelIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclareChannelsQuery,
  DeclareChannelsQueryVariables
>;
export const DeclareTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DeclareTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "artists" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "size" },
                            value: {
                              kind: "StringValue",
                              value: "large",
                              block: false,
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeclareTracksQuery, DeclareTracksQueryVariables>;
export const LikedTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LikedTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "liked" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sort" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrackList" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LikedTracksQuery, LikedTracksQueryVariables>;
export const UserPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserPlaylists" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistGallery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserPlaylistsQuery, UserPlaylistsQueryVariables>;
export const TeamPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TeamPlaylists" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "team" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistGallery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamPlaylistsQuery, TeamPlaylistsQueryVariables>;
export const LikedPlaylistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LikedPlaylists" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "liked" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PlaylistGallery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGalleryTile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AudioContextTrack" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlaylistGallery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Playlist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PlaylistGalleryTile" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LikedPlaylistsQuery, LikedPlaylistsQueryVariables>;
export const RecentTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RecentTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tracks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recent" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sort" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "query" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "query" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrackList" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "Track" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TrackActions" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AudioContextTrack" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecentTracksQuery, RecentTracksQueryVariables>;
export const SharedArtistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedArtist" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "artist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shared" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trackIds" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SharedArtistHeader",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SharedArtistHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Artist" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "trackIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "albumsCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mostCommonGenre" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SharedArtistQuery, SharedArtistQueryVariables>;
export const SharedArtistTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedArtistTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "artist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shared" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limit" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "offset" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "offset" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Track" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AudioContextTrack",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SharedArtistTracksQuery,
  SharedArtistTracksQueryVariables
>;
export const SharedPlaylistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedPlaylist" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shared" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "size" },
                                  value: {
                                    kind: "StringValue",
                                    value: "large",
                                    block: false,
                                  },
                                },
                              ],
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdBy" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SharedPlaylistQuery, SharedPlaylistQueryVariables>;
export const SharedPlaylistTracksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedPlaylistTracks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "playlist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shared" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tracks" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "limit" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "offset" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "offset" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Track" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AudioContextTrack",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Track" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SharedPlaylistTracksQuery,
  SharedPlaylistTracksQueryVariables
>;
export const SharedTrackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedTrack" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "track" },
            name: { kind: "Name", value: "sharedTrack" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "size" },
                      value: {
                        kind: "StringValue",
                        value: "large",
                        block: false,
                      },
                    },
                  ],
                },
                { kind: "Field", name: { kind: "Name", value: "genres" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "artists" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackDetails" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AudioContextTrack" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AudioContextTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "size" },
                value: { kind: "StringValue", value: "large", block: false },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "release" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "artists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "audioUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "low" } },
                { kind: "Field", name: { kind: "Name", value: "normal" } },
                { kind: "Field", name: { kind: "Name", value: "high" } },
                { kind: "Field", name: { kind: "Name", value: "veryHigh" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "traits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "youtubeSafe" } },
                { kind: "Field", name: { kind: "Name", value: "explicit" } },
                { kind: "Field", name: { kind: "Name", value: "vocals" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "waveform" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "length" } },
                { kind: "Field", name: { kind: "Name", value: "data" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userMeta" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "liked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SharedTrackQuery, SharedTrackQueryVariables>;
export const SharedTrackDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SharedTrackDetails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "track" },
            name: { kind: "Name", value: "sharedTrack" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrackDetailsAnalysis" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrackDetailsAnalysis" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Track" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "analysis" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "characteristics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "genre" } },
                      { kind: "Field", name: { kind: "Name", value: "mood" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vocals" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tempo" } },
                      { kind: "Field", name: { kind: "Name", value: "bpm" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "decade" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useCasePredictions" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visuals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subGenres" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "moods" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ageAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genderAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAffinity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SharedTrackDetailsQuery,
  SharedTrackDetailsQueryVariables
>;
export const ValidateFilesInS3Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ValidateFilesInS3" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidateFilesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateFilesInS3" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                { kind: "Field", name: { kind: "Name", value: "exists" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateFilesInS3Mutation,
  ValidateFilesInS3MutationVariables
>;
export const StartIngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartIngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "licensorDpid" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startIngestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "licensorDpid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "licensorDpid" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartIngestionJobMutation,
  StartIngestionJobMutationVariables
>;
export const ExecuteCatalogUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ExecuteCatalogUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dromoUploadId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "executeCatalogUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dromoUploadId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dromoUploadId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExecuteCatalogUploadMutation,
  ExecuteCatalogUploadMutationVariables
>;
export const IngestionJobsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IngestionJobs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingestionJobs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "catalogUploadId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changeUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "orgId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dromoSessionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dromoImportId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dromoImportIdentifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "csvOriginalFilename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataRowCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensorDpid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngestionJobsQuery, IngestionJobsQueryVariables>;
export const IngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "catalogUploadId" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changeUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "orgId" } },
                { kind: "Field", name: { kind: "Name", value: "orgName" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mediaFiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadComplete" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoSessionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportIdentifier" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "csvOriginalFilename" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadataRowCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensorDpid" },
                },
                { kind: "Field", name: { kind: "Name", value: "jobName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngestionJobQuery, IngestionJobQueryVariables>;
export const CreateIngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateIngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "licensorDpid" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIngestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "licensorDpid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "licensorDpid" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "catalogUploadId" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changeUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "orgId" } },
                { kind: "Field", name: { kind: "Name", value: "orgName" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoSessionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportIdentifier" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "csvOriginalFilename" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadataRowCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensorDpid" },
                },
                { kind: "Field", name: { kind: "Name", value: "jobName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateIngestionJobMutation,
  CreateIngestionJobMutationVariables
>;
export const UpdateIngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateIngestionJobInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIngestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "catalogUploadId" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mediaFiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadComplete" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoSessionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dromoImportIdentifier" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "csvOriginalFilename" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadataRowCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensorDpid" },
                },
                { kind: "Field", name: { kind: "Name", value: "jobName" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIngestionJobMutation,
  UpdateIngestionJobMutationVariables
>;
export const DeleteIngestionJobMediaFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIngestionJobMediaFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mediaFileId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIngestionJobMediaFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "mediaFileId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "mediaFileId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mediaFiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadComplete" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIngestionJobMediaFileMutation,
  DeleteIngestionJobMediaFileMutationVariables
>;
export const CancelIngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelIngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelIngestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelIngestionJobMutation,
  CancelIngestionJobMutationVariables
>;
export const DeleteIngestionJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIngestionJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIngestionJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIngestionJobMutation,
  DeleteIngestionJobMutationVariables
>;
export const IngestionSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IngestionSettings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingestionSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dpid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IngestionSettingsQuery,
  IngestionSettingsQueryVariables
>;
export const UpdateIngestionSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIngestionSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dpid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIngestionSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dpid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dpid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dpid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIngestionSettingsMutation,
  UpdateIngestionSettingsMutationVariables
>;
export const CustomerSupportSubmitInquiryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerSupportSubmitInquiry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inquiry" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitInquiry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inquiry" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inquiry" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "category" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "category" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerSupportSubmitInquiryMutation,
  CustomerSupportSubmitInquiryMutationVariables
>;
export const NotificationsPanelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NotificationsPanel" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "unreadCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationsPanelQuery,
  NotificationsPanelQueryVariables
>;
export const NotificationsPanelListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NotificationsPanelList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "NotificationItem" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NotificationItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Notification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "avatar" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "dest" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationsPanelListQuery,
  NotificationsPanelListQueryVariables
>;
export const NotificationsPanelListFeedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "NotificationsPanelListFeed" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "newNotification" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationsPanelListFeedSubscription,
  NotificationsPanelListFeedSubscriptionVariables
>;
export const NotificationsPanelTabsClearUnreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "NotificationsPanelTabsClearUnread" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearUnreadNotifications" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationsPanelTabsClearUnreadMutation,
  NotificationsPanelTabsClearUnreadMutationVariables
>;
export const BulkDownloadLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BulkDownloadLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bulkDownload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "downloadUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkDownloadLinkQuery,
  BulkDownloadLinkQueryVariables
>;
export const NotificationItemMarkAsReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "NotificationItemMarkAsRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markNotificationAsRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationItemMarkAsReadMutation,
  NotificationItemMarkAsReadMutationVariables
>;
export const InviteAcceptAcceptDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteAcceptAccept" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptUserInviteToOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteAcceptAcceptMutation,
  InviteAcceptAcceptMutationVariables
>;
export const InviteCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InviteCreate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hidden" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InviteCreateQuery, InviteCreateQueryVariables>;
export const InviteCreateSendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteCreateSend" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invites" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "OrgUserInviteInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inviteUserToOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invites" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invites" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "requested" } },
                { kind: "Field", name: { kind: "Name", value: "skipped" } },
                { kind: "Field", name: { kind: "Name", value: "invalid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteCreateSendMutation,
  InviteCreateSendMutationVariables
>;
export const EmailsFieldLookupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EmailsFieldLookup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emails" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgUserInviteLookup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "emails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emails" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmailsFieldLookupQuery,
  EmailsFieldLookupQueryVariables
>;
export const OrgCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgCreateQuery, OrgCreateQueryVariables>;
export const OrgCreateCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgCreateCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrgInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgCreateCreateMutation,
  OrgCreateCreateMutationVariables
>;
export const OrgBrandingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgBranding" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "background" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgBrandingQuery, OrgBrandingQueryVariables>;
export const UpdateOrgAssetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrgAssets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "logo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "background" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrgAssets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "logo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "logo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "background" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "background" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgAssetsMutation,
  UpdateOrgAssetsMutationVariables
>;
export const CreateOrgAssetSignedUploadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateOrgAssetSignedUploadUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hash" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contentType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrgAssetSignedUploadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "hash" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hash" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contentType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contentType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrgAssetSignedUploadUrlMutation,
  CreateOrgAssetSignedUploadUrlMutationVariables
>;
export const OrgDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "parentOrgId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "analytics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heap" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountManager" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phone" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceEstimation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "publicCompany" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "marketSymbol" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "marketCap" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "numberOfEmployees",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "instagramFollowers",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tikTokFollowers" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "holdingOrgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "servicingOrgId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "servicingOrgEmail",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dealId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payouts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "billingEmail" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyRefId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "minimumPayoutCents",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "other" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hubSpotIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgDetailsQuery, OrgDetailsQueryVariables>;
export const UpdateOrgDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrgDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrgDetailsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrgDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgDetailsMutation,
  UpdateOrgDetailsMutationVariables
>;
export const OrgModulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgModules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "modules" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "modules" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "adaptiveMusic" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgModulesQuery, OrgModulesQueryVariables>;
export const UpdateOrgModulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrgModules" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrgModulesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrgModules" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgModulesMutation,
  UpdateOrgModulesMutationVariables
>;
export const OrgUsersActiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgUsersActive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "offset" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_RolesColumn" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_UpdateModal" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_OrgRoles" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_RolesColumn" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_UpdateModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_OrgRoles" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgUsersActiveQuery, OrgUsersActiveQueryVariables>;
export const OrgUsersActiveDeactivateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersActiveDeactivate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateUserInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersActiveDeactivateMutation,
  OrgUsersActiveDeactivateMutationVariables
>;
export const OrgUsersActiveUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersActiveUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserPermissionsInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersActiveUpdateMutation,
  OrgUsersActiveUpdateMutationVariables
>;
export const OrgUsersInactiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgUsersInactive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inactiveDate" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "offset" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_RolesColumn" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_UpdateModal" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_OrgRoles" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_RolesColumn" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_UpdateModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_OrgRoles" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInactiveQuery,
  OrgUsersInactiveQueryVariables
>;
export const OrgUsersInactiveRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInactiveRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeUserFromOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInactiveRemoveMutation,
  OrgUsersInactiveRemoveMutationVariables
>;
export const OrgUsersInactiveUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInactiveUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserPermissionsInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInactiveUpdateMutation,
  OrgUsersInactiveUpdateMutationVariables
>;
export const OrgUsersInactiveReactivateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInactiveReactivate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reactivateUserInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInactiveReactivateMutation,
  OrgUsersInactiveReactivateMutationVariables
>;
export const OrgUsersInvitedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgUsersInvited" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OrgUserInviteSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgUserInvites" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastSendDate" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "offset" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_UpdateModal" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_RolesColumn" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgUsers_OrgRoles" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_UpdateModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_RolesColumn" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgUsers_OrgRoles" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Org" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hidden" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInvitedQuery,
  OrgUsersInvitedQueryVariables
>;
export const OrgUsersInvitedResendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInvitedResend" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInvitedResendMutation,
  OrgUsersInvitedResendMutationVariables
>;
export const OrgUsersInvitedRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInvitedRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInvitedRemoveMutation,
  OrgUsersInvitedRemoveMutationVariables
>;
export const OrgUsersInvitedUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersInvitedUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersInvitedUpdateMutation,
  OrgUsersInvitedUpdateMutationVariables
>;
export const OrgsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Orgs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OrgsSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orgs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "offset" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgsQuery, OrgsQueryVariables>;
export const OrgUsersDeactivateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersDeactivate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateUserInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersDeactivateMutation,
  OrgUsersDeactivateMutationVariables
>;
export const OrgUsersReactivateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersReactivate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reactivateUserInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersReactivateMutation,
  OrgUsersReactivateMutationVariables
>;
export const OrgUsersRemoveInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersRemoveInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersRemoveInviteMutation,
  OrgUsersRemoveInviteMutationVariables
>;
export const OrgUsersRemoveOrgUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersRemoveOrgUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeUserFromOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersRemoveOrgUserMutation,
  OrgUsersRemoveOrgUserMutationVariables
>;
export const OrgUsersResendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersResend" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersResendMutation,
  OrgUsersResendMutationVariables
>;
export const OrgUsersUpdateOrgUserInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersUpdateOrgUserInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrgUserInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersUpdateOrgUserInviteMutation,
  OrgUsersUpdateOrgUserInviteMutationVariables
>;
export const OrgUsersUpdateOrgUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgUsersUpdateOrgUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserPermissionsInOrg" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissions" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgUsersUpdateOrgUserMutation,
  OrgUsersUpdateOrgUserMutationVariables
>;
export const OrgPayoutsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgPayouts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payouts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgPayoutsQuery, OrgPayoutsQueryVariables>;
export const PayoutAdministrationEligibleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationEligible" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trolleyStatuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "PayoutTrolleyStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PayoutEligibleSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eligible" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "trolleyStatuses" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trolleyStatuses" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "id" },
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "marketplaceUserId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "balanceCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "legacyCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statementCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "adjustmentCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "itemCount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "minimumPayoutCents",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commentCount" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationEligibleQuery,
  PayoutAdministrationEligibleQueryVariables
>;
export const PayoutAdministrationEligibleExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationEligibleExport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trolleyStatuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "PayoutTrolleyStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PayoutEligibleSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eligible" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "trolleyStatuses" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trolleyStatuses" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "marketplaceUserId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "balance" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "legacy" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statements" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "adjustments" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "itemCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "minimumPayout" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationEligibleExportQuery,
  PayoutAdministrationEligibleExportQueryVariables
>;
export const PayoutAdministrationEligibleSelectAllDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationEligibleSelectAll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "trolleyStatuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "PayoutTrolleyStatus" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eligible" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "trolleyStatuses" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "trolleyStatuses" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "id" },
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "marketplaceUserId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "balanceCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "legacyCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statementCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "adjustmentCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "itemCount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "minimumPayoutCents",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commentCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationEligibleSelectAllQuery,
  PayoutAdministrationEligibleSelectAllQueryVariables
>;
export const PayoutAdministrationSyncRecipientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutAdministrationSyncRecipients" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "syncPayoutRecipients" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationSyncRecipientsMutation,
  PayoutAdministrationSyncRecipientsMutationVariables
>;
export const PayoutAdministrationCreateBatchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutAdministrationCreateBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orgIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPayoutBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orgIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orgIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationCreateBatchMutation,
  PayoutAdministrationCreateBatchMutationVariables
>;
export const PayoutAdministrationHeldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationHeld" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "held" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "id" },
                        name: { kind: "Name", value: "orgId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "orgId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "marketplaceUserId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balanceCents" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumPayoutCents" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trolleyStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commentCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heldAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationHeldQuery,
  PayoutAdministrationHeldQueryVariables
>;
export const PayoutAdministrationBatchesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationBatches" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batches" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastSyncedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createUser" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "userSub" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fullName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationBatchesQuery,
  PayoutAdministrationBatchesQueryVariables
>;
export const PayoutBatchViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutBatchView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trolleyBatchId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCents" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paymentCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastSyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preparedCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trolleyRequestedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changeDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userSub" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "skipped" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "id" },
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reason" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payouts" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "search" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "search" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amountCents" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paidAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "returned" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "returnedAt" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncing" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncProgress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "applied" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastSyncError" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issues" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "kind" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "releasable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payout" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "orgId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "orgName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "amountCents",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "trolleyStatus",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "returned" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchViewQuery,
  PayoutBatchViewQueryVariables
>;
export const PayoutBatchExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutBatchExport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payouts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyPaymentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trolleyStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paidAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchExportQuery,
  PayoutBatchExportQueryVariables
>;
export const PayoutBatchProgressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutBatchProgress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orgCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preparedCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trolleyRequestedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changeDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncing" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "syncProgress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "applied" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchProgressQuery,
  PayoutBatchProgressQueryVariables
>;
export const PayoutBatchSyncDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutBatchSync" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "syncPayoutBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "syncing" } },
                { kind: "Field", name: { kind: "Name", value: "syncTask" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchSyncMutation,
  PayoutBatchSyncMutationVariables
>;
export const PayoutBatchReleaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutBatchRelease" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payoutIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "releasePayouts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payoutIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payoutIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "syncing" } },
                { kind: "Field", name: { kind: "Name", value: "syncTask" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchReleaseMutation,
  PayoutBatchReleaseMutationVariables
>;
export const PayoutBatchMarkPaidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutBatchMarkPaid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payoutId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markPayoutPaid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payoutId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payoutId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "syncing" } },
                { kind: "Field", name: { kind: "Name", value: "syncTask" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchMarkPaidMutation,
  PayoutBatchMarkPaidMutationVariables
>;
export const PayoutBatchDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutBatchDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePayoutBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "syncing" } },
                { kind: "Field", name: { kind: "Name", value: "syncTask" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutBatchDeleteMutation,
  PayoutBatchDeleteMutationVariables
>;
export const PayoutAdministrationSetHoldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutAdministrationSetHold" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orgId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onHold" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setPayoutHold" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orgId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orgId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "onHold" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "onHold" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationSetHoldMutation,
  PayoutAdministrationSetHoldMutationVariables
>;
export const PayoutAdministrationCommentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PayoutAdministrationComments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orgId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payouts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orgId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orgId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userSub" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationCommentsQuery,
  PayoutAdministrationCommentsQueryVariables
>;
export const PayoutAdministrationAddCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PayoutAdministrationAddComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orgId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "body" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addPayoutComment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orgId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orgId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "body" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "body" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayoutAdministrationAddCommentMutation,
  PayoutAdministrationAddCommentMutationVariables
>;
export const ReportDefinitionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReportDefinition" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "report" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parameters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "required" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "helpText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultValue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportDefinitionQuery,
  ReportDefinitionQueryVariables
>;
export const ReportRunDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReportRun" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "parameters" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ReportParameterValueInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "runReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parameters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "parameters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "rows" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportRunQuery, ReportRunQueryVariables>;
export const ReportExportRowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReportExportRows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "key" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "parameters" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ReportParameterValueInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "key" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "key" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parameters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "parameters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportExportRowsQuery,
  ReportExportRowsQueryVariables
>;
export const ReportsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReportsList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parameters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListQuery, ReportsListQueryVariables>;
export const ResourcesTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ResourcesTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ResourceSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updated" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourcesTableQuery, ResourcesTableQueryVariables>;
export const ViewResourceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceHeader" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columns" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ResourceVideo" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ResourceDocument" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ResourceIframe" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceCustomText",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceTextSection",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "musicPlayerTracks",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ResourceTrack",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceVideo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "video" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "document" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "uploadDate" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isDownloadable" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceIframe" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "iframe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceCustomText" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customTextSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "width" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "portableText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_type" } },
                      { kind: "Field", name: { kind: "Name", value: "_key" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "marks" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_key" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "style" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listItem" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTextSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceColumns" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "textSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTrack" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceMusicPlayerTracksItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "isDownloadable" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewResourceQuery, ViewResourceQueryVariables>;
export const AuthRedirectProbeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuthRedirectProbe" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthRedirectProbeQuery,
  AuthRedirectProbeQueryVariables
>;
export const UserLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserLayout" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "picture" } },
                { kind: "Field", name: { kind: "Name", value: "orgId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inOrgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentOrgId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isImInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "isIm" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disclaimer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmLabel" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "labApps" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manageUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentOrgId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspace" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loginMethods" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "analytics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heap" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "background" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserLayoutQuery, UserLayoutQueryVariables>;
export const ThankYouDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ThankYou" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SignatureDocumentQueryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pdfBase64" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentDisplay" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WelcomeDialog" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentDisplay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "pdfBase64" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WelcomeDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "hideWelcomeDialog" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ThankYouQuery, ThankYouQueryVariables>;
export const ViewDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SignatureDocumentQueryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signatories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatoryId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentDisplay" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WelcomeDialog" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ConfirmDialog" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SignatureDialog" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DeclineDialog" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentDisplay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "pdfBase64" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WelcomeDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "hideWelcomeDialog" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConfirmDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "userConfirmData" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SignatureDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "sessionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeclineDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SignatureDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "templateKey" } },
          { kind: "Field", name: { kind: "Name", value: "sessionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewDocumentQuery, ViewDocumentQueryVariables>;
export const ViewDocumentFeedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "ViewDocumentFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "signatoryId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "documentUpdated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "signatoryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "signatoryId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewDocumentFeedSubscription,
  ViewDocumentFeedSubscriptionVariables
>;
export const ConfirmDialogSubmitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmDialogSubmit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SignatureDocumentSignatoryUpdateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSignatory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "signatoryId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmDialogSubmitMutation,
  ConfirmDialogSubmitMutationVariables
>;
export const DeclineDialogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DeclineDialog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "templateKey" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureDocumentTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateKey" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "templateKey" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declineReasons" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reasonKey" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reasonText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeclineDialogQuery, DeclineDialogQueryVariables>;
export const DeclineDialogSubmitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeclineDialogSubmit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SignatureDocumentDeclineInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "declineSignatureDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declineRedirectUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclineDialogSubmitMutation,
  DeclineDialogSubmitMutationVariables
>;
export const SignatureDialogFeedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "SignatureDialogFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sessionId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sessionUpdated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sessionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "event" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SignatureDialogFeedSubscription,
  SignatureDialogFeedSubscriptionVariables
>;
export const SignatureDialogSubmitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SignatureDialogSubmit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SignatureDocumentSignInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signSignatureDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successRedirectUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SignatureDialogSubmitMutation,
  SignatureDialogSubmitMutationVariables
>;
export const AddClientAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddClientAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addClient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddClientAddMutation,
  AddClientAddMutationVariables
>;
export const YoutubeChannelCanonicalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "YoutubeChannelCanonical" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "youtubeChannel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "url" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "canonical" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  YoutubeChannelCanonicalQuery,
  YoutubeChannelCanonicalQueryVariables
>;
export const CreateClearanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateClearance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ClearanceCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createClearance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClearanceMutation,
  CreateClearanceMutationVariables
>;
export const EditClearanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EditClearance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platform" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditClearanceQuery, EditClearanceQueryVariables>;
export const EditClearanceEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditClearanceEdit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ClearanceUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClearance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditClearanceEditMutation,
  EditClearanceEditMutationVariables
>;
export const EditClearanceExpireDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditClearanceExpire" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "expireClearance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditClearanceExpireMutation,
  EditClearanceExpireMutationVariables
>;
export const ClearancesTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClearancesTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClearanceMediaType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "platform" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClearanceMediaPlatform" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClearanceStatus" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClearanceSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "platform" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "platform" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearancesTableQuery,
  ClearancesTableQueryVariables
>;
export const ClientsTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClientsTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ClientSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contact" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientsTableQuery, ClientsTableQueryVariables>;
export const UpdateClientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UpdateClient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "contact" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClientQuery, UpdateClientQueryVariables>;
export const UpdateClientUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateClientUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateClientUpdateMutation,
  UpdateClientUpdateMutationVariables
>;
export const ViewClearanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewClearance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platform" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewClearanceQuery, ViewClearanceQueryVariables>;
export const ViewClientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewClient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClientHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "contact" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewClientQuery, ViewClientQueryVariables>;
export const ClientClearancesTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClientClearancesTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ClearanceSort" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platform" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientClearancesTableQuery,
  ClientClearancesTableQueryVariables
>;
export const ClientFieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClientField" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientFieldQuery, ClientFieldQueryVariables>;
export const TiktokProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TiktokProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tikTokOembed" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "url" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "html" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TiktokProfileQuery, TiktokProfileQueryVariables>;
export const YoutubeChannelPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "YoutubeChannelPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "youtubeChannel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "url" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "image" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  YoutubeChannelPreviewQuery,
  YoutubeChannelPreviewQueryVariables
>;
export const StatementImportBatchViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementImportBatchView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "format" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isStale" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "periodIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "warnings" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "skippedRows" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rowNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "beneficiaryCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totals" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rowCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "matchedCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unmatchedCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zeroBalanceCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "generateCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "generateAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statementCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paidCount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userSub" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportBatchViewQuery,
  StatementImportBatchViewQueryVariables
>;
export const StatementImportSetIncludedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportSetIncluded" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dataIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "included" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportSetIncluded" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dataIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dataIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "included" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "included" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportSetIncludedMutation,
  StatementImportSetIncludedMutationVariables
>;
export const StatementImportSetAllIncludedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportSetAllIncluded" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "included" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ImportDataStatus" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportSetAllIncluded" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "included" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "included" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportSetAllIncludedMutation,
  StatementImportSetAllIncludedMutationVariables
>;
export const StatementImportGenerateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportGenerate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportGenerateStatements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generateCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generateAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportGenerateMutation,
  StatementImportGenerateMutationVariables
>;
export const StatementImportPayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportPay" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dataIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportPay" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dataIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dataIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generateCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generateAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportPayMutation,
  StatementImportPayMutationVariables
>;
export const StatementImportCancelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportCancel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportCancelBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportCancelMutation,
  StatementImportCancelMutationVariables
>;
export const StatementImportDataTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementImportDataTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ImportDataStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StatementImportDataSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "batchId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "batchId" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "statuses" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "sortBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "sortBy" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "beneficiaryCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalUserId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "periodId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "statementReference",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "matchedOrgId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "emailAddress" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "included" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statementId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "batchId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "generateCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "generateAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statementCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paidCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportDataTableQuery,
  StatementImportDataTableQueryVariables
>;
export const StatementImportsTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementImportsTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImports" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batches" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "format" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "periodIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totals" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rowCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "matchedCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unmatchedCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zeroBalanceCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userSub" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportsTableQuery,
  StatementImportsTableQueryVariables
>;
export const StatementImportCreateBatchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportCreateBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StatementImportCreateBatchInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportCreateBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportCreateBatchMutation,
  StatementImportCreateBatchMutationVariables
>;
export const StatementImportDeleteBatchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementImportDeleteBatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statementImportDeleteBatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "batchId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementImportDeleteBatchMutation,
  StatementImportDeleteBatchMutationVariables
>;
export const StatementsTableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementsTable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "years" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "months" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "service" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "StatementPaymentStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StatementSort" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "years" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "years" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "months" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "months" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "service" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "service" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issued" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "netRevenue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "report" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sourceUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statementYears" } },
          { kind: "Field", name: { kind: "Name", value: "statementServices" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statementPaymentStatuses" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementsTableQuery,
  StatementsTableQueryVariables
>;
export const StatementsExportButtonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementsExportButton" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "period" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issued" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "service" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "netRevenue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementsExportButtonQuery,
  StatementsExportButtonQueryVariables
>;
export const StatementsBalanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StatementsBalance" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payoutBalance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balanceCents" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pendingPayoutCents" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumPayoutCents" },
                },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payoutSetupComplete" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementsBalanceQuery,
  StatementsBalanceQueryVariables
>;
export const StatementsUpdatePayoutMinimumDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StatementsUpdatePayoutMinimum" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "minimumPayoutCents" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePayoutMinimum" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "minimumPayoutCents" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "minimumPayoutCents" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumPayoutCents" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatementsUpdatePayoutMinimumMutation,
  StatementsUpdatePayoutMinimumMutationVariables
>;
export const ViewStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statementId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statementId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                { kind: "Field", name: { kind: "Name", value: "service" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatementHeader" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatementParticulars" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatementDetails" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "service" } },
          { kind: "Field", name: { kind: "Name", value: "orgId" } },
          { kind: "Field", name: { kind: "Name", value: "orgName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "report" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sourceUrl" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementParticulars" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "service" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "issued" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "information" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatementDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Statement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewStatementQuery, ViewStatementQueryVariables>;
export const DownloadStatementButtonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadStatementButton" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "statement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "file" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "temporaryUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadStatementButtonQuery,
  DownloadStatementButtonQueryVariables
>;
